var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgControlRoom = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 834,
  height: 606,
  viewBox: "0 0 834 606",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__control-room"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-studio-room",
  className: "element-studio-room"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector 241",
  d: "M2 148.522L368.954 2L831.86 187.422V454.533L464.906 603L2 415.633V148.522Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector 242",
  d: "M368.305 13.6702L14.3184 155.654V408.502L368.305 266.518V13.6702Z",
  stroke: "#141941",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector 243",
  d: "M368.305 13.6702L819.541 194.553V447.402L368.305 266.518V13.6702Z",
  stroke: "#141941",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector 244",
  d: "M14.3185 408.502L465.555 589.385L819.542 447.401L368.306 266.518L14.3185 408.502Z",
  stroke: "#141941",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-studio-room-active",
  className: "element-studio-room-active"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector 241_2",
  d: "M2 149.522L368.954 3L831.86 188.422V455.533L464.906 604L2 416.633V149.522Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector 242_2",
  d: "M368.305 14.6702L14.3184 156.654V409.502L368.305 267.518V14.6702Z",
  stroke: "#6E32F0",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector 243_2",
  d: "M368.305 14.6702L819.541 195.553V448.402L368.305 267.518V14.6702Z",
  stroke: "#6E32F0",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector 244_2",
  d: "M14.3185 409.502L465.555 590.385L819.542 448.401L368.306 267.518L14.3185 409.502Z",
  stroke: "#6E32F0",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Shadow",
  opacity: 0.7,
  d: "M304.262 469.445L198.767 427.249L419.839 338.824L525.334 381.02L304.262 469.445Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Aku"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector",
  opacity: 0.7,
  d: "M803.65 248.662L751.555 227.867V181.036L803.65 201.831V248.662Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_2",
  opacity: 0.7,
  d: "M742.315 224.017L690.22 203.222V156.391L742.315 177.186V224.017Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_3",
  opacity: 0.7,
  d: "M680.981 199.295L628.886 178.501V131.67L680.981 152.464V199.295Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_4",
  opacity: 0.7,
  d: "M619.654 174.576L567.559 153.781V106.95L619.654 127.745V174.576Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_5",
  opacity: 0.7,
  d: "M558.32 149.855L506.225 129.061V82.2299L558.32 103.024V149.855Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_6",
  opacity: 0.7,
  d: "M496.986 125.135L444.891 104.34V57.5091L496.986 78.3036V125.135Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_7",
  opacity: 0.7,
  d: "M435.651 100.413L383.556 79.6185V32.7875L435.651 53.582V100.413Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_8",
  opacity: 0.7,
  d: "M803.65 308.078L751.555 287.284V240.453L803.65 261.247V308.078Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_9",
  opacity: 0.7,
  d: "M742.315 283.432L690.22 262.638V215.807L742.315 236.601V283.432Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_10",
  opacity: 0.7,
  d: "M680.981 258.713L628.886 237.919V191.088L680.981 211.882V258.713Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_11",
  opacity: 0.7,
  d: "M619.654 233.991L567.559 213.197V166.366L619.654 187.16V233.991Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_12",
  opacity: 0.7,
  d: "M558.32 209.272L506.225 188.478V141.647L558.32 162.441V209.272Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_13",
  opacity: 0.7,
  d: "M496.986 184.551L444.891 163.757V116.926L496.986 137.72V184.551Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_14",
  opacity: 0.7,
  d: "M435.651 159.83L383.556 139.035V92.2043L435.651 112.999V159.83Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_15",
  opacity: 0.7,
  d: "M803.65 367.494L751.555 346.699V299.868L803.65 320.663V367.494Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_16",
  opacity: 0.7,
  d: "M742.315 342.848L690.22 322.054V275.223L742.315 296.017V342.848Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_17",
  opacity: 0.7,
  d: "M680.981 318.129L628.886 297.334V250.503L680.981 271.298V318.129Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_18",
  opacity: 0.7,
  d: "M619.654 293.407L567.559 272.613V225.782L619.654 246.576V293.407Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_19",
  opacity: 0.7,
  d: "M558.32 268.687L506.225 247.893V201.062L558.32 221.856V268.687Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_20",
  opacity: 0.7,
  d: "M496.986 243.967L444.891 223.172V176.341L496.986 197.136V243.967Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_21",
  opacity: 0.7,
  d: "M435.651 219.245L383.556 198.451V151.62L435.651 172.414V219.245Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_22",
  opacity: 0.7,
  d: "M803.65 426.91L751.555 406.115V359.284L803.65 380.079V426.91Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_23",
  opacity: 0.7,
  d: "M742.315 402.264L690.22 381.469V334.638L742.315 355.433V402.264Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_24",
  opacity: 0.7,
  d: "M680.981 377.543L628.886 356.749V309.918L680.981 330.712V377.543Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_25",
  opacity: 0.7,
  d: "M619.654 352.823L567.559 332.028V285.197L619.654 305.992V352.823Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_26",
  opacity: 0.7,
  d: "M558.32 328.102L506.225 307.307V260.476L558.32 281.271V328.102Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_27",
  opacity: 0.7,
  d: "M496.986 303.382L444.891 282.587V235.756L496.986 256.551V303.382Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_28",
  opacity: 0.7,
  d: "M435.651 278.66L383.556 257.865V211.034L435.651 231.829V278.66Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_29",
  opacity: 0.7,
  d: "M29.2504 211.036L76.6846 192.503L76.6846 145.672L29.2504 164.205L29.2504 211.036Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_30",
  opacity: 0.7,
  d: "M85.0978 188.977L132.532 170.444V123.613L85.0978 142.146V188.977Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_31",
  opacity: 0.7,
  d: "M140.937 166.92L188.371 148.387V101.556L140.937 120.089V166.92Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_32",
  opacity: 0.7,
  d: "M196.785 144.863L244.219 126.33V79.499L196.785 98.0316V144.863Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_33",
  opacity: 0.7,
  d: "M252.631 122.805L300.065 104.273V57.4415L252.631 75.9741V122.805Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_34",
  opacity: 0.7,
  d: "M308.479 100.747L355.913 82.214V35.383L308.479 53.9156V100.747Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_35",
  opacity: 0.7,
  d: "M29.2504 270.453L76.6846 251.921L76.6846 205.09L29.2504 223.622L29.2504 270.453Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_36",
  opacity: 0.7,
  d: "M308.479 160.164L355.913 141.631V94.8005L308.479 113.333V160.164Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_37",
  opacity: 0.7,
  d: "M29.2504 329.869L76.6846 311.336L76.6846 264.505L29.2504 283.038L29.2504 329.869Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_38",
  opacity: 0.7,
  d: "M308.479 219.58L355.913 201.047V154.216L308.479 172.749V219.58Z",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__LED"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_39",
  d: "M108.481 196.78L102.42 194.331V303.319L108.481 305.768V196.78Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.5162,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_40",
  d: "M288.392 122.292L283.169 120.182L102.758 193.669L107.981 195.779L288.392 122.292Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.73656,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_41",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M108.482 196.517L289.2 122.729V232.362L108.482 306.149V196.517Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.35833,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_42",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.129 199.732L283.528 130.596V229.146L114.129 298.282V199.732Z",
  stroke: "#8496B9",
  strokeWidth: 0.509561,
  strokeMiterlimit: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "control-room_svg__Rectangle",
  opacity: 0.6,
  x: 113.395,
  y: 130.852,
  width: 169.936,
  height: 167.159,
  fill: "url(#control-room_svg__pattern0_7074_1985)"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-speakers-2",
  className: "element-speakers-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Sub"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_43",
  d: "M371.782 255.2L330.735 271.92V316.329L371.782 299.61V255.2Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.59163,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_44",
  d: "M371.77 255.199L344.052 244L303.006 260.72L330.724 271.919L371.77 255.199Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.25966,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_45",
  d: "M330.719 271.924L303.001 260.725V305.135L330.719 316.334V271.924Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.16908,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_46",
  d: "M351.243 299.954C358.496 296.999 364.376 288.256 364.376 280.425C364.376 272.593 358.496 268.64 351.243 271.594C343.991 274.548 338.111 283.292 338.111 291.123C338.111 298.954 343.991 302.908 351.243 299.954Z",
  stroke: "#8496B9",
  strokeWidth: 1.73273,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_47",
  d: "M349.065 292.031C352.952 290.448 356.103 285.762 356.103 281.566C356.103 277.369 352.952 275.25 349.065 276.833C345.178 278.416 342.028 283.102 342.028 287.299C342.028 291.496 345.178 293.615 349.065 292.031Z",
  stroke: "#8496B9",
  strokeWidth: 1.21247,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_48",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303 260.726L344.035 244.005L371.747 255.206V299.617L330.706 316.333L303 305.137V260.726Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_49",
  d: "M307.639 334.716C307.639 331.034 316.322 328.049 327.033 328.049C337.744 328.049 346.427 331.034 346.427 334.716C346.427 338.398 337.744 341.383 327.033 341.383C316.322 341.383 307.639 338.398 307.639 334.716Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_50"
}, /*#__PURE__*/React.createElement("path", {
  d: "M347.654 334.712H345.23C345.23 335.118 344.992 335.684 344.154 336.366C343.323 337.04 342.049 337.701 340.368 338.279C337.015 339.432 332.306 340.166 327.048 340.166V342.591C332.5 342.591 337.488 341.833 341.156 340.573C342.984 339.943 344.55 339.169 345.682 338.248C346.806 337.335 347.654 336.147 347.654 334.712ZM327.048 342.591V340.166C321.79 340.166 317.081 339.432 313.728 338.279C312.047 337.701 310.773 337.04 309.942 336.366C309.104 335.684 308.866 335.118 308.866 334.712H306.442C306.442 336.147 307.29 337.335 308.414 338.248C309.546 339.169 311.112 339.943 312.94 340.573C316.608 341.833 321.596 342.591 327.048 342.591ZM306.442 334.712H308.866C308.866 334.306 309.104 333.74 309.942 333.057C310.773 332.383 312.047 331.723 313.728 331.145C317.081 329.992 321.79 329.257 327.048 329.257V326.833C321.596 326.833 316.608 327.591 312.94 328.851C311.112 329.48 309.546 330.255 308.414 331.176C307.29 332.089 306.442 333.277 306.442 334.712ZM327.048 326.833V329.257C332.306 329.257 337.015 329.992 340.368 331.145C342.049 331.723 343.323 332.383 344.154 333.057C344.992 333.74 345.23 334.306 345.23 334.712H347.654C347.654 333.277 346.806 332.089 345.682 331.176C344.55 330.255 342.984 329.48 341.156 328.851C337.488 327.591 332.5 326.833 327.048 326.833Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M347.654 334.712H345.23M347.654 334.712C347.654 336.147 346.806 337.335 345.682 338.248C344.55 339.169 342.984 339.943 341.156 340.573C337.488 341.833 332.5 342.591 327.048 342.591M347.654 334.712C347.654 333.277 346.806 332.089 345.682 331.176C344.55 330.255 342.984 329.48 341.156 328.851C337.488 327.591 332.5 326.833 327.048 326.833M345.23 334.712C345.23 335.118 344.992 335.684 344.154 336.366C343.323 337.04 342.049 337.701 340.368 338.279C337.015 339.432 332.306 340.166 327.048 340.166M345.23 334.712C345.23 334.306 344.992 333.74 344.154 333.057C343.323 332.383 342.049 331.723 340.368 331.145C337.015 329.992 332.306 329.257 327.048 329.257M327.048 340.166V342.591M327.048 340.166C321.79 340.166 317.081 339.432 313.728 338.279C312.047 337.701 310.773 337.04 309.942 336.366C309.104 335.684 308.866 335.118 308.866 334.712M327.048 342.591C321.596 342.591 316.608 341.833 312.94 340.573C311.112 339.943 309.546 339.169 308.414 338.248C307.29 337.335 306.442 336.147 306.442 334.712M308.866 334.712H306.442M308.866 334.712C308.866 334.306 309.104 333.74 309.942 333.057C310.773 332.383 312.047 331.723 313.728 331.145C317.081 329.992 321.79 329.257 327.048 329.257M306.442 334.712C306.442 333.277 307.29 332.089 308.414 331.176C309.546 330.255 311.112 329.48 312.94 328.851C316.608 327.591 321.596 326.833 327.048 326.833M327.048 329.257V326.833",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_51",
  d: "M328.247 234.388H325.823V334.106H328.247V234.388Z",
  fill: "#8496B9",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__FR"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_52",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.723 235.638V266.892L317.135 269.491V238.23L340.723 235.638Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_53",
  d: "M340.715 235.633L336.135 228.721L312.542 231.319L317.122 238.232L340.715 235.633Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.57687,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_54",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M317.124 238.224V269.486L312.547 262.575V231.319L317.124 238.224Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.16799,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_55",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M312.547 231.319L336.12 228.72L340.722 235.632V266.889L317.128 269.488L312.547 262.576V231.319Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_56",
  d: "M329.238 263.578C332.596 263.152 335.318 260.393 335.318 257.417C335.318 254.441 332.596 252.374 329.238 252.8C325.88 253.227 323.158 255.985 323.158 258.961C323.158 261.937 325.88 264.004 329.238 263.578Z",
  stroke: "#8496B9",
  strokeWidth: 1.46407,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_57",
  d: "M329.243 247.387C330.929 247.173 332.296 245.788 332.296 244.293C332.296 242.798 330.929 241.76 329.243 241.974C327.556 242.188 326.189 243.573 326.189 245.068C326.189 246.563 327.556 247.601 329.243 247.387Z",
  stroke: "#8496B9",
  strokeWidth: 1.5,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_58",
  d: "M329.24 260.526C331.04 260.298 332.498 258.82 332.498 257.225C332.498 255.63 331.04 254.522 329.24 254.75C327.441 254.979 325.982 256.457 325.982 258.052C325.982 259.647 327.441 260.755 329.24 260.526Z",
  stroke: "#8496B9",
  strokeWidth: 1.02512,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Sub_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_59",
  d: "M146.879 344.418L105.832 361.138V405.547L146.879 388.827V344.418Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.59163,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_60",
  d: "M146.868 344.417L119.149 333.218L78.1028 349.937L105.821 361.136L146.868 344.417Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.25966,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_61",
  d: "M105.816 361.142L78.0981 349.943L78.0981 394.353L105.816 405.552L105.816 361.142Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.16908,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_62",
  d: "M126.341 389.171C133.593 386.217 139.473 377.474 139.473 369.642C139.473 361.811 133.593 357.857 126.341 360.812C119.088 363.766 113.208 372.509 113.208 380.341C113.208 388.172 119.088 392.126 126.341 389.171Z",
  stroke: "#8496B9",
  strokeWidth: 1.73273,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_63",
  d: "M124.162 381.249C128.049 379.666 131.2 374.98 131.2 370.783C131.2 366.586 128.049 364.468 124.162 366.051C120.276 367.634 117.125 372.32 117.125 376.517C117.125 380.714 120.276 382.832 124.162 381.249Z",
  stroke: "#8496B9",
  strokeWidth: 1.21247,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_64",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.0974 349.944L119.132 333.223L146.844 344.424V388.835L105.803 405.551L78.0974 394.355V349.944Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_65",
  d: "M219.934 356.454C219.934 352.772 228.618 349.788 239.329 349.788C250.04 349.788 258.723 352.772 258.723 356.454C258.723 360.136 250.04 363.121 239.329 363.121C228.618 363.121 219.934 360.136 219.934 356.454Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_66"
}, /*#__PURE__*/React.createElement("path", {
  d: "M259.95 356.45H257.526C257.526 356.856 257.288 357.422 256.449 358.105C255.619 358.779 254.345 359.439 252.664 360.018C249.311 361.17 244.602 361.905 239.344 361.905V364.329C244.796 364.329 249.784 363.572 253.452 362.311C255.28 361.682 256.846 360.907 257.978 359.986C259.101 359.073 259.95 357.885 259.95 356.45ZM239.344 364.329V361.905C234.085 361.905 229.376 361.17 226.024 360.018C224.342 359.439 223.068 358.779 222.238 358.105C221.399 357.422 221.162 356.856 221.162 356.45H218.737C218.737 357.885 219.586 359.073 220.71 359.986C221.842 360.907 223.408 361.682 225.236 362.311C228.904 363.572 233.891 364.329 239.344 364.329ZM218.737 356.45H221.162C221.162 356.044 221.399 355.478 222.238 354.796C223.068 354.122 224.342 353.461 226.024 352.883C229.376 351.73 234.085 350.996 239.344 350.996V348.571C233.891 348.571 228.904 349.329 225.236 350.59C223.408 351.219 221.842 351.993 220.71 352.914C219.586 353.827 218.737 355.015 218.737 356.45ZM239.344 348.571V350.996C244.602 350.996 249.311 351.73 252.664 352.883C254.345 353.461 255.619 354.122 256.449 354.796C257.288 355.478 257.526 356.044 257.526 356.45H259.95C259.95 355.015 259.101 353.827 257.978 352.914C256.846 351.993 255.28 351.219 253.452 350.59C249.784 349.329 244.796 348.571 239.344 348.571Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.95 356.45H257.526M259.95 356.45C259.95 357.885 259.101 359.073 257.978 359.986C256.846 360.907 255.28 361.682 253.452 362.311C249.784 363.572 244.796 364.329 239.344 364.329M259.95 356.45C259.95 355.015 259.101 353.827 257.978 352.914C256.846 351.993 255.28 351.219 253.452 350.59C249.784 349.329 244.796 348.571 239.344 348.571M257.526 356.45C257.526 356.856 257.288 357.422 256.449 358.105C255.619 358.779 254.345 359.439 252.664 360.018C249.311 361.17 244.602 361.905 239.344 361.905M257.526 356.45C257.526 356.044 257.288 355.478 256.449 354.796C255.619 354.122 254.345 353.461 252.664 352.883C249.311 351.73 244.602 350.996 239.344 350.996M239.344 361.905V364.329M239.344 361.905C234.085 361.905 229.376 361.17 226.024 360.018C224.342 359.439 223.068 358.779 222.238 358.105C221.399 357.422 221.162 356.856 221.162 356.45M239.344 364.329C233.891 364.329 228.904 363.572 225.236 362.311C223.408 361.682 221.842 360.907 220.71 359.986C219.586 359.073 218.737 357.885 218.737 356.45M221.162 356.45H218.737M221.162 356.45C221.162 356.044 221.399 355.478 222.238 354.796C223.068 354.122 224.342 353.461 226.024 352.883C229.376 351.73 234.085 350.996 239.344 350.996M218.737 356.45C218.737 355.015 219.586 353.827 220.71 352.914C221.842 351.993 223.408 351.219 225.236 350.59C228.904 349.329 233.891 348.571 239.344 348.571M239.344 350.996V348.571",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_67",
  d: "M240.544 256.126H238.119V355.844H240.544V256.126Z",
  fill: "#8496B9",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__FC"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_68",
  d: "M254.955 253.72L236.228 261.349V292.604L254.955 284.976V253.72Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_69",
  d: "M254.948 253.716L242.456 248.669L223.729 256.297L236.221 261.345L254.948 253.716Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.24322,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_70",
  d: "M236.212 261.35L223.72 256.303V287.561L236.212 292.608V261.35Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.16799,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_71",
  d: "M245.578 283.942C248.334 282.819 250.569 279.496 250.569 276.52C250.569 273.544 248.334 272.041 245.578 273.164C242.822 274.287 240.587 277.61 240.587 280.586C240.587 283.562 242.822 285.064 245.578 283.942Z",
  stroke: "#8496B9",
  strokeWidth: 1.73258,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_72",
  d: "M245.573 267.837C247 267.256 248.157 265.536 248.157 263.995C248.157 262.454 247 261.676 245.573 262.257C244.146 262.839 242.99 264.559 242.99 266.1C242.99 267.64 244.146 268.418 245.573 267.837Z",
  stroke: "#8496B9",
  strokeWidth: 1.5,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_73",
  d: "M244.752 280.934C246.229 280.333 247.427 278.552 247.427 276.957C247.427 275.362 246.229 274.557 244.752 275.159C243.275 275.76 242.078 277.541 242.078 279.136C242.078 280.731 243.275 281.536 244.752 280.934Z",
  stroke: "#8496B9",
  strokeWidth: 1.21249,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_74",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M223.726 256.306L242.473 248.675L254.965 253.724V284.98L236.205 292.607L223.726 287.562V256.306Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_75",
  d: "M166.784 392.124C166.784 388.442 175.467 385.457 186.178 385.457C196.889 385.457 205.573 388.442 205.573 392.124C205.573 395.806 196.889 398.791 186.178 398.791C175.467 398.791 166.784 395.806 166.784 392.124Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_76"
}, /*#__PURE__*/React.createElement("path", {
  d: "M206.8 392.12H204.375C204.375 392.526 204.138 393.092 203.299 393.774C202.469 394.448 201.195 395.109 199.514 395.687C196.161 396.84 191.452 397.574 186.193 397.574V399.998C191.646 399.998 196.634 399.241 200.301 397.98C202.129 397.351 203.695 396.577 204.828 395.655C205.951 394.743 206.8 393.555 206.8 392.12ZM186.193 399.998V397.574C180.935 397.574 176.226 396.84 172.873 395.687C171.192 395.109 169.918 394.448 169.088 393.774C168.249 393.092 168.011 392.526 168.011 392.12H165.587C165.587 393.555 166.436 394.743 167.559 395.655C168.691 396.577 170.258 397.351 172.085 397.98C175.753 399.241 180.741 399.998 186.193 399.998ZM165.587 392.12H168.011C168.011 391.714 168.249 391.147 169.088 390.465C169.918 389.791 171.192 389.13 172.873 388.552C176.226 387.4 180.935 386.665 186.193 386.665V384.241C180.741 384.241 175.753 384.998 172.085 386.259C170.258 386.888 168.691 387.663 167.559 388.584C166.436 389.497 165.587 390.684 165.587 392.12ZM186.193 384.241V386.665C191.452 386.665 196.161 387.4 199.514 388.552C201.195 389.13 202.469 389.791 203.299 390.465C204.138 391.147 204.375 391.714 204.375 392.12H206.8C206.8 390.684 205.951 389.497 204.828 388.584C203.695 387.663 202.129 386.888 200.301 386.259C196.634 384.998 191.646 384.241 186.193 384.241Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.8 392.12H204.375M206.8 392.12C206.8 393.555 205.951 394.743 204.828 395.655C203.695 396.577 202.129 397.351 200.301 397.98C196.634 399.241 191.646 399.998 186.193 399.998M206.8 392.12C206.8 390.684 205.951 389.497 204.828 388.584C203.695 387.663 202.129 386.888 200.301 386.259C196.634 384.998 191.646 384.241 186.193 384.241M204.375 392.12C204.375 392.526 204.138 393.092 203.299 393.774C202.469 394.448 201.195 395.109 199.514 395.687C196.161 396.84 191.452 397.574 186.193 397.574M204.375 392.12C204.375 391.714 204.138 391.147 203.299 390.465C202.469 389.791 201.195 389.13 199.514 388.552C196.161 387.4 191.452 386.665 186.193 386.665M186.193 397.574V399.998M186.193 397.574C180.935 397.574 176.226 396.84 172.873 395.687C171.192 395.109 169.918 394.448 169.088 393.774C168.249 393.092 168.011 392.526 168.011 392.12M186.193 399.998C180.741 399.998 175.753 399.241 172.085 397.98C170.258 397.351 168.691 396.577 167.559 395.655C166.436 394.743 165.587 393.555 165.587 392.12M168.011 392.12H165.587M168.011 392.12C168.011 391.714 168.249 391.147 169.088 390.465C169.918 389.791 171.192 389.13 172.873 388.552C176.226 387.4 180.935 386.665 186.193 386.665M165.587 392.12C165.587 390.684 166.436 389.497 167.559 388.584C168.691 387.663 170.258 386.888 172.085 386.259C175.753 384.998 180.741 384.241 186.193 384.241M186.193 386.665V384.241",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_77",
  d: "M187.393 291.796H184.969V391.514H187.393V291.796Z",
  fill: "#8496B9",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__FL"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_78",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M200.602 285.41V316.665L188.309 330.523V299.268L200.602 285.41Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_79",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M200.433 285L188.303 299L172.423 296.932L184.634 283.041L200.433 285Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.328894,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_80",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M188.303 299.261V330.517L171.885 328.807V297.551L188.303 299.261Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.16799,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_81",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.883 297.555L184.117 283.66L200.598 285.405V316.661L188.325 330.521L171.883 328.811V297.555Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_82",
  d: "M194.362 318.043C196.128 316.111 197.559 312.132 197.559 309.156C197.559 306.179 196.128 305.333 194.362 307.265C192.596 309.197 191.165 313.176 191.165 316.152C191.165 319.128 192.596 319.975 194.362 318.043Z",
  stroke: "#8496B9",
  strokeWidth: 1.58856,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_83",
  d: "M194.358 301.935C195.273 300.935 196.014 298.875 196.014 297.334C196.014 295.793 195.273 295.355 194.358 296.355C193.444 297.356 192.703 299.415 192.703 300.956C192.703 302.497 193.444 302.935 194.358 301.935Z",
  stroke: "#8496B9",
  strokeWidth: 1.5,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_84",
  d: "M193.275 315.272C194.221 314.236 194.989 312.104 194.989 310.509C194.989 308.914 194.221 308.46 193.275 309.496C192.329 310.531 191.562 312.664 191.562 314.259C191.562 315.853 192.329 316.307 193.275 315.272Z",
  stroke: "#8496B9",
  strokeWidth: 1.8035,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-speakers-2-active",
  className: "element-speakers-2-active"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Sub_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_85",
  d: "M371.782 255.2L330.735 271.92V316.329L371.782 299.61V255.2Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.59163,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_86",
  d: "M371.77 255.199L344.052 244L303.006 260.72L330.724 271.919L371.77 255.199Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.25966,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_87",
  d: "M330.719 271.924L303.001 260.725V305.135L330.719 316.334V271.924Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.16908,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_88",
  d: "M351.243 299.954C358.496 297 364.376 288.256 364.376 280.425C364.376 272.593 358.496 268.64 351.243 271.594C343.991 274.548 338.111 283.292 338.111 291.123C338.111 298.954 343.991 302.908 351.243 299.954Z",
  stroke: "#6E32F0",
  strokeWidth: 1.73273,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_89",
  d: "M349.065 292.031C352.952 290.448 356.103 285.763 356.103 281.566C356.103 277.369 352.952 275.25 349.065 276.833C345.178 278.416 342.028 283.102 342.028 287.299C342.028 291.496 345.178 293.615 349.065 292.031Z",
  stroke: "#6E32F0",
  strokeWidth: 1.21247,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_90",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303 260.726L344.035 244.005L371.747 255.206V299.617L330.706 316.333L303 305.137V260.726Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_91",
  d: "M307.639 334.716C307.639 331.034 316.322 328.049 327.033 328.049C337.744 328.049 346.427 331.034 346.427 334.716C346.427 338.398 337.744 341.383 327.033 341.383C316.322 341.383 307.639 338.398 307.639 334.716Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_92"
}, /*#__PURE__*/React.createElement("path", {
  d: "M347.654 334.712H345.23C345.23 335.118 344.992 335.684 344.154 336.367C343.323 337.041 342.049 337.701 340.368 338.279C337.015 339.432 332.306 340.167 327.048 340.167V342.591C332.5 342.591 337.488 341.833 341.156 340.573C342.984 339.944 344.55 339.169 345.682 338.248C346.806 337.335 347.654 336.147 347.654 334.712ZM327.048 342.591V340.167C321.79 340.167 317.081 339.432 313.728 338.279C312.047 337.701 310.773 337.041 309.942 336.367C309.104 335.684 308.866 335.118 308.866 334.712H306.442C306.442 336.147 307.29 337.335 308.414 338.248C309.546 339.169 311.112 339.944 312.94 340.573C316.608 341.833 321.596 342.591 327.048 342.591ZM306.442 334.712H308.866C308.866 334.306 309.104 333.74 309.942 333.057C310.773 332.383 312.047 331.723 313.728 331.145C317.081 329.992 321.79 329.257 327.048 329.257V326.833C321.596 326.833 316.608 327.591 312.94 328.851C311.112 329.48 309.546 330.255 308.414 331.176C307.29 332.089 306.442 333.277 306.442 334.712ZM327.048 326.833V329.257C332.306 329.257 337.015 329.992 340.368 331.145C342.049 331.723 343.323 332.383 344.154 333.057C344.992 333.74 345.23 334.306 345.23 334.712H347.654C347.654 333.277 346.806 332.089 345.682 331.176C344.55 330.255 342.984 329.48 341.156 328.851C337.488 327.591 332.5 326.833 327.048 326.833Z",
  fill: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M347.654 334.712H345.23M347.654 334.712C347.654 336.147 346.806 337.335 345.682 338.248C344.55 339.169 342.984 339.944 341.156 340.573C337.488 341.833 332.5 342.591 327.048 342.591M347.654 334.712C347.654 333.277 346.806 332.089 345.682 331.176C344.55 330.255 342.984 329.48 341.156 328.851C337.488 327.591 332.5 326.833 327.048 326.833M345.23 334.712C345.23 335.118 344.992 335.684 344.154 336.367C343.323 337.041 342.049 337.701 340.368 338.279C337.015 339.432 332.306 340.167 327.048 340.167M345.23 334.712C345.23 334.306 344.992 333.74 344.154 333.057C343.323 332.383 342.049 331.723 340.368 331.145C337.015 329.992 332.306 329.257 327.048 329.257M327.048 340.167V342.591M327.048 340.167C321.79 340.167 317.081 339.432 313.728 338.279C312.047 337.701 310.773 337.041 309.942 336.367C309.104 335.684 308.866 335.118 308.866 334.712M327.048 342.591C321.596 342.591 316.608 341.833 312.94 340.573C311.112 339.944 309.546 339.169 308.414 338.248C307.29 337.335 306.442 336.147 306.442 334.712M308.866 334.712H306.442M308.866 334.712C308.866 334.306 309.104 333.74 309.942 333.057C310.773 332.383 312.047 331.723 313.728 331.145C317.081 329.992 321.79 329.257 327.048 329.257M306.442 334.712C306.442 333.277 307.29 332.089 308.414 331.176C309.546 330.255 311.112 329.48 312.94 328.851C316.608 327.591 321.596 326.833 327.048 326.833M327.048 329.257V326.833",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_93",
  d: "M328.247 234.388H325.823V334.106H328.247V234.388Z",
  fill: "#6E32F0",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__FR_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_94",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.723 235.638V266.893L317.135 269.491V238.23L340.723 235.638Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_95",
  d: "M340.715 235.633L336.135 228.721L312.542 231.32L317.122 238.232L340.715 235.633Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.57687,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_96",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M317.124 238.224V269.486L312.547 262.575V231.32L317.124 238.224Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.16799,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_97",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M312.547 231.32L336.12 228.72L340.722 235.633V266.889L317.128 269.488L312.547 262.576V231.32Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_98",
  d: "M329.238 263.578C332.596 263.152 335.318 260.393 335.318 257.417C335.318 254.441 332.596 252.374 329.238 252.801C325.88 253.227 323.158 255.985 323.158 258.961C323.158 261.937 325.88 264.004 329.238 263.578Z",
  stroke: "#6E32F0",
  strokeWidth: 1.46407,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_99",
  d: "M329.243 247.387C330.929 247.173 332.296 245.788 332.296 244.293C332.296 242.798 330.929 241.76 329.243 241.974C327.556 242.188 326.189 243.574 326.189 245.068C326.189 246.563 327.556 247.602 329.243 247.387Z",
  stroke: "#6E32F0",
  strokeWidth: 1.5,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_100",
  d: "M329.24 260.526C331.04 260.298 332.498 258.82 332.498 257.225C332.498 255.63 331.04 254.522 329.24 254.751C327.441 254.979 325.982 256.457 325.982 258.052C325.982 259.647 327.441 260.755 329.24 260.526Z",
  stroke: "#6E32F0",
  strokeWidth: 1.02512,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Sub_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_101",
  d: "M146.879 344.418L105.832 361.138V405.547L146.879 388.827V344.418Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.59163,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_102",
  d: "M146.868 344.417L119.149 333.218L78.1028 349.938L105.821 361.136L146.868 344.417Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.25966,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_103",
  d: "M105.816 361.142L78.0981 349.943L78.0981 394.353L105.816 405.552L105.816 361.142Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.16908,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_104",
  d: "M126.341 389.172C133.593 386.217 139.473 377.474 139.473 369.642C139.473 361.811 133.593 357.857 126.341 360.812C119.088 363.766 113.208 372.509 113.208 380.341C113.208 388.172 119.088 392.126 126.341 389.172Z",
  stroke: "#6E32F0",
  strokeWidth: 1.73273,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_105",
  d: "M124.162 381.249C128.049 379.666 131.2 374.98 131.2 370.783C131.2 366.587 128.049 364.468 124.162 366.051C120.276 367.634 117.125 372.32 117.125 376.517C117.125 380.714 120.276 382.832 124.162 381.249Z",
  stroke: "#6E32F0",
  strokeWidth: 1.21247,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_106",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.0974 349.944L119.132 333.223L146.844 344.424V388.835L105.803 405.551L78.0974 394.355V349.944Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_5"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_107",
  d: "M219.934 356.454C219.934 352.773 228.618 349.788 239.329 349.788C250.04 349.788 258.723 352.773 258.723 356.454C258.723 360.136 250.04 363.121 239.329 363.121C228.618 363.121 219.934 360.136 219.934 356.454Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_108"
}, /*#__PURE__*/React.createElement("path", {
  d: "M259.95 356.45H257.526C257.526 356.856 257.288 357.422 256.449 358.105C255.619 358.779 254.345 359.439 252.664 360.018C249.311 361.17 244.602 361.905 239.344 361.905V364.329C244.796 364.329 249.784 363.572 253.452 362.311C255.28 361.682 256.846 360.907 257.978 359.986C259.101 359.073 259.95 357.886 259.95 356.45ZM239.344 364.329V361.905C234.085 361.905 229.376 361.17 226.024 360.018C224.342 359.439 223.068 358.779 222.238 358.105C221.399 357.422 221.162 356.856 221.162 356.45H218.737C218.737 357.886 219.586 359.073 220.71 359.986C221.842 360.907 223.408 361.682 225.236 362.311C228.904 363.572 233.891 364.329 239.344 364.329ZM218.737 356.45H221.162C221.162 356.044 221.399 355.478 222.238 354.796C223.068 354.122 224.342 353.461 226.024 352.883C229.376 351.73 234.085 350.996 239.344 350.996V348.571C233.891 348.571 228.904 349.329 225.236 350.59C223.408 351.219 221.842 351.993 220.71 352.915C219.586 353.827 218.737 355.015 218.737 356.45ZM239.344 348.571V350.996C244.602 350.996 249.311 351.73 252.664 352.883C254.345 353.461 255.619 354.122 256.449 354.796C257.288 355.478 257.526 356.044 257.526 356.45H259.95C259.95 355.015 259.101 353.827 257.978 352.915C256.846 351.993 255.28 351.219 253.452 350.59C249.784 349.329 244.796 348.571 239.344 348.571Z",
  fill: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.95 356.45H257.526M259.95 356.45C259.95 357.886 259.101 359.073 257.978 359.986C256.846 360.907 255.28 361.682 253.452 362.311C249.784 363.572 244.796 364.329 239.344 364.329M259.95 356.45C259.95 355.015 259.101 353.827 257.978 352.915C256.846 351.993 255.28 351.219 253.452 350.59C249.784 349.329 244.796 348.571 239.344 348.571M257.526 356.45C257.526 356.856 257.288 357.422 256.449 358.105C255.619 358.779 254.345 359.439 252.664 360.018C249.311 361.17 244.602 361.905 239.344 361.905M257.526 356.45C257.526 356.044 257.288 355.478 256.449 354.796C255.619 354.122 254.345 353.461 252.664 352.883C249.311 351.73 244.602 350.996 239.344 350.996M239.344 361.905V364.329M239.344 361.905C234.085 361.905 229.376 361.17 226.024 360.018C224.342 359.439 223.068 358.779 222.238 358.105C221.399 357.422 221.162 356.856 221.162 356.45M239.344 364.329C233.891 364.329 228.904 363.572 225.236 362.311C223.408 361.682 221.842 360.907 220.71 359.986C219.586 359.073 218.737 357.886 218.737 356.45M221.162 356.45H218.737M221.162 356.45C221.162 356.044 221.399 355.478 222.238 354.796C223.068 354.122 224.342 353.461 226.024 352.883C229.376 351.73 234.085 350.996 239.344 350.996M218.737 356.45C218.737 355.015 219.586 353.827 220.71 352.915C221.842 351.993 223.408 351.219 225.236 350.59C228.904 349.329 233.891 348.571 239.344 348.571M239.344 350.996V348.571",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_109",
  d: "M240.544 256.126H238.119V355.844H240.544V256.126Z",
  fill: "#6E32F0",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__FC_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_110",
  d: "M254.955 253.72L236.228 261.349V292.604L254.955 284.976V253.72Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_111",
  d: "M254.948 253.716L242.456 248.669L223.729 256.298L236.221 261.345L254.948 253.716Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.24322,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_112",
  d: "M236.212 261.351L223.72 256.303V287.561L236.212 292.608V261.351Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.16799,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_113",
  d: "M245.578 283.942C248.334 282.819 250.569 279.496 250.569 276.52C250.569 273.544 248.334 272.042 245.578 273.164C242.822 274.287 240.587 277.61 240.587 280.586C240.587 283.562 242.822 285.065 245.578 283.942Z",
  stroke: "#6E32F0",
  strokeWidth: 1.73258,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_114",
  d: "M245.573 267.837C247 267.256 248.157 265.536 248.157 263.995C248.157 262.454 247 261.676 245.573 262.258C244.146 262.839 242.99 264.559 242.99 266.1C242.99 267.64 244.146 268.418 245.573 267.837Z",
  stroke: "#6E32F0",
  strokeWidth: 1.5,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_115",
  d: "M244.752 280.935C246.229 280.333 247.427 278.552 247.427 276.957C247.427 275.362 246.229 274.557 244.752 275.159C243.275 275.76 242.078 277.541 242.078 279.136C242.078 280.731 243.275 281.536 244.752 280.935Z",
  stroke: "#6E32F0",
  strokeWidth: 1.21249,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_116",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M223.726 256.306L242.473 248.675L254.965 253.724V284.98L236.205 292.607L223.726 287.562V256.306Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_117",
  d: "M166.784 392.124C166.784 388.442 175.467 385.457 186.178 385.457C196.889 385.457 205.573 388.442 205.573 392.124C205.573 395.806 196.889 398.791 186.178 398.791C175.467 398.791 166.784 395.806 166.784 392.124Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_118"
}, /*#__PURE__*/React.createElement("path", {
  d: "M206.8 392.12H204.375C204.375 392.526 204.138 393.092 203.299 393.774C202.469 394.448 201.195 395.109 199.514 395.687C196.161 396.84 191.452 397.574 186.193 397.574V399.999C191.646 399.999 196.634 399.241 200.301 397.98C202.129 397.351 203.695 396.577 204.828 395.655C205.951 394.743 206.8 393.555 206.8 392.12ZM186.193 399.999V397.574C180.935 397.574 176.226 396.84 172.873 395.687C171.192 395.109 169.918 394.448 169.088 393.774C168.249 393.092 168.011 392.526 168.011 392.12H165.587C165.587 393.555 166.436 394.743 167.559 395.655C168.691 396.577 170.258 397.351 172.085 397.98C175.753 399.241 180.741 399.999 186.193 399.999ZM165.587 392.12H168.011C168.011 391.714 168.249 391.148 169.088 390.465C169.918 389.791 171.192 389.131 172.873 388.552C176.226 387.4 180.935 386.665 186.193 386.665V384.241C180.741 384.241 175.753 384.998 172.085 386.259C170.258 386.888 168.691 387.663 167.559 388.584C166.436 389.497 165.587 390.684 165.587 392.12ZM186.193 384.241V386.665C191.452 386.665 196.161 387.4 199.514 388.552C201.195 389.131 202.469 389.791 203.299 390.465C204.138 391.148 204.375 391.714 204.375 392.12H206.8C206.8 390.684 205.951 389.497 204.828 388.584C203.695 387.663 202.129 386.888 200.301 386.259C196.634 384.998 191.646 384.241 186.193 384.241Z",
  fill: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.8 392.12H204.375M206.8 392.12C206.8 393.555 205.951 394.743 204.828 395.655C203.695 396.577 202.129 397.351 200.301 397.98C196.634 399.241 191.646 399.999 186.193 399.999M206.8 392.12C206.8 390.684 205.951 389.497 204.828 388.584C203.695 387.663 202.129 386.888 200.301 386.259C196.634 384.998 191.646 384.241 186.193 384.241M204.375 392.12C204.375 392.526 204.138 393.092 203.299 393.774C202.469 394.448 201.195 395.109 199.514 395.687C196.161 396.84 191.452 397.574 186.193 397.574M204.375 392.12C204.375 391.714 204.138 391.148 203.299 390.465C202.469 389.791 201.195 389.131 199.514 388.552C196.161 387.4 191.452 386.665 186.193 386.665M186.193 397.574V399.999M186.193 397.574C180.935 397.574 176.226 396.84 172.873 395.687C171.192 395.109 169.918 394.448 169.088 393.774C168.249 393.092 168.011 392.526 168.011 392.12M186.193 399.999C180.741 399.999 175.753 399.241 172.085 397.98C170.258 397.351 168.691 396.577 167.559 395.655C166.436 394.743 165.587 393.555 165.587 392.12M168.011 392.12H165.587M168.011 392.12C168.011 391.714 168.249 391.148 169.088 390.465C169.918 389.791 171.192 389.131 172.873 388.552C176.226 387.4 180.935 386.665 186.193 386.665M165.587 392.12C165.587 390.684 166.436 389.497 167.559 388.584C168.691 387.663 170.258 386.888 172.085 386.259C175.753 384.998 180.741 384.241 186.193 384.241M186.193 386.665V384.241",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_119",
  d: "M187.393 291.796H184.969V391.514H187.393V291.796Z",
  fill: "#6E32F0",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__FL_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_120",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M200.602 285.41V316.665L188.309 330.523V299.268L200.602 285.41Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_121",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M200.433 285L188.303 299L172.423 296.932L184.634 283.041L200.433 285Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 0.328894,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_122",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M188.303 299.261V330.517L171.885 328.807V297.551L188.303 299.261Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.16799,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_123",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.883 297.555L184.117 283.66L200.598 285.405V316.661L188.325 330.521L171.883 328.811V297.555Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_124",
  d: "M194.362 318.043C196.128 316.111 197.559 312.132 197.559 309.156C197.559 306.179 196.128 305.333 194.362 307.265C192.596 309.197 191.165 313.176 191.165 316.152C191.165 319.128 192.596 319.975 194.362 318.043Z",
  stroke: "#6E32F0",
  strokeWidth: 1.58856,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_125",
  d: "M194.358 301.935C195.273 300.935 196.014 298.875 196.014 297.334C196.014 295.793 195.273 295.355 194.358 296.355C193.444 297.356 192.703 299.415 192.703 300.956C192.703 302.497 193.444 302.935 194.358 301.935Z",
  stroke: "#6E32F0",
  strokeWidth: 1.5,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_126",
  d: "M193.275 315.272C194.221 314.236 194.989 312.104 194.989 310.509C194.989 308.914 194.221 308.461 193.275 309.496C192.329 310.531 191.562 312.664 191.562 314.259C191.562 315.854 192.329 316.307 193.275 315.272Z",
  stroke: "#6E32F0",
  strokeWidth: 1.8035,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__desk"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_127",
  d: "M373.817 311.309L373.723 311.276C373.255 311.138 372.89 311.417 372.89 311.934V384.558C372.89 385.11 373.305 385.725 373.817 385.932L431.941 409.416C432.453 409.622 432.868 409.342 432.868 408.79V336.167C432.868 335.615 432.453 334.999 431.941 334.793L373.817 311.309Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_128",
  d: "M309.39 384.533C309.635 384.634 309.968 384.691 310.315 384.691C310.662 384.691 310.995 384.634 311.24 384.533L490.304 310.636C490.813 310.426 490.813 310.086 490.303 309.876L403.052 273.973C402.807 273.872 402.474 273.815 402.126 273.815C401.779 273.815 401.446 273.872 401.201 273.974L222.137 347.87C221.627 348.08 221.628 348.42 222.139 348.63L309.39 384.533Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_129",
  d: "M221.888 348.452L310.368 384.199V456.823L221.888 421.075V348.452Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_130",
  d: "M432.123 334.031L432.029 334.074C431.562 334.316 431.197 334.891 431.197 335.408V408.116C431.197 408.668 431.612 408.946 432.123 408.738L490.18 385.09C490.691 384.882 491.106 384.265 491.106 383.713V311.006L491.101 310.905C491.054 310.42 490.659 310.188 490.18 310.383L432.123 334.031Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__RackR"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_131",
  d: "M439.558 338.177L484.89 319.712V331.817L439.558 350.282V338.177Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_132",
  d: "M459.717 333.319L481.221 324.559V330.302L459.717 339.061V333.319Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_133",
  d: "M439.558 350.266L484.89 331.801V343.906L439.558 362.371V350.266Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_134",
  d: "M439.558 362.356L484.89 343.891V355.996L439.558 374.461V362.356Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_135",
  d: "M439.648 374.445L484.979 355.98V368.086L439.648 386.55V374.445Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_136",
  d: "M439.648 386.535L484.979 368.07V380.175L439.648 398.64V386.535Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_137",
  d: "M446.337 344.238C447.742 343.665 448.882 341.971 448.882 340.453C448.882 338.935 447.742 338.169 446.337 338.741C444.931 339.314 443.792 341.008 443.792 342.526C443.792 344.044 444.931 344.81 446.337 344.238Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_138",
  d: "M446.337 392.82C447.742 392.247 448.882 390.553 448.882 389.035C448.882 387.517 447.742 386.751 446.337 387.324C444.931 387.896 443.792 389.591 443.792 391.108C443.792 392.626 444.931 393.392 446.337 392.82Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_139",
  d: "M471.868 382.429C473.273 381.857 474.412 380.162 474.412 378.645C474.412 377.127 473.273 376.36 471.868 376.933C470.462 377.506 469.322 379.2 469.322 380.718C469.322 382.236 470.462 383.002 471.868 382.429Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_140",
  d: "M444.427 353.563C445.13 353.276 445.699 352.429 445.699 351.67C445.699 350.911 445.13 350.528 444.427 350.814C443.724 351.101 443.154 351.948 443.154 352.707C443.154 353.466 443.724 353.849 444.427 353.563Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_141",
  d: "M444.427 357.892C445.13 357.605 445.699 356.758 445.699 355.999C445.699 355.24 445.13 354.857 444.427 355.143C443.724 355.43 443.154 356.277 443.154 357.036C443.154 357.795 443.724 358.178 444.427 357.892Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_142",
  d: "M448.907 351.743C449.609 351.457 450.179 350.61 450.179 349.851C450.179 349.092 449.609 348.709 448.907 348.995C448.204 349.282 447.634 350.129 447.634 350.888C447.634 351.647 448.204 352.03 448.907 351.743Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_143",
  d: "M462.254 346.302C462.957 346.016 463.527 345.168 463.527 344.409C463.527 343.651 462.957 343.267 462.254 343.554C461.551 343.84 460.982 344.687 460.982 345.446C460.982 346.205 461.551 346.588 462.254 346.302Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_144",
  d: "M471.123 342.672C471.826 342.386 472.395 341.538 472.395 340.78C472.395 340.021 471.826 339.637 471.123 339.924C470.42 340.21 469.85 341.057 469.85 341.816C469.85 342.575 470.42 342.958 471.123 342.672Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_145",
  d: "M471.123 347.001C471.826 346.714 472.395 345.867 472.395 345.108C472.395 344.35 471.826 343.966 471.123 344.253C470.42 344.539 469.85 345.386 469.85 346.145C469.85 346.904 470.42 347.287 471.123 347.001Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_146",
  d: "M475.601 340.861C476.304 340.575 476.874 339.727 476.874 338.969C476.874 338.21 476.304 337.826 475.601 338.113C474.899 338.399 474.329 339.246 474.329 340.005C474.329 340.764 474.899 341.147 475.601 340.861Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_147",
  d: "M475.601 345.189C476.304 344.903 476.874 344.056 476.874 343.297C476.874 342.538 476.304 342.155 475.601 342.441C474.899 342.728 474.329 343.575 474.329 344.334C474.329 345.093 474.899 345.476 475.601 345.189Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_148",
  d: "M453.951 341.125C455.356 340.552 456.495 338.858 456.495 337.34C456.495 335.822 455.356 335.056 453.951 335.629C452.545 336.201 451.405 337.896 451.405 339.413C451.405 340.931 452.545 341.697 453.951 341.125Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_149",
  d: "M453.951 389.707C455.356 389.135 456.495 387.44 456.495 385.922C456.495 384.405 455.356 383.638 453.951 384.211C452.545 384.783 451.405 386.478 451.405 387.996C451.405 389.513 452.545 390.28 453.951 389.707Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_150",
  d: "M479.481 379.315C480.887 378.743 482.026 377.049 482.026 375.531C482.026 374.013 480.887 373.247 479.481 373.819C478.076 374.392 476.936 376.086 476.936 377.604C476.936 379.122 478.076 379.888 479.481 379.315Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Group 460"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_151",
  d: "M443.391 364.912L443.33 369.136",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_152",
  d: "M463.725 356.642L463.664 360.866",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_153",
  d: "M445.9 363.86L445.839 368.084",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_154",
  d: "M466.323 355.589L466.262 359.813",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_155",
  d: "M448.497 362.807L448.436 367.031",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_156",
  d: "M468.921 354.529L468.86 358.753",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_157",
  d: "M451.095 361.747L451.034 365.971",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_158",
  d: "M471.43 353.478L471.369 357.702",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_159",
  d: "M453.692 360.694L453.631 364.918",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_160",
  d: "M474.027 352.425L473.966 356.649",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_161",
  d: "M456.291 359.642L456.231 363.866",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_162",
  d: "M476.624 351.373L476.563 355.597",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_163",
  d: "M458.889 358.591L458.828 362.815",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_164",
  d: "M479.224 350.321L479.163 354.545",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_165",
  d: "M461.486 357.539L461.425 361.763",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_166",
  d: "M481.821 349.26L481.76 353.484",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_167",
  d: "M443.391 377L443.33 381.225",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_168",
  d: "M463.725 368.731L463.664 372.955",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_169",
  d: "M445.9 375.949L445.839 380.173",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_170",
  d: "M466.323 367.679L466.262 371.903",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_171",
  d: "M448.497 374.896L448.436 379.12",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_172",
  d: "M468.921 366.618L468.86 370.842",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_173",
  d: "M451.095 373.836L451.034 378.06",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_174",
  d: "M471.43 365.567L471.369 369.791",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_175",
  d: "M453.692 372.783L453.631 377.007",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_176",
  d: "M474.027 364.514L473.966 368.738",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_177",
  d: "M456.291 371.731L456.231 375.955",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_178",
  d: "M476.624 363.462L476.563 367.686",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_179",
  d: "M458.889 370.68L458.828 374.904",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_180",
  d: "M479.224 362.41L479.163 366.634",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_181",
  d: "M461.486 369.628L461.425 373.852",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_182",
  d: "M481.821 361.35L481.76 365.574",
  stroke: "#8496B9",
  strokeWidth: 0.440213,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-interface",
  className: "element-interface"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_183",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M318.758 373.361L468.954 311.355L407.242 286.792L257.046 348.798L318.758 373.361Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_184",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M248.266 325.41L398.465 265.064L407.293 286.788L257.097 348.793L248.266 325.41Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.5,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_185",
  d: "M304.08 360.627L320.476 367.249",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_186",
  d: "M310.531 358.023L326.927 364.646",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_187",
  d: "M316.89 355.418L333.286 362.041",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_188",
  d: "M323.25 352.815L339.647 359.437",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_189",
  d: "M329.699 350.21L346.096 356.832",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_190",
  d: "M336.06 347.606L352.456 354.228",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_191",
  d: "M342.422 345.002L358.818 351.624",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_192",
  d: "M348.87 342.398L365.266 349.02",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_193",
  d: "M355.229 339.794L371.626 346.416",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_194",
  d: "M361.59 337.19L377.987 343.812",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_195",
  d: "M368.041 334.585L384.437 341.207",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_196",
  d: "M374.4 331.981L390.796 338.603",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_197",
  d: "M380.76 329.377L397.157 335.999",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_198",
  d: "M387.21 326.773L403.607 333.395",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_199",
  d: "M393.57 324.177L409.966 330.8",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_200",
  d: "M399.931 321.573L416.327 328.195",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_201",
  d: "M406.38 318.969L422.776 325.591",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_202",
  d: "M412.741 316.365L429.137 322.987",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_203",
  d: "M419.19 313.761L435.586 320.383",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_204",
  d: "M425.551 311.156L441.947 317.778",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_205",
  d: "M431.91 308.552L448.307 315.174",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_206",
  d: "M438.36 305.948L454.756 312.57",
  stroke: "#8496B9",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_207",
  d: "M297.9 358.106L298.439 358.324",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_208",
  d: "M304.259 355.502L304.797 355.72",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_209",
  d: "M310.62 352.898L311.158 353.116",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_210",
  d: "M317.069 350.293L317.608 350.511",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_211",
  d: "M323.43 347.69L323.968 347.907",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_212",
  d: "M329.879 345.085L330.417 345.302",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_213",
  d: "M336.238 342.481L336.776 342.699",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_214",
  d: "M342.6 339.885L343.138 340.103",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_215",
  d: "M349.049 337.281L349.587 337.499",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_216",
  d: "M355.408 334.678L355.946 334.895",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_217",
  d: "M361.768 332.073L362.306 332.291",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_218",
  d: "M368.219 329.47L368.757 329.687",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_219",
  d: "M374.579 326.865L375.117 327.082",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_220",
  d: "M380.938 324.261L381.477 324.479",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_221",
  d: "M387.39 321.656L387.928 321.873",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_222",
  d: "M393.749 319.052L394.287 319.27",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_223",
  d: "M400.108 316.448L400.647 316.666",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_224",
  d: "M406.558 313.845L407.096 314.062",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_225",
  d: "M412.92 311.24L413.458 311.457",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_226",
  d: "M419.278 308.636L419.817 308.853",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_227",
  d: "M425.728 306.031L426.266 306.248",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_228",
  d: "M432.088 303.427L432.626 303.645",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_229",
  d: "M292.601 355.966L293.139 356.183",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_230",
  d: "M298.961 353.361L299.5 353.579",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_231",
  d: "M305.321 350.758L305.859 350.975",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_232",
  d: "M311.771 348.153L312.31 348.37",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_233",
  d: "M318.132 345.549L318.67 345.766",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_234",
  d: "M324.581 342.945L325.119 343.162",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_235",
  d: "M330.94 340.341L331.479 340.558",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_236",
  d: "M337.302 337.744L337.84 337.962",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_237",
  d: "M343.752 335.141L344.29 335.358",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_238",
  d: "M350.111 332.537L350.649 332.754",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_239",
  d: "M356.47 329.933L357.008 330.15",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_240",
  d: "M362.922 327.329L363.46 327.546",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_241",
  d: "M369.282 324.724L369.82 324.942",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_242",
  d: "M375.641 322.12L376.179 322.338",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_243",
  d: "M382.091 319.516L382.63 319.733",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_244",
  d: "M388.451 316.912L388.989 317.129",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_245",
  d: "M394.811 314.308L395.349 314.525",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_246",
  d: "M401.261 311.704L401.799 311.921",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_247",
  d: "M407.622 309.099L408.16 309.316",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_248",
  d: "M413.981 306.495L414.52 306.713",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_249",
  d: "M420.431 303.891L420.969 304.108",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_250",
  d: "M426.79 301.287L427.328 301.504",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_251",
  d: "M287.304 353.825L287.842 354.043",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_252",
  d: "M293.664 351.221L294.202 351.438",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_253",
  d: "M300.023 348.617L300.562 348.834",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_254",
  d: "M306.474 346.012L307.012 346.23",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_255",
  d: "M312.833 343.409L313.372 343.626",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_256",
  d: "M319.282 340.804L319.82 341.021",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_257",
  d: "M325.643 338.2L326.181 338.418",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_258",
  d: "M332.004 335.604L332.543 335.821",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_259",
  d: "M338.453 333L338.991 333.217",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_260",
  d: "M344.814 330.396L345.352 330.614",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_261",
  d: "M351.172 327.792L351.711 328.009",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_262",
  d: "M357.624 325.188L358.162 325.406",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_263",
  d: "M363.984 322.583L364.522 322.801",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_264",
  d: "M370.343 319.98L370.881 320.197",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_265",
  d: "M376.794 317.375L377.332 317.592",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_266",
  d: "M383.152 314.771L383.691 314.989",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_267",
  d: "M389.513 312.167L390.051 312.384",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_268",
  d: "M395.963 309.563L396.502 309.781",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_269",
  d: "M402.323 306.958L402.861 307.176",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_270",
  d: "M408.684 304.355L409.222 304.572",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_271",
  d: "M415.133 301.75L415.671 301.967",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_272",
  d: "M421.492 299.146L422.03 299.364",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_273",
  d: "M282.006 351.686L282.545 351.903",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_274",
  d: "M288.366 349.081L288.904 349.298",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_275",
  d: "M294.726 346.477L295.264 346.695",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_276",
  d: "M301.176 343.872L301.714 344.09",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_277",
  d: "M307.536 341.269L308.074 341.486",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_278",
  d: "M313.985 338.664L314.523 338.882",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_279",
  d: "M320.345 336.061L320.883 336.278",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_280",
  d: "M326.706 333.464L327.244 333.682",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_281",
  d: "M333.156 330.861L333.694 331.078",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_282",
  d: "M339.515 328.256L340.053 328.473",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_283",
  d: "M345.875 325.652L346.413 325.869",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_284",
  d: "M352.326 323.049L352.864 323.266",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_285",
  d: "M358.686 320.443L359.224 320.661",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_286",
  d: "M365.047 317.84L365.585 318.057",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_287",
  d: "M371.496 315.236L372.034 315.453",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_288",
  d: "M377.855 312.632L378.393 312.849",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_289",
  d: "M384.216 310.027L384.754 310.244",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_290",
  d: "M390.665 307.423L391.203 307.641",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_291",
  d: "M397.026 304.818L397.564 305.036",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_292",
  d: "M403.386 302.215L403.924 302.432",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_293",
  d: "M409.834 299.61L410.372 299.828",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_294",
  d: "M416.195 297.007L416.733 297.224",
  stroke: "#8496B9",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-interface-active",
  className: "element-interface-active"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_295",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M318.758 373.361L468.954 311.355L407.242 286.792L257.046 348.798L318.758 373.361Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_296",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M248.266 325.41L398.465 265.064L407.293 286.788L257.097 348.793L248.266 325.41Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.5,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_297",
  d: "M304.08 360.627L320.476 367.249",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_298",
  d: "M310.531 358.023L326.927 364.646",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_299",
  d: "M316.89 355.418L333.286 362.041",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_300",
  d: "M323.25 352.815L339.647 359.437",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_301",
  d: "M329.699 350.21L346.096 356.832",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_302",
  d: "M336.06 347.606L352.456 354.228",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_303",
  d: "M342.422 345.002L358.818 351.624",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_304",
  d: "M348.87 342.398L365.266 349.02",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_305",
  d: "M355.229 339.794L371.626 346.416",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_306",
  d: "M361.59 337.19L377.987 343.812",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_307",
  d: "M368.041 334.585L384.437 341.207",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_308",
  d: "M374.4 331.981L390.796 338.603",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_309",
  d: "M380.76 329.377L397.157 335.999",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_310",
  d: "M387.21 326.773L403.607 333.395",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_311",
  d: "M393.57 324.177L409.966 330.8",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_312",
  d: "M399.931 321.573L416.327 328.195",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_313",
  d: "M406.38 318.969L422.776 325.591",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_314",
  d: "M412.741 316.365L429.137 322.987",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_315",
  d: "M419.19 313.761L435.586 320.383",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_316",
  d: "M425.551 311.156L441.947 317.778",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_317",
  d: "M431.91 308.552L448.307 315.174",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_318",
  d: "M438.36 305.948L454.756 312.57",
  stroke: "#6E32F0",
  strokeWidth: 1.08766,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_319",
  d: "M297.9 358.106L298.439 358.324",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_320",
  d: "M304.259 355.502L304.797 355.72",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_321",
  d: "M310.62 352.898L311.158 353.116",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_322",
  d: "M317.069 350.293L317.608 350.511",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_323",
  d: "M323.43 347.69L323.968 347.907",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_324",
  d: "M329.879 345.085L330.417 345.302",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_325",
  d: "M336.238 342.481L336.776 342.699",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_326",
  d: "M342.6 339.885L343.138 340.103",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_327",
  d: "M349.049 337.281L349.587 337.499",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_328",
  d: "M355.408 334.678L355.946 334.895",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_329",
  d: "M361.768 332.073L362.306 332.291",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_330",
  d: "M368.219 329.47L368.757 329.687",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_331",
  d: "M374.579 326.865L375.117 327.082",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_332",
  d: "M380.938 324.261L381.477 324.479",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_333",
  d: "M387.39 321.656L387.928 321.873",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_334",
  d: "M393.749 319.052L394.287 319.27",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_335",
  d: "M400.108 316.448L400.647 316.666",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_336",
  d: "M406.558 313.845L407.096 314.062",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_337",
  d: "M412.92 311.24L413.458 311.457",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_338",
  d: "M419.278 308.636L419.817 308.853",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_339",
  d: "M425.728 306.031L426.266 306.248",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_340",
  d: "M432.088 303.427L432.626 303.645",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_341",
  d: "M292.601 355.966L293.139 356.183",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_342",
  d: "M298.961 353.361L299.5 353.579",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_343",
  d: "M305.321 350.758L305.859 350.975",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_344",
  d: "M311.771 348.153L312.31 348.37",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_345",
  d: "M318.132 345.549L318.67 345.766",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_346",
  d: "M324.581 342.945L325.119 343.162",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_347",
  d: "M330.94 340.341L331.479 340.558",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_348",
  d: "M337.302 337.744L337.84 337.962",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_349",
  d: "M343.752 335.141L344.29 335.358",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_350",
  d: "M350.111 332.537L350.649 332.754",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_351",
  d: "M356.47 329.933L357.008 330.15",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_352",
  d: "M362.922 327.329L363.46 327.546",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_353",
  d: "M369.282 324.724L369.82 324.942",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_354",
  d: "M375.641 322.12L376.179 322.338",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_355",
  d: "M382.091 319.516L382.63 319.733",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_356",
  d: "M388.451 316.912L388.989 317.129",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_357",
  d: "M394.811 314.308L395.349 314.525",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_358",
  d: "M401.261 311.704L401.799 311.921",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_359",
  d: "M407.622 309.099L408.16 309.316",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_360",
  d: "M413.981 306.495L414.52 306.713",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_361",
  d: "M420.431 303.891L420.969 304.108",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_362",
  d: "M426.79 301.287L427.328 301.504",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_363",
  d: "M287.304 353.825L287.842 354.043",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_364",
  d: "M293.664 351.221L294.202 351.438",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_365",
  d: "M300.023 348.617L300.562 348.834",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_366",
  d: "M306.474 346.012L307.012 346.23",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_367",
  d: "M312.833 343.409L313.372 343.626",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_368",
  d: "M319.282 340.804L319.82 341.021",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_369",
  d: "M325.643 338.2L326.181 338.418",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_370",
  d: "M332.004 335.604L332.543 335.821",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_371",
  d: "M338.453 333L338.991 333.217",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_372",
  d: "M344.814 330.396L345.352 330.614",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_373",
  d: "M351.172 327.792L351.711 328.009",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_374",
  d: "M357.624 325.188L358.162 325.406",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_375",
  d: "M363.984 322.583L364.522 322.801",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_376",
  d: "M370.343 319.98L370.881 320.197",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_377",
  d: "M376.794 317.375L377.332 317.592",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_378",
  d: "M383.152 314.771L383.691 314.989",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_379",
  d: "M389.513 312.167L390.051 312.384",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_380",
  d: "M395.963 309.563L396.502 309.781",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_381",
  d: "M402.323 306.958L402.861 307.176",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_382",
  d: "M408.684 304.355L409.222 304.572",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_383",
  d: "M415.133 301.75L415.671 301.967",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_384",
  d: "M421.492 299.146L422.03 299.364",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_385",
  d: "M282.006 351.686L282.545 351.903",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_386",
  d: "M288.366 349.081L288.904 349.298",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_387",
  d: "M294.726 346.477L295.264 346.695",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_388",
  d: "M301.176 343.872L301.714 344.09",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_389",
  d: "M307.536 341.269L308.074 341.486",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_390",
  d: "M313.985 338.664L314.523 338.882",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_391",
  d: "M320.345 336.061L320.883 336.278",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_392",
  d: "M326.706 333.464L327.244 333.682",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_393",
  d: "M333.156 330.861L333.694 331.078",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_394",
  d: "M339.515 328.256L340.053 328.473",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_395",
  d: "M345.875 325.652L346.413 325.869",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_396",
  d: "M352.326 323.049L352.864 323.266",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_397",
  d: "M358.686 320.443L359.224 320.661",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_398",
  d: "M365.047 317.84L365.585 318.057",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_399",
  d: "M371.496 315.236L372.034 315.453",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_400",
  d: "M377.855 312.632L378.393 312.849",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_401",
  d: "M384.216 310.027L384.754 310.244",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_402",
  d: "M390.665 307.423L391.203 307.641",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_403",
  d: "M397.026 304.818L397.564 305.036",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_404",
  d: "M403.386 302.215L403.924 302.432",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_405",
  d: "M409.834 299.61L410.372 299.828",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_406",
  d: "M416.195 297.007L416.733 297.224",
  stroke: "#6E32F0",
  strokeWidth: 0.685204,
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Dude"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_407",
  d: "M402.716 361.247C402.25 361.131 401.837 361.217 401.588 361.29C401.083 361.44 400.575 361.752 400.147 362.048C399.248 362.67 398.148 363.627 397.088 364.58C395.993 365.566 394.938 366.55 394.02 367.347C393.566 367.741 393.177 368.062 392.867 368.289C392.582 368.499 392.463 368.554 392.468 368.556L392.504 368.548L392.471 368.556L392.44 368.566C390.667 369.12 389.255 369.125 388.049 368.884C386.816 368.637 385.718 368.119 384.551 367.497C382.328 366.315 379.606 364.523 375.972 365.504L375.973 365.504C370.957 366.844 367.525 371.453 367.69 376.686C367.965 385.475 368.402 399.656 368.629 406.892C368.733 410.282 371.036 413.18 374.293 414.082C374.547 414.183 374.778 414.216 374.93 414.228C376.237 414.532 377.602 414.494 378.882 414.111V414.11C382.185 413.148 389.758 410.883 394.481 409.5L394.492 409.497C397.565 408.568 399.727 405.781 399.904 402.605V402.603C400.376 393.896 401.415 374.81 401.702 369.501V369.5C401.725 369.066 401.952 368.648 402.334 368.382L402.339 368.378C404.252 367.029 404.993 364.501 403.963 362.284C403.726 361.771 403.277 361.387 402.716 361.247Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_408",
  d: "M385.827 376.5L385.827 412.807",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_409",
  d: "M399.748 431.5L399.748 392.786L431.577 381.18L431.577 420.41",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_410",
  d: "M375.366 419.921L375.273 380.738L400.43 392L407.102 369.132L407.102 408.362",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_411",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M431.578 379.726L399.79 391.329L375.266 380.766L387.901 386.208L407.137 369.126L431.578 379.726Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_412",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M418.96 371.706C420.182 371.768 421.404 371.42 422.422 370.703C423.871 369.7 424.757 368.083 424.829 366.343L426.315 327.33C426.519 321.926 423.224 316.994 418.133 315.07L409.688 312.204L414.755 300.496C414.959 300.087 415.139 299.657 415.294 299.227C415.666 298.183 415.881 297.057 415.893 295.89C415.989 290.159 411.365 285.513 405.591 285.513C399.818 285.513 395.062 290.16 394.966 295.891C394.942 297.529 395.302 299.064 395.949 300.435L400.561 311.939C400.106 312.082 399.65 312.246 399.207 312.43C399.207 312.43 390.642 316.34 389.863 316.995C386.785 319.144 384.581 322.316 383.682 325.96L379.107 344.587L363.93 338C362.864 337.775 359.34 337.886 358.43 338.5C357.531 339.114 357.609 344.936 357.43 346C357.034 348.354 360.13 349.886 362.43 350.5L389.863 357L389.43 370.5L377.429 380.5C383.676 383.5 394.429 388.5 398.929 390L398.345 389.384C398.812 389.486 399.302 389.465 399.758 389.302L415.294 384C417.918 383.099 419.727 380.704 419.858 377.941L418.96 371.706Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_413"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.39 314.846L387.312 314.903C387.339 314.884 387.365 314.865 387.39 314.846Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.39 314.846C388.432 314.165 393.708 311.082 396.362 309.809C393.631 311.119 388.187 314.289 387.312 314.903L387.33 314.89C387.328 314.892 387.333 314.888 387.33 314.89C387.338 314.884 387.338 314.884 387.345 314.879M387.345 314.879C387.359 314.869 387.376 314.856 387.39 314.846L387.345 314.879ZM387.39 314.846L387.457 314.797Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.39 314.846L387.564 314.718C383.671 317.4 381.892 320.412 380.766 325.017L376.93 341L364.93 336.5C362.785 336.05 360.738 336.272 358.93 337.5C357.109 338.728 356.289 339.83 355.93 342C355.211 346.36 357.629 349.833 361.93 351L379.93 356.5L388.43 357C388.703 354.594 388.476 358.314 388.43 357C388.43 353.986 388.43 357.5 388.43 357L388.243 359.999L372.93 365L379.43 364L388.243 361.68L388.103 369C388.103 371 390.183 370.998 390.183 369.498C390.183 367.2 390.229 369.414 390.183 367.998L390.183 355.998L383.93 355.5L378.43 354L362.899 348.887C360.599 348.273 358.139 345.021 358.534 342.668C358.714 341.603 359.531 340.114 360.429 339.5C361.34 338.886 363.247 339.208 364.313 339.433L379.107 344.585L383.683 325.959C384.581 322.315 386.785 319.143 389.864 316.993C390.642 316.338 399.207 312.429 399.207 312.429C399.65 312.245 400.106 312.081 400.561 311.938L395.949 300.434C395.302 299.063 394.943 297.528 394.966 295.89C395.062 290.159 399.818 285.512 405.592 285.512C411.365 285.512 415.989 290.158 415.893 295.89C415.882 297.056 415.666 298.182 415.295 299.226C415.139 299.656 414.959 300.086 414.755 300.495L409.688 312.203L418.134 315.069C423.225 316.993 426.519 321.926 426.315 327.33L424.829 366.343C424.758 368.082 423.871 369.7 422.422 370.703C422.101 360.488 421.25 364.013 420.357 367.708C419.878 369.693 419.387 371.727 418.96 371.706L416.912 371.236C416.78 373.999 414.971 376.394 412.348 377.295L408.773 380.342C410.087 381.07 411.35 381.557 412.517 381.868L413.665 381.081C415.231 380.554 416.612 380.604 417.738 380.645C419.628 380.714 420.802 380.757 420.929 378L422.841 375.021C423.5 374.755 424.134 374.407 424.733 373.998C427.213 372.278 428.746 369.495 428.854 366.486L429.351 327.493C429.615 320.349 426.279 314.841 419.559 312.323C419.549 312.319 419.54 312.315 419.53 312.31C419.496 312.295 419.468 312.282 419.439 312.282L413.93 310.5L417.409 302.194C417.673 301.662 417.9 301.13 418.104 300.557C418.619 299.124 418.907 297.568 418.93 295.972C419.05 287.968 413.629 282.5 405.592 282.5C397.626 282.5 392.062 287.928 391.942 295.849C391.906 298.06 392.373 300.148 393.236 302.031C393.236 302.01 395.032 306.472 396.362 309.809C393.631 311.119 388.187 314.289 387.312 314.903L387.39 314.846Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Group_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_414",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M429.43 369L431.43 370L430.872 421.39L429.43 420.831L429.43 369Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_415",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M405.43 357L407.43 358L406.872 409.39L405.43 408.831L405.43 357Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_416",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.43 390.5L399.43 391.492L399.43 432.5L397.43 431.945L397.43 390.5Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Group_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_417",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.559 374.545L418.723 374.428L420.409 328.777L423.246 328.883L421.559 374.545Z",
  fill: "#8496B9"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Group_5"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_418",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M392.93 332.125L395.858 332.883C395.858 332.883 395.33 339.025 393.87 351.384C393.531 354.271 392.032 356.403 389.29 357.253C386.636 358.122 382.721 357.875 377.353 355.793L377.995 353.69C382.327 355.337 385.493 355.72 387.631 355.037C389.678 354.376 390.697 352.734 390.946 350.588C392.395 338.248 392.93 332.125 392.93 332.125Z",
  fill: "#8496B9"
}))), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_419",
  d: "M420.292 381.451L422.194 329.871",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_420",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M431.577 379.678L399.84 391.211C399.84 391.211 399.791 367.535 399.764 354.79C399.754 350.046 402.718 345.805 407.176 344.182C411.813 342.495 417.808 340.313 422.695 338.534C424.724 337.796 426.986 338.094 428.755 339.332C430.524 340.571 431.577 342.595 431.577 344.754C431.577 357.785 431.577 379.678 431.577 379.678Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_421",
  d: "M311.43 384.196L368.442 360.974V433.68L311.43 456.903V384.196Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 2,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__screens"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_422",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M394.43 267.5L368.801 277.743L376.576 299.035L394.43 289.5L394.43 267.5Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_423",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M278.366 314.176L248.751 326.239L257.526 347.532L287.142 335.468L278.366 314.176Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_424",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M308.195 302.052L278.58 314.115L287.355 335.408L316.97 323.344L308.195 302.052Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_425",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.936 289.928L308.321 301.991L317.096 323.283L346.711 311.22L338.936 289.928Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_426",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M368.677 277.804L339.062 289.867L346.837 311.16L376.452 299.096L368.677 277.804Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-monitoring-controller",
  className: "element-monitoring-controller"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_427",
  d: "M316.746 388.199L362.077 369.734V381.839L316.746 400.304V388.199Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_428",
  d: "M336.993 383.34L358.498 374.581V380.324L336.993 389.083V383.34Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_429",
  d: "M316.746 400.288L362.077 381.823V393.928L316.746 412.393V400.288Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_430",
  d: "M316.834 412.378L362.166 393.913V406.018L316.834 424.483V412.378Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_431",
  d: "M316.834 424.459L362.166 405.994V418.099L316.834 436.564V424.459Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_432",
  d: "M316.834 436.549L362.166 418.084V430.189L316.834 448.654V436.549Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_433",
  d: "M323.524 394.252C324.93 393.679 326.069 391.985 326.069 390.467C326.069 388.949 324.93 388.183 323.524 388.755C322.119 389.328 320.979 391.023 320.979 392.54C320.979 394.058 322.119 394.824 323.524 394.252Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_434",
  d: "M321.616 403.584C322.318 403.298 322.888 402.451 322.888 401.692C322.888 400.933 322.318 400.55 321.616 400.836C320.913 401.122 320.343 401.97 320.343 402.729C320.343 403.487 320.913 403.871 321.616 403.584Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_435",
  d: "M321.616 407.905C322.318 407.619 322.888 406.772 322.888 406.013C322.888 405.254 322.318 404.871 321.616 405.157C320.913 405.443 320.343 406.29 320.343 407.049C320.343 407.808 320.913 408.191 321.616 407.905Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_436",
  d: "M326.094 401.766C326.797 401.48 327.366 400.633 327.366 399.874C327.366 399.115 326.797 398.732 326.094 399.018C325.391 399.304 324.821 400.152 324.821 400.91C324.821 401.669 325.391 402.052 326.094 401.766Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_437",
  d: "M330.572 399.954C331.275 399.668 331.844 398.821 331.844 398.062C331.844 397.303 331.275 396.92 330.572 397.206C329.869 397.492 329.299 398.34 329.299 399.098C329.299 399.857 329.869 400.24 330.572 399.954Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_438",
  d: "M334.962 398.136C335.665 397.849 336.235 397.002 336.235 396.243C336.235 395.484 335.665 395.101 334.962 395.387C334.259 395.674 333.69 396.521 333.69 397.28C333.69 398.039 334.259 398.422 334.962 398.136Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_439",
  d: "M334.962 402.464C335.665 402.178 336.235 401.33 336.235 400.572C336.235 399.813 335.665 399.429 334.962 399.716C334.259 400.002 333.69 400.849 333.69 401.608C333.69 402.367 334.259 402.75 334.962 402.464Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_440",
  d: "M339.442 396.324C340.145 396.038 340.714 395.191 340.714 394.432C340.714 393.673 340.145 393.29 339.442 393.576C338.739 393.862 338.17 394.71 338.17 395.469C338.17 396.227 338.739 396.61 339.442 396.324Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_441",
  d: "M339.442 400.653C340.145 400.367 340.714 399.52 340.714 398.761C340.714 398.002 340.145 397.619 339.442 397.905C338.739 398.191 338.17 399.039 338.17 399.797C338.17 400.556 338.739 400.939 339.442 400.653Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_442",
  d: "M343.92 394.513C344.623 394.227 345.193 393.38 345.193 392.621C345.193 391.862 344.623 391.479 343.92 391.765C343.217 392.051 342.648 392.899 342.648 393.658C342.648 394.416 343.217 394.799 343.92 394.513Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_443",
  d: "M348.4 392.694C349.103 392.408 349.672 391.56 349.672 390.802C349.672 390.043 349.103 389.659 348.4 389.946C347.697 390.232 347.128 391.079 347.128 391.838C347.128 392.597 347.697 392.98 348.4 392.694Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_444",
  d: "M348.4 397.023C349.103 396.736 349.672 395.889 349.672 395.13C349.672 394.372 349.103 393.988 348.4 394.275C347.697 394.561 347.128 395.408 347.128 396.167C347.128 396.926 347.697 397.309 348.4 397.023Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_445",
  d: "M352.787 390.884C353.49 390.597 354.06 389.75 354.06 388.991C354.06 388.232 353.49 387.849 352.787 388.135C352.085 388.422 351.515 389.269 351.515 390.028C351.515 390.787 352.085 391.17 352.787 390.884Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_446",
  d: "M352.787 395.212C353.49 394.926 354.06 394.078 354.06 393.32C354.06 392.561 353.49 392.178 352.787 392.464C352.085 392.75 351.515 393.597 351.515 394.356C351.515 395.115 352.085 395.498 352.787 395.212Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_447",
  d: "M357.267 389.063C357.97 388.777 358.539 387.93 358.539 387.171C358.539 386.412 357.97 386.029 357.267 386.315C356.564 386.601 355.994 387.449 355.994 388.208C355.994 388.966 356.564 389.35 357.267 389.063Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_448",
  d: "M331.139 391.147C332.545 390.574 333.684 388.88 333.684 387.362C333.684 385.844 332.545 385.078 331.139 385.65C329.734 386.223 328.594 387.917 328.594 389.435C328.594 390.953 329.734 391.719 331.139 391.147Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_449",
  d: "M320.579 414.933L320.518 419.157",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_450",
  d: "M340.912 406.664L340.851 410.888",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_451",
  d: "M323.177 413.882L323.116 418.106",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_452",
  d: "M343.51 405.603L343.449 409.827",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_453",
  d: "M325.683 412.821L325.622 417.045",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_454",
  d: "M346.107 404.551L346.046 408.775",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_455",
  d: "M328.281 411.769L328.22 415.993",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_456",
  d: "M348.707 403.5L348.646 407.724",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_457",
  d: "M330.88 410.718L330.819 414.942",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_458",
  d: "M351.213 402.448L351.152 406.672",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_459",
  d: "M333.478 409.665L333.417 413.889",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_460",
  d: "M353.812 401.395L353.751 405.619",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_461",
  d: "M336.075 408.613L336.014 412.837",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_462",
  d: "M356.41 400.335L356.349 404.559",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_463",
  d: "M338.672 407.552L338.611 411.776",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_464",
  d: "M359.007 399.282L358.946 403.507",
  stroke: "#8496B9",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_465",
  d: "M341.433 417.872L358.483 410.927V416.669L341.433 423.614V417.872Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_466",
  d: "M321.726 425.883L338.776 418.938V424.68L321.726 431.625V425.883Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-monitoring-controller-active",
  className: "element-monitoring-controller-active"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_467",
  d: "M316.746 388.199L362.077 369.734V381.839L316.746 400.304V388.199Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_468",
  d: "M336.993 383.34L358.498 374.581V380.324L336.993 389.083V383.34Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_469",
  d: "M316.746 400.288L362.077 381.823V393.928L316.746 412.393V400.288Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_470",
  d: "M316.834 412.378L362.166 393.913V406.018L316.834 424.483V412.378Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_471",
  d: "M316.834 424.459L362.166 405.994V418.099L316.834 436.564V424.459Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_472",
  d: "M316.834 436.549L362.166 418.084V430.189L316.834 448.654V436.549Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_473",
  d: "M323.524 394.252C324.93 393.679 326.069 391.985 326.069 390.467C326.069 388.949 324.93 388.183 323.524 388.755C322.119 389.328 320.979 391.023 320.979 392.54C320.979 394.058 322.119 394.824 323.524 394.252Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_474",
  d: "M321.615 403.584C322.318 403.298 322.888 402.451 322.888 401.692C322.888 400.933 322.318 400.55 321.615 400.836C320.913 401.122 320.343 401.97 320.343 402.729C320.343 403.487 320.913 403.871 321.615 403.584Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_475",
  d: "M321.615 407.905C322.318 407.619 322.888 406.772 322.888 406.013C322.888 405.254 322.318 404.871 321.615 405.157C320.913 405.443 320.343 406.29 320.343 407.049C320.343 407.808 320.913 408.191 321.615 407.905Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_476",
  d: "M326.094 401.766C326.797 401.48 327.366 400.633 327.366 399.874C327.366 399.115 326.797 398.732 326.094 399.018C325.391 399.304 324.821 400.152 324.821 400.91C324.821 401.669 325.391 402.052 326.094 401.766Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_477",
  d: "M330.572 399.954C331.275 399.668 331.844 398.821 331.844 398.062C331.844 397.303 331.275 396.92 330.572 397.206C329.869 397.492 329.299 398.34 329.299 399.098C329.299 399.857 329.869 400.24 330.572 399.954Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_478",
  d: "M334.962 398.136C335.665 397.849 336.234 397.002 336.234 396.243C336.234 395.484 335.665 395.101 334.962 395.387C334.259 395.674 333.69 396.521 333.69 397.28C333.69 398.039 334.259 398.422 334.962 398.136Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_479",
  d: "M334.962 402.464C335.665 402.178 336.234 401.33 336.234 400.572C336.234 399.813 335.665 399.429 334.962 399.716C334.259 400.002 333.69 400.849 333.69 401.608C333.69 402.367 334.259 402.75 334.962 402.464Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_480",
  d: "M339.442 396.324C340.145 396.038 340.714 395.191 340.714 394.432C340.714 393.673 340.145 393.29 339.442 393.576C338.739 393.862 338.169 394.71 338.169 395.469C338.169 396.227 338.739 396.61 339.442 396.324Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_481",
  d: "M339.442 400.653C340.145 400.367 340.714 399.52 340.714 398.761C340.714 398.002 340.145 397.619 339.442 397.905C338.739 398.191 338.169 399.039 338.169 399.797C338.169 400.556 338.739 400.939 339.442 400.653Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_482",
  d: "M343.92 394.513C344.623 394.227 345.192 393.38 345.192 392.621C345.192 391.862 344.623 391.479 343.92 391.765C343.217 392.051 342.648 392.899 342.648 393.658C342.648 394.416 343.217 394.799 343.92 394.513Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_483",
  d: "M348.4 392.694C349.103 392.408 349.672 391.56 349.672 390.802C349.672 390.043 349.103 389.659 348.4 389.946C347.697 390.232 347.128 391.079 347.128 391.838C347.128 392.597 347.697 392.98 348.4 392.694Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_484",
  d: "M348.4 397.023C349.103 396.736 349.672 395.889 349.672 395.13C349.672 394.372 349.103 393.988 348.4 394.275C347.697 394.561 347.128 395.408 347.128 396.167C347.128 396.926 347.697 397.309 348.4 397.023Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_485",
  d: "M352.787 390.884C353.49 390.597 354.06 389.75 354.06 388.991C354.06 388.232 353.49 387.849 352.787 388.135C352.085 388.422 351.515 389.269 351.515 390.028C351.515 390.787 352.085 391.17 352.787 390.884Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_486",
  d: "M352.787 395.212C353.49 394.926 354.06 394.078 354.06 393.32C354.06 392.561 353.49 392.178 352.787 392.464C352.085 392.75 351.515 393.597 351.515 394.356C351.515 395.115 352.085 395.498 352.787 395.212Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_487",
  d: "M357.267 389.063C357.97 388.777 358.539 387.93 358.539 387.171C358.539 386.412 357.97 386.029 357.267 386.315C356.564 386.601 355.994 387.449 355.994 388.208C355.994 388.966 356.564 389.35 357.267 389.063Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_488",
  d: "M331.139 391.147C332.545 390.574 333.684 388.88 333.684 387.362C333.684 385.844 332.545 385.078 331.139 385.65C329.733 386.223 328.594 387.917 328.594 389.435C328.594 390.953 329.733 391.719 331.139 391.147Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_489",
  d: "M320.579 414.933L320.518 419.157",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_490",
  d: "M340.912 406.664L340.851 410.888",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_491",
  d: "M323.177 413.882L323.116 418.106",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_492",
  d: "M343.51 405.603L343.449 409.827",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_493",
  d: "M325.683 412.821L325.622 417.045",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_494",
  d: "M346.107 404.551L346.046 408.775",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_495",
  d: "M328.281 411.769L328.22 415.993",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_496",
  d: "M348.706 403.5L348.646 407.724",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_497",
  d: "M330.88 410.718L330.819 414.942",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_498",
  d: "M351.213 402.448L351.152 406.672",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_499",
  d: "M333.478 409.665L333.417 413.889",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_500",
  d: "M353.812 401.395L353.751 405.619",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_501",
  d: "M336.075 408.613L336.014 412.837",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_502",
  d: "M356.41 400.335L356.349 404.559",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_503",
  d: "M338.672 407.552L338.611 411.776",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_504",
  d: "M359.007 399.282L358.946 403.507",
  stroke: "#6E32F0",
  strokeMiterlimit: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_505",
  d: "M341.433 417.872L358.483 410.927V416.669L341.433 423.614V417.872Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_506",
  d: "M321.726 425.883L338.776 418.938V424.68L321.726 431.625V425.883Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-speakers-1",
  className: "element-speakers-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_7"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_507",
  d: "M505.198 354.864C505.198 351.182 513.881 348.197 524.592 348.197C535.303 348.197 543.986 351.182 543.986 354.864C543.986 358.546 535.303 361.531 524.592 361.531C513.881 361.531 505.198 358.546 505.198 354.864Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_508"
}, /*#__PURE__*/React.createElement("path", {
  d: "M545.213 354.86H542.789C542.789 355.266 542.552 355.832 541.713 356.515C540.883 357.188 539.609 357.849 537.927 358.427C534.575 359.58 529.865 360.315 524.607 360.315V362.739C530.059 362.739 535.047 361.981 538.715 360.721C540.543 360.092 542.109 359.317 543.241 358.396C544.365 357.483 545.213 356.295 545.213 354.86ZM524.607 362.739V360.315C519.349 360.315 514.64 359.58 511.287 358.427C509.606 357.849 508.332 357.188 507.502 356.515C506.663 355.832 506.425 355.266 506.425 354.86H504.001C504.001 356.295 504.849 357.483 505.973 358.396C507.105 359.317 508.671 360.092 510.499 360.721C514.167 361.981 519.155 362.739 524.607 362.739ZM504.001 354.86H506.425C506.425 354.454 506.663 353.888 507.502 353.205C508.332 352.531 509.606 351.871 511.287 351.293C514.64 350.14 519.349 349.405 524.607 349.405V346.981C519.155 346.981 514.167 347.739 510.499 348.999C508.671 349.628 507.105 350.403 505.973 351.324C504.849 352.237 504.001 353.425 504.001 354.86ZM524.607 346.981V349.405C529.865 349.405 534.575 350.14 537.927 351.293C539.609 351.871 540.883 352.531 541.713 353.205C542.552 353.888 542.789 354.454 542.789 354.86H545.213C545.213 353.425 544.365 352.237 543.241 351.324C542.109 350.403 540.543 349.628 538.715 348.999C535.047 347.739 530.059 346.981 524.607 346.981Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545.213 354.86H542.789M545.213 354.86C545.213 356.295 544.365 357.483 543.241 358.396C542.109 359.317 540.543 360.092 538.715 360.721C535.047 361.981 530.059 362.739 524.607 362.739M545.213 354.86C545.213 353.425 544.365 352.237 543.241 351.324C542.109 350.403 540.543 349.628 538.715 348.999C535.047 347.739 530.059 346.981 524.607 346.981M542.789 354.86C542.789 355.266 542.552 355.832 541.713 356.515C540.883 357.188 539.609 357.849 537.927 358.427C534.575 359.58 529.865 360.315 524.607 360.315M542.789 354.86C542.789 354.454 542.552 353.888 541.713 353.205C540.883 352.531 539.609 351.871 537.927 351.293C534.575 350.14 529.865 349.405 524.607 349.405M524.607 360.315V362.739M524.607 360.315C519.349 360.315 514.64 359.58 511.287 358.427C509.606 357.849 508.332 357.188 507.502 356.515C506.663 355.832 506.425 355.266 506.425 354.86M524.607 362.739C519.155 362.739 514.167 361.981 510.499 360.721C508.671 360.092 507.105 359.317 505.973 358.396C504.849 357.483 504.001 356.295 504.001 354.86M506.425 354.86H504.001M506.425 354.86C506.425 354.454 506.663 353.888 507.502 353.205C508.332 352.531 509.606 351.871 511.287 351.293C514.64 350.14 519.349 349.405 524.607 349.405M504.001 354.86C504.001 353.425 504.849 352.237 505.973 351.324C507.105 350.403 508.671 349.628 510.499 348.999C514.167 347.739 519.155 346.981 524.607 346.981M524.607 349.405V346.981",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_509",
  d: "M525.806 254.536H523.381V354.254H525.806V254.536Z",
  fill: "#8496B9",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__R"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_510",
  d: "M527.88 261.314L509.131 253.739V284.959L527.88 292.534V261.314Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.12284,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_511",
  d: "M521.808 248.562L509.331 253.645L528.08 261.22L540.557 256.137L521.808 248.562Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.04625,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_512",
  d: "M540.346 256.059L527.869 261.141V292.434L540.346 287.352V256.059Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.25966,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_513",
  d: "M540.346 256.059L527.869 261.141V292.434L540.346 287.352V256.059Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.25966,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_514",
  d: "M519.634 284.356C522.393 285.471 524.63 283.965 524.63 280.992C524.63 278.019 522.393 274.705 519.634 273.591C516.874 272.476 514.637 273.982 514.637 276.955C514.637 279.927 516.874 283.241 519.634 284.356Z",
  stroke: "#8496B9",
  strokeWidth: 1.16824,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_515",
  d: "M519.628 269.336C521.056 269.913 522.214 269.133 522.214 267.594C522.214 266.055 521.056 264.34 519.628 263.763C518.199 263.186 517.041 263.965 517.041 265.504C517.041 267.043 518.199 268.759 519.628 269.336Z",
  stroke: "#8496B9",
  strokeWidth: 1.16791,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_516",
  d: "M520.28 281.343C521.759 281.941 522.957 281.134 522.957 279.54C522.957 277.947 521.759 276.171 520.28 275.574C518.801 274.977 517.602 275.784 517.602 277.377C517.602 278.97 518.801 280.746 520.28 281.343Z",
  stroke: "#8496B9",
  strokeWidth: 0.81737,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_517",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M509.172 253.718L522.133 248.432L540.367 255.765V287.021L528.006 292.478L509.172 284.974V253.718Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_8"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_518",
  d: "M219.528 471.793C219.528 468.111 228.211 465.126 238.922 465.126C249.633 465.126 258.316 468.111 258.316 471.793C258.316 475.475 249.633 478.46 238.922 478.46C228.211 478.46 219.528 475.475 219.528 471.793Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_519"
}, /*#__PURE__*/React.createElement("path", {
  d: "M259.544 471.788H257.12C257.12 472.195 256.882 472.761 256.043 473.443C255.213 474.117 253.939 474.778 252.258 475.356C248.905 476.509 244.196 477.243 238.938 477.243V479.667C244.39 479.667 249.378 478.91 253.046 477.649C254.874 477.02 256.44 476.246 257.572 475.324C258.696 474.412 259.544 473.224 259.544 471.788ZM238.938 479.667V477.243C233.679 477.243 228.97 476.509 225.618 475.356C223.936 474.778 222.662 474.117 221.832 473.443C220.993 472.761 220.756 472.195 220.756 471.788H218.331C218.331 473.224 219.18 474.412 220.304 475.324C221.436 476.246 223.002 477.02 224.83 477.649C228.498 478.91 233.486 479.667 238.938 479.667ZM218.331 471.788H220.756C220.756 471.382 220.993 470.816 221.832 470.134C222.662 469.46 223.936 468.799 225.618 468.221C228.97 467.068 233.679 466.334 238.938 466.334V463.91C233.486 463.91 228.498 464.667 224.83 465.928C223.002 466.557 221.436 467.331 220.304 468.253C219.18 469.165 218.331 470.353 218.331 471.788ZM238.938 463.91V466.334C244.196 466.334 248.905 467.068 252.258 468.221C253.939 468.799 255.213 469.46 256.043 470.134C256.882 470.816 257.12 471.382 257.12 471.788H259.544C259.544 470.353 258.696 469.165 257.572 468.253C256.44 467.331 254.874 466.557 253.046 465.928C249.378 464.667 244.39 463.91 238.938 463.91Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.544 471.788H257.12M259.544 471.788C259.544 473.224 258.696 474.412 257.572 475.324C256.44 476.246 254.874 477.02 253.046 477.649C249.378 478.91 244.39 479.667 238.938 479.667M259.544 471.788C259.544 470.353 258.696 469.165 257.572 468.253C256.44 467.331 254.874 466.557 253.046 465.928C249.378 464.667 244.39 463.91 238.938 463.91M257.12 471.788C257.12 472.195 256.882 472.761 256.043 473.443C255.213 474.117 253.939 474.778 252.258 475.356C248.905 476.509 244.196 477.243 238.938 477.243M257.12 471.788C257.12 471.382 256.882 470.816 256.043 470.134C255.213 469.46 253.939 468.799 252.258 468.221C248.905 467.068 244.196 466.334 238.938 466.334M238.938 477.243V479.667M238.938 477.243C233.679 477.243 228.97 476.509 225.618 475.356C223.936 474.778 222.662 474.117 221.832 473.443C220.993 472.761 220.756 472.195 220.756 471.788M238.938 479.667C233.486 479.667 228.498 478.91 224.83 477.649C223.002 477.02 221.436 476.246 220.304 475.324C219.18 474.412 218.331 473.224 218.331 471.788M220.756 471.788H218.331M220.756 471.788C220.756 471.382 220.993 470.816 221.832 470.134C222.662 469.46 223.936 468.799 225.618 468.221C228.97 467.068 233.679 466.334 238.938 466.334M218.331 471.788C218.331 470.353 219.18 469.165 220.304 468.253C221.436 467.331 223.002 466.557 224.83 465.928C228.498 464.667 233.486 463.91 238.938 463.91M238.938 466.334V463.91",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_520",
  d: "M240.136 371.465H237.712V471.183H240.136V371.465Z",
  fill: "#8496B9",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__L"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_521",
  d: "M235.833 396.143L223.356 401.226L242.105 408.801L254.582 403.718L235.833 396.143Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.04625,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_522",
  d: "M241.862 377.206L223.113 369.631V400.851L241.862 408.426V377.206Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.12284,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_523",
  d: "M235.79 364.453L223.313 369.536L242.062 377.111L254.54 372.028L235.79 364.453Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.04625,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_524",
  d: "M254.328 371.949L241.85 377.032V408.325L254.328 403.243V371.949Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.07548,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_525",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M223.154 369.612L236.115 364.326L254.349 371.659V402.915L241.988 408.372L223.154 400.868V369.612Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_9"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_526",
  d: "M361.627 495.328C361.627 491.646 370.31 488.661 381.021 488.661C391.732 488.661 400.415 491.646 400.415 495.328C400.415 499.01 391.732 501.995 381.021 501.995C370.31 501.995 361.627 499.01 361.627 495.328Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_527"
}, /*#__PURE__*/React.createElement("path", {
  d: "M401.642 495.324H399.218C399.218 495.73 398.981 496.296 398.142 496.978C397.312 497.652 396.038 498.313 394.356 498.891C391.004 500.044 386.294 500.778 381.036 500.778V503.203C386.488 503.203 391.476 502.445 395.144 501.184C396.972 500.555 398.538 499.781 399.67 498.859C400.794 497.947 401.642 496.759 401.642 495.324ZM381.036 503.203V500.778C375.778 500.778 371.069 500.044 367.716 498.891C366.035 498.313 364.761 497.652 363.931 496.978C363.092 496.296 362.854 495.73 362.854 495.324H360.43C360.43 496.759 361.278 497.947 362.402 498.859C363.534 499.781 365.1 500.555 366.928 501.184C370.596 502.445 375.584 503.203 381.036 503.203ZM360.43 495.324H362.854C362.854 494.918 363.092 494.352 363.931 493.669C364.761 492.995 366.035 492.335 367.716 491.756C371.069 490.604 375.778 489.869 381.036 489.869V487.445C375.584 487.445 370.596 488.202 366.928 489.463C365.1 490.092 363.534 490.867 362.402 491.788C361.278 492.701 360.43 493.888 360.43 495.324ZM381.036 487.445V489.869C386.294 489.869 391.004 490.604 394.356 491.756C396.038 492.335 397.312 492.995 398.142 493.669C398.981 494.352 399.218 494.918 399.218 495.324H401.642C401.642 493.888 400.794 492.701 399.67 491.788C398.538 490.867 396.972 490.092 395.144 489.463C391.476 488.202 386.488 487.445 381.036 487.445Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M401.642 495.324H399.218M401.642 495.324C401.642 496.759 400.794 497.947 399.67 498.859C398.538 499.781 396.972 500.555 395.144 501.184C391.476 502.445 386.488 503.203 381.036 503.203M401.642 495.324C401.642 493.888 400.794 492.701 399.67 491.788C398.538 490.867 396.972 490.092 395.144 489.463C391.476 488.202 386.488 487.445 381.036 487.445M399.218 495.324C399.218 495.73 398.981 496.296 398.142 496.978C397.312 497.652 396.038 498.313 394.356 498.891C391.004 500.044 386.294 500.778 381.036 500.778M399.218 495.324C399.218 494.918 398.981 494.352 398.142 493.669C397.312 492.995 396.038 492.335 394.356 491.756C391.004 490.604 386.294 489.869 381.036 489.869M381.036 500.778V503.203M381.036 500.778C375.778 500.778 371.069 500.044 367.716 498.891C366.035 498.313 364.761 497.652 363.931 496.978C363.092 496.296 362.854 495.73 362.854 495.324M381.036 503.203C375.584 503.203 370.596 502.445 366.928 501.184C365.1 500.555 363.534 499.781 362.402 498.859C361.278 497.947 360.43 496.759 360.43 495.324M362.854 495.324H360.43M362.854 495.324C362.854 494.918 363.092 494.352 363.931 493.669C364.761 492.995 366.035 492.335 367.716 491.756C371.069 490.604 375.778 489.869 381.036 489.869M360.43 495.324C360.43 493.888 361.278 492.701 362.402 491.788C363.534 490.867 365.1 490.092 366.928 489.463C370.596 488.202 375.584 487.445 381.036 487.445M381.036 489.869V487.445",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_528",
  d: "M382.235 395H379.811V494.718H382.235V395Z",
  fill: "#8496B9",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__RL"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_529",
  d: "M394.888 430.373L394.878 423.21L368.378 423.248L368.388 430.411L394.888 430.373Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.17845,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_530",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M394.837 398.588L394.875 430.369L368.378 430.408L368.331 398.63L394.837 398.588Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_531",
  d: "M394.844 398.595L394.834 391.433L368.334 391.47L368.344 398.633L394.844 398.595Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.17845,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_532",
  d: "M394.888 430.381L394.833 391.44L368.333 391.478L368.388 430.418L394.888 430.381Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_10"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_533",
  d: "M564.01 412.389C564.01 408.708 572.693 405.723 583.404 405.723C594.115 405.723 602.798 408.708 602.798 412.389C602.798 416.071 594.115 419.056 583.404 419.056C572.693 419.056 564.01 416.071 564.01 412.389Z",
  fill: "white",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_534"
}, /*#__PURE__*/React.createElement("path", {
  d: "M604.025 412.385H601.601C601.601 412.791 601.363 413.357 600.524 414.04C599.694 414.714 598.42 415.374 596.739 415.953C593.386 417.105 588.677 417.84 583.419 417.84V420.264C588.871 420.264 593.859 419.507 597.527 418.246C599.355 417.617 600.921 416.842 602.053 415.921C603.177 415.008 604.025 413.821 604.025 412.385ZM583.419 420.264V417.84C578.16 417.84 573.451 417.105 570.099 415.953C568.417 415.374 567.143 414.714 566.313 414.04C565.474 413.357 565.237 412.791 565.237 412.385H562.812C562.812 413.821 563.661 415.008 564.785 415.921C565.917 416.842 567.483 417.617 569.311 418.246C572.979 419.507 577.967 420.264 583.419 420.264ZM562.812 412.385H565.237C565.237 411.979 565.474 411.413 566.313 410.731C567.143 410.057 568.417 409.396 570.099 408.818C573.451 407.665 578.16 406.931 583.419 406.931V404.506C577.967 404.506 572.979 405.264 569.311 406.525C567.483 407.154 565.917 407.928 564.785 408.85C563.661 409.762 562.812 410.95 562.812 412.385ZM583.419 404.506V406.931C588.677 406.931 593.386 407.665 596.739 408.818C598.42 409.396 599.694 410.057 600.524 410.731C601.363 411.413 601.601 411.979 601.601 412.385H604.025C604.025 410.95 603.177 409.762 602.053 408.85C600.921 407.928 599.355 407.154 597.527 406.525C593.859 405.264 588.871 404.506 583.419 404.506Z",
  fill: "#8496B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.025 412.385H601.601M604.025 412.385C604.025 413.821 603.177 415.008 602.053 415.921C600.921 416.842 599.355 417.617 597.527 418.246C593.859 419.507 588.871 420.264 583.419 420.264M604.025 412.385C604.025 410.95 603.177 409.762 602.053 408.85C600.921 407.928 599.355 407.154 597.527 406.525C593.859 405.264 588.871 404.506 583.419 404.506M601.601 412.385C601.601 412.791 601.363 413.357 600.524 414.04C599.694 414.714 598.42 415.374 596.739 415.953C593.386 417.105 588.677 417.84 583.419 417.84M601.601 412.385C601.601 411.979 601.363 411.413 600.524 410.731C599.694 410.057 598.42 409.396 596.739 408.818C593.386 407.665 588.677 406.931 583.419 406.931M583.419 417.84V420.264M583.419 417.84C578.16 417.84 573.451 417.105 570.099 415.953C568.417 415.374 567.143 414.714 566.313 414.04C565.474 413.357 565.237 412.791 565.237 412.385M583.419 420.264C577.967 420.264 572.979 419.507 569.311 418.246C567.483 417.617 565.917 416.842 564.785 415.921C563.661 415.008 562.812 413.821 562.812 412.385M565.237 412.385H562.812M565.237 412.385C565.237 411.979 565.474 411.413 566.313 410.731C567.143 410.057 568.417 409.396 570.099 408.818C573.451 407.665 578.16 406.931 583.419 406.931M562.812 412.385C562.812 410.95 563.661 409.762 564.785 408.85C565.917 407.928 567.483 407.154 569.311 406.525C572.979 405.264 577.967 404.506 583.419 404.506M583.419 406.931V404.506",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_535",
  d: "M584.618 312.062H582.194V411.779H584.618V312.062Z",
  fill: "#8496B9",
  stroke: "#8496B9",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__RR"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_536",
  d: "M592.362 306.516L574.706 306.541L574.721 317.292L592.377 317.267L592.362 306.516Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.10703,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_537",
  d: "M592.42 348.195L574.764 348.22L574.72 317.287L592.376 317.262L592.42 348.195Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.37119,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_538",
  d: "M592.36 306.502L574.704 306.527L574.763 348.21L592.419 348.185L592.36 306.502Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__High"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__HL"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_539",
  d: "M195.305 199.572L180.002 190.765L164.403 217.872L179.706 226.679L195.305 199.572Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.36768,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_540",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164.401 217.878L185.36 181.452L200.679 190.266L179.704 226.683L164.401 217.878Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_541",
  d: "M200.668 190.247L185.365 181.441L180.003 190.759L195.306 199.565L200.668 190.247Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.10703,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__HR"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_542",
  d: "M400.903 139.997L400.893 132.834L374.392 132.872L374.403 140.035L400.903 139.997Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.17845,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_543",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M400.852 108.77L400.889 140.047L374.393 140.085L374.345 108.812L400.852 108.77Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_544",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M400.852 108.717L400.89 101.755L374.393 101.793L374.345 108.759L400.852 108.717Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_545",
  d: "M387.6 136.077C390.828 136.077 393.445 133.46 393.445 130.232C393.445 127.003 390.828 124.386 387.6 124.386C384.371 124.386 381.754 127.003 381.754 130.232C381.754 133.46 384.371 136.077 387.6 136.077Z",
  stroke: "#8496B9",
  strokeWidth: 1.36859,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_546",
  d: "M387.615 132.769C389.285 132.769 390.638 131.415 390.638 129.746C390.638 128.076 389.285 126.723 387.615 126.723C385.946 126.723 384.592 128.076 384.592 129.746C384.592 131.415 385.946 132.769 387.615 132.769Z",
  stroke: "#8496B9",
  strokeWidth: 0.958614,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_547",
  d: "M387.6 119.82C389.116 119.82 390.345 118.59 390.345 117.074C390.345 115.558 389.116 114.328 387.6 114.328C386.084 114.328 384.854 115.558 384.854 117.074C384.854 118.59 386.084 119.82 387.6 119.82Z",
  stroke: "#8496B9",
  strokeWidth: 1.5,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_548",
  d: "M400.902 140.029L400.848 101.671L374.347 101.708L374.402 140.067L400.902 140.029Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__HRL"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_549",
  d: "M397.943 303.031L397.933 295.869L371.433 295.906L371.443 303.069L397.943 303.031Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.17845,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_550",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.893 265.142L397.931 303.301L371.434 303.34L371.387 265.142L397.893 265.142Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_551",
  d: "M397.943 303.064L397.888 264.706L371.388 264.743L371.442 303.102L397.943 303.064Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_552",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M371.402 275.493L371.446 303.079L371.497 296.461L371.396 268.783L371.402 275.493Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.16799,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__HRR"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_553",
  d: "M584.685 183.992L572.218 196.495L579.83 204.086L592.297 191.583L584.685 183.992Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.10703,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_554",
  d: "M584.674 183.983L572.207 196.486L601.724 225.919L614.191 213.416L584.674 183.983Z",
  stroke: "#8496B9",
  strokeWidth: 2.2,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-speakers-1-active",
  className: "element-speakers-1-active"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_11"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_555",
  d: "M505.198 354.864C505.198 351.182 513.881 348.197 524.592 348.197C535.303 348.197 543.986 351.182 543.986 354.864C543.986 358.546 535.303 361.531 524.592 361.531C513.881 361.531 505.198 358.546 505.198 354.864Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_556"
}, /*#__PURE__*/React.createElement("path", {
  d: "M545.213 354.86H542.789C542.789 355.266 542.552 355.832 541.713 356.515C540.883 357.189 539.609 357.849 537.927 358.427C534.575 359.58 529.865 360.315 524.607 360.315V362.739C530.059 362.739 535.047 361.981 538.715 360.721C540.543 360.092 542.109 359.317 543.241 358.396C544.365 357.483 545.213 356.295 545.213 354.86ZM524.607 362.739V360.315C519.349 360.315 514.64 359.58 511.287 358.427C509.606 357.849 508.332 357.189 507.502 356.515C506.663 355.832 506.425 355.266 506.425 354.86H504.001C504.001 356.295 504.849 357.483 505.973 358.396C507.105 359.317 508.671 360.092 510.499 360.721C514.167 361.981 519.155 362.739 524.607 362.739ZM504.001 354.86H506.425C506.425 354.454 506.663 353.888 507.502 353.205C508.332 352.532 509.606 351.871 511.287 351.293C514.64 350.14 519.349 349.405 524.607 349.405V346.981C519.155 346.981 514.167 347.739 510.499 348.999C508.671 349.628 507.105 350.403 505.973 351.324C504.849 352.237 504.001 353.425 504.001 354.86ZM524.607 346.981V349.405C529.865 349.405 534.575 350.14 537.927 351.293C539.609 351.871 540.883 352.532 541.713 353.205C542.552 353.888 542.789 354.454 542.789 354.86H545.213C545.213 353.425 544.365 352.237 543.241 351.324C542.109 350.403 540.543 349.628 538.715 348.999C535.047 347.739 530.059 346.981 524.607 346.981Z",
  fill: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545.213 354.86H542.789M545.213 354.86C545.213 356.295 544.365 357.483 543.241 358.396C542.109 359.317 540.543 360.092 538.715 360.721C535.047 361.981 530.059 362.739 524.607 362.739M545.213 354.86C545.213 353.425 544.365 352.237 543.241 351.324C542.109 350.403 540.543 349.628 538.715 348.999C535.047 347.739 530.059 346.981 524.607 346.981M542.789 354.86C542.789 355.266 542.552 355.832 541.713 356.515C540.883 357.189 539.609 357.849 537.927 358.427C534.575 359.58 529.865 360.315 524.607 360.315M542.789 354.86C542.789 354.454 542.552 353.888 541.713 353.205C540.883 352.532 539.609 351.871 537.927 351.293C534.575 350.14 529.865 349.405 524.607 349.405M524.607 360.315V362.739M524.607 360.315C519.349 360.315 514.64 359.58 511.287 358.427C509.606 357.849 508.332 357.189 507.502 356.515C506.663 355.832 506.425 355.266 506.425 354.86M524.607 362.739C519.155 362.739 514.167 361.981 510.499 360.721C508.671 360.092 507.105 359.317 505.973 358.396C504.849 357.483 504.001 356.295 504.001 354.86M506.425 354.86H504.001M506.425 354.86C506.425 354.454 506.663 353.888 507.502 353.205C508.332 352.532 509.606 351.871 511.287 351.293C514.64 350.14 519.349 349.405 524.607 349.405M504.001 354.86C504.001 353.425 504.849 352.237 505.973 351.324C507.105 350.403 508.671 349.628 510.499 348.999C514.167 347.739 519.155 346.981 524.607 346.981M524.607 349.405V346.981",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_557",
  d: "M525.806 254.536H523.381V354.254H525.806V254.536Z",
  fill: "#6E32F0",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__R_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_558",
  d: "M527.88 261.314L509.131 253.739V284.959L527.88 292.534V261.314Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.12284,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_559",
  d: "M521.808 248.562L509.331 253.645L528.08 261.22L540.557 256.137L521.808 248.562Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.04625,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_560",
  d: "M540.346 256.059L527.869 261.141V292.434L540.346 287.352V256.059Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.25966,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_561",
  d: "M540.346 256.059L527.869 261.141V292.434L540.346 287.352V256.059Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.25966,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_562",
  d: "M519.634 284.356C522.393 285.471 524.63 283.965 524.63 280.992C524.63 278.019 522.393 274.706 519.634 273.591C516.874 272.476 514.637 273.982 514.637 276.955C514.637 279.927 516.874 283.241 519.634 284.356Z",
  stroke: "#6E32F0",
  strokeWidth: 1.16824,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_563",
  d: "M519.628 269.336C521.056 269.913 522.214 269.133 522.214 267.594C522.214 266.055 521.056 264.34 519.628 263.763C518.199 263.186 517.041 263.965 517.041 265.504C517.041 267.043 518.199 268.759 519.628 269.336Z",
  stroke: "#6E32F0",
  strokeWidth: 1.16791,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_564",
  d: "M520.28 281.343C521.759 281.941 522.957 281.134 522.957 279.54C522.957 277.947 521.759 276.172 520.28 275.574C518.801 274.977 517.602 275.784 517.602 277.377C517.602 278.97 518.801 280.746 520.28 281.343Z",
  stroke: "#6E32F0",
  strokeWidth: 0.81737,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_565",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M509.172 253.718L522.133 248.432L540.367 255.765V287.021L528.006 292.478L509.172 284.974V253.718Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_12"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_566",
  d: "M219.528 471.793C219.528 468.111 228.211 465.126 238.922 465.126C249.633 465.126 258.316 468.111 258.316 471.793C258.316 475.475 249.633 478.46 238.922 478.46C228.211 478.46 219.528 475.475 219.528 471.793Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_567"
}, /*#__PURE__*/React.createElement("path", {
  d: "M259.544 471.789H257.12C257.12 472.195 256.882 472.761 256.043 473.443C255.213 474.117 253.939 474.778 252.258 475.356C248.905 476.509 244.196 477.243 238.938 477.243V479.667C244.39 479.667 249.378 478.91 253.046 477.649C254.874 477.02 256.44 476.246 257.572 475.324C258.696 474.412 259.544 473.224 259.544 471.789ZM238.938 479.667V477.243C233.679 477.243 228.97 476.509 225.618 475.356C223.936 474.778 222.662 474.117 221.832 473.443C220.993 472.761 220.756 472.195 220.756 471.789H218.331C218.331 473.224 219.18 474.412 220.304 475.324C221.436 476.246 223.002 477.02 224.83 477.649C228.498 478.91 233.486 479.667 238.938 479.667ZM218.331 471.789H220.756C220.756 471.382 220.993 470.816 221.832 470.134C222.662 469.46 223.936 468.799 225.618 468.221C228.97 467.068 233.679 466.334 238.938 466.334V463.91C233.486 463.91 228.498 464.667 224.83 465.928C223.002 466.557 221.436 467.332 220.304 468.253C219.18 469.165 218.331 470.353 218.331 471.789ZM238.938 463.91V466.334C244.196 466.334 248.905 467.068 252.258 468.221C253.939 468.799 255.213 469.46 256.043 470.134C256.882 470.816 257.12 471.382 257.12 471.789H259.544C259.544 470.353 258.696 469.165 257.572 468.253C256.44 467.332 254.874 466.557 253.046 465.928C249.378 464.667 244.39 463.91 238.938 463.91Z",
  fill: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.544 471.789H257.12M259.544 471.789C259.544 473.224 258.696 474.412 257.572 475.324C256.44 476.246 254.874 477.02 253.046 477.649C249.378 478.91 244.39 479.667 238.938 479.667M259.544 471.789C259.544 470.353 258.696 469.165 257.572 468.253C256.44 467.332 254.874 466.557 253.046 465.928C249.378 464.667 244.39 463.91 238.938 463.91M257.12 471.789C257.12 472.195 256.882 472.761 256.043 473.443C255.213 474.117 253.939 474.778 252.258 475.356C248.905 476.509 244.196 477.243 238.938 477.243M257.12 471.789C257.12 471.382 256.882 470.816 256.043 470.134C255.213 469.46 253.939 468.799 252.258 468.221C248.905 467.068 244.196 466.334 238.938 466.334M238.938 477.243V479.667M238.938 477.243C233.679 477.243 228.97 476.509 225.618 475.356C223.936 474.778 222.662 474.117 221.832 473.443C220.993 472.761 220.756 472.195 220.756 471.789M238.938 479.667C233.486 479.667 228.498 478.91 224.83 477.649C223.002 477.02 221.436 476.246 220.304 475.324C219.18 474.412 218.331 473.224 218.331 471.789M220.756 471.789H218.331M220.756 471.789C220.756 471.382 220.993 470.816 221.832 470.134C222.662 469.46 223.936 468.799 225.618 468.221C228.97 467.068 233.679 466.334 238.938 466.334M218.331 471.789C218.331 470.353 219.18 469.165 220.304 468.253C221.436 467.332 223.002 466.557 224.83 465.928C228.498 464.667 233.486 463.91 238.938 463.91M238.938 466.334V463.91",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_568",
  d: "M240.136 371.465H237.712V471.183H240.136V371.465Z",
  fill: "#6E32F0",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__L_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_569",
  d: "M235.833 396.143L223.356 401.226L242.105 408.801L254.582 403.718L235.833 396.143Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.04625,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_570",
  d: "M241.862 377.206L223.113 369.631V400.851L241.862 408.426V377.206Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.12284,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_571",
  d: "M235.79 364.453L223.313 369.536L242.062 377.111L254.54 372.028L235.79 364.453Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.04625,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_572",
  d: "M254.328 371.949L241.85 377.032V408.325L254.328 403.243V371.949Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.07548,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_573",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M223.154 369.612L236.115 364.326L254.349 371.659V402.915L241.988 408.372L223.154 400.868V369.612Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_13"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_574",
  d: "M361.627 495.328C361.627 491.646 370.31 488.661 381.021 488.661C391.732 488.661 400.415 491.646 400.415 495.328C400.415 499.01 391.732 501.995 381.021 501.995C370.31 501.995 361.627 499.01 361.627 495.328Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_575"
}, /*#__PURE__*/React.createElement("path", {
  d: "M401.642 495.324H399.218C399.218 495.73 398.981 496.296 398.142 496.978C397.312 497.652 396.038 498.313 394.356 498.891C391.004 500.044 386.294 500.778 381.036 500.778V503.203C386.488 503.203 391.476 502.445 395.144 501.184C396.972 500.555 398.538 499.781 399.67 498.859C400.794 497.947 401.642 496.759 401.642 495.324ZM381.036 503.203V500.778C375.778 500.778 371.069 500.044 367.716 498.891C366.035 498.313 364.761 497.652 363.931 496.978C363.092 496.296 362.854 495.73 362.854 495.324H360.43C360.43 496.759 361.278 497.947 362.402 498.859C363.534 499.781 365.1 500.555 366.928 501.184C370.596 502.445 375.584 503.203 381.036 503.203ZM360.43 495.324H362.854C362.854 494.918 363.092 494.352 363.931 493.669C364.761 492.995 366.035 492.335 367.716 491.756C371.069 490.604 375.778 489.869 381.036 489.869V487.445C375.584 487.445 370.596 488.202 366.928 489.463C365.1 490.092 363.534 490.867 362.402 491.788C361.278 492.701 360.43 493.889 360.43 495.324ZM381.036 487.445V489.869C386.294 489.869 391.004 490.604 394.356 491.756C396.038 492.335 397.312 492.995 398.142 493.669C398.981 494.352 399.218 494.918 399.218 495.324H401.642C401.642 493.889 400.794 492.701 399.67 491.788C398.538 490.867 396.972 490.092 395.144 489.463C391.476 488.202 386.488 487.445 381.036 487.445Z",
  fill: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M401.642 495.324H399.218M401.642 495.324C401.642 496.759 400.794 497.947 399.67 498.859C398.538 499.781 396.972 500.555 395.144 501.184C391.476 502.445 386.488 503.203 381.036 503.203M401.642 495.324C401.642 493.889 400.794 492.701 399.67 491.788C398.538 490.867 396.972 490.092 395.144 489.463C391.476 488.202 386.488 487.445 381.036 487.445M399.218 495.324C399.218 495.73 398.981 496.296 398.142 496.978C397.312 497.652 396.038 498.313 394.356 498.891C391.004 500.044 386.294 500.778 381.036 500.778M399.218 495.324C399.218 494.918 398.981 494.352 398.142 493.669C397.312 492.995 396.038 492.335 394.356 491.756C391.004 490.604 386.294 489.869 381.036 489.869M381.036 500.778V503.203M381.036 500.778C375.778 500.778 371.069 500.044 367.716 498.891C366.035 498.313 364.761 497.652 363.931 496.978C363.092 496.296 362.854 495.73 362.854 495.324M381.036 503.203C375.584 503.203 370.596 502.445 366.928 501.184C365.1 500.555 363.534 499.781 362.402 498.859C361.278 497.947 360.43 496.759 360.43 495.324M362.854 495.324H360.43M362.854 495.324C362.854 494.918 363.092 494.352 363.931 493.669C364.761 492.995 366.035 492.335 367.716 491.756C371.069 490.604 375.778 489.869 381.036 489.869M360.43 495.324C360.43 493.889 361.278 492.701 362.402 491.788C363.534 490.867 365.1 490.092 366.928 489.463C370.596 488.202 375.584 487.445 381.036 487.445M381.036 489.869V487.445",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_576",
  d: "M382.235 395H379.811V494.718H382.235V395Z",
  fill: "#6E32F0",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__RL_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_577",
  d: "M394.888 430.373L394.878 423.21L368.378 423.248L368.388 430.411L394.888 430.373Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.17845,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_578",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M394.837 398.588L394.875 430.369L368.378 430.408L368.331 398.631L394.837 398.588Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_579",
  d: "M394.844 398.596L394.834 391.433L368.334 391.47L368.344 398.633L394.844 398.596Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.17845,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_580",
  d: "M394.888 430.381L394.833 391.44L368.333 391.478L368.388 430.419L394.888 430.381Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__S_14"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_581",
  d: "M564.01 412.39C564.01 408.708 572.693 405.723 583.404 405.723C594.115 405.723 602.798 408.708 602.798 412.39C602.798 416.071 594.115 419.056 583.404 419.056C572.693 419.056 564.01 416.071 564.01 412.39Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_582"
}, /*#__PURE__*/React.createElement("path", {
  d: "M604.025 412.385H601.601C601.601 412.792 601.363 413.358 600.524 414.04C599.694 414.714 598.42 415.375 596.739 415.953C593.386 417.106 588.677 417.84 583.419 417.84V420.264C588.871 420.264 593.859 419.507 597.527 418.246C599.355 417.617 600.921 416.842 602.053 415.921C603.177 415.009 604.025 413.821 604.025 412.385ZM583.419 420.264V417.84C578.16 417.84 573.451 417.106 570.099 415.953C568.417 415.375 567.143 414.714 566.313 414.04C565.474 413.358 565.237 412.792 565.237 412.385H562.812C562.812 413.821 563.661 415.009 564.785 415.921C565.917 416.842 567.483 417.617 569.311 418.246C572.979 419.507 577.967 420.264 583.419 420.264ZM562.812 412.385H565.237C565.237 411.979 565.474 411.413 566.313 410.731C567.143 410.057 568.417 409.396 570.099 408.818C573.451 407.665 578.16 406.931 583.419 406.931V404.507C577.967 404.507 572.979 405.264 569.311 406.525C567.483 407.154 565.917 407.928 564.785 408.85C563.661 409.762 562.812 410.95 562.812 412.385ZM583.419 404.507V406.931C588.677 406.931 593.386 407.665 596.739 408.818C598.42 409.396 599.694 410.057 600.524 410.731C601.363 411.413 601.601 411.979 601.601 412.385H604.025C604.025 410.95 603.177 409.762 602.053 408.85C600.921 407.928 599.355 407.154 597.527 406.525C593.859 405.264 588.871 404.507 583.419 404.507Z",
  fill: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.025 412.385H601.601M604.025 412.385C604.025 413.821 603.177 415.009 602.053 415.921C600.921 416.842 599.355 417.617 597.527 418.246C593.859 419.507 588.871 420.264 583.419 420.264M604.025 412.385C604.025 410.95 603.177 409.762 602.053 408.85C600.921 407.928 599.355 407.154 597.527 406.525C593.859 405.264 588.871 404.507 583.419 404.507M601.601 412.385C601.601 412.792 601.363 413.358 600.524 414.04C599.694 414.714 598.42 415.375 596.739 415.953C593.386 417.106 588.677 417.84 583.419 417.84M601.601 412.385C601.601 411.979 601.363 411.413 600.524 410.731C599.694 410.057 598.42 409.396 596.739 408.818C593.386 407.665 588.677 406.931 583.419 406.931M583.419 417.84V420.264M583.419 417.84C578.16 417.84 573.451 417.106 570.099 415.953C568.417 415.375 567.143 414.714 566.313 414.04C565.474 413.358 565.237 412.792 565.237 412.385M583.419 420.264C577.967 420.264 572.979 419.507 569.311 418.246C567.483 417.617 565.917 416.842 564.785 415.921C563.661 415.009 562.812 413.821 562.812 412.385M565.237 412.385H562.812M565.237 412.385C565.237 411.979 565.474 411.413 566.313 410.731C567.143 410.057 568.417 409.396 570.099 408.818C573.451 407.665 578.16 406.931 583.419 406.931M562.812 412.385C562.812 410.95 563.661 409.762 564.785 408.85C565.917 407.928 567.483 407.154 569.311 406.525C572.979 405.264 577.967 404.507 583.419 404.507M583.419 406.931V404.507",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_583",
  d: "M584.618 312.062H582.194V411.779H584.618V312.062Z",
  fill: "#6E32F0",
  stroke: "#6E32F0",
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__RR_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_584",
  d: "M592.362 306.516L574.706 306.541L574.721 317.292L592.377 317.267L592.362 306.516Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.10703,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_585",
  d: "M592.42 348.195L574.764 348.22L574.72 317.288L592.376 317.262L592.42 348.195Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.37119,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_586",
  d: "M592.36 306.502L574.704 306.527L574.763 348.21L592.419 348.185L592.36 306.502Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__High_2"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__HL_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_587",
  d: "M195.305 199.572L180.002 190.765L164.403 217.873L179.706 226.679L195.305 199.572Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.36768,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_588",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164.401 217.878L185.36 181.452L200.679 190.266L179.704 226.683L164.401 217.878Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_589",
  d: "M200.668 190.247L185.365 181.441L180.003 190.759L195.306 199.565L200.668 190.247Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.10703,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__HR_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_590",
  d: "M400.903 139.997L400.893 132.834L374.392 132.872L374.403 140.035L400.903 139.997Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.17845,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_591",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M400.852 108.77L400.889 140.047L374.393 140.085L374.345 108.812L400.852 108.77Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_592",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M400.852 108.717L400.89 101.755L374.393 101.793L374.345 108.759L400.852 108.717Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_593",
  d: "M387.6 136.078C390.828 136.078 393.445 133.46 393.445 130.232C393.445 127.003 390.828 124.386 387.6 124.386C384.371 124.386 381.754 127.003 381.754 130.232C381.754 133.46 384.371 136.078 387.6 136.078Z",
  stroke: "#6E32F0",
  strokeWidth: 1.36859,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_594",
  d: "M387.615 132.769C389.285 132.769 390.638 131.415 390.638 129.746C390.638 128.076 389.285 126.723 387.615 126.723C385.946 126.723 384.592 128.076 384.592 129.746C384.592 131.415 385.946 132.769 387.615 132.769Z",
  stroke: "#6E32F0",
  strokeWidth: 0.958614,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_595",
  d: "M387.6 119.82C389.116 119.82 390.345 118.59 390.345 117.074C390.345 115.558 389.116 114.329 387.6 114.329C386.084 114.329 384.854 115.558 384.854 117.074C384.854 118.59 386.084 119.82 387.6 119.82Z",
  stroke: "#6E32F0",
  strokeWidth: 1.5,
  strokeMiterlimit: 3,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_596",
  d: "M400.902 140.029L400.848 101.671L374.347 101.709L374.402 140.067L400.902 140.029Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__HRL_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_597",
  d: "M397.943 303.032L397.933 295.869L371.433 295.906L371.443 303.069L397.943 303.032Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.17845,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_598",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.893 265.142L397.931 303.301L371.434 303.34L371.387 265.142L397.893 265.142Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.59279,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_599",
  d: "M397.943 303.064L397.888 264.706L371.388 264.743L371.442 303.102L397.943 303.064Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_600",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M371.402 275.493L371.446 303.079L371.497 296.461L371.396 268.783L371.402 275.493Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.16799,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__HRR_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_601",
  d: "M584.685 183.992L572.218 196.495L579.83 204.086L592.297 191.583L584.685 183.992Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.10703,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_602",
  d: "M584.674 183.983L572.207 196.486L601.724 225.919L614.191 213.416L584.674 183.983Z",
  stroke: "#6E32F0",
  strokeWidth: 2.2,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-headphones",
  className: "element-headphones"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_603"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M463.45 302.231C458.154 300.091 450.261 300.241 444.282 304.33C439.566 307.553 438.996 309.967 444.292 312.107C438.996 309.967 439.474 307.41 444.282 304.33C450.471 300.367 458.154 300.091 463.45 302.231Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444.282 304.33C450.261 300.241 458.154 300.091 463.45 302.231C458.154 300.091 450.471 300.367 444.282 304.33ZM444.282 304.33C439.566 307.553 438.996 309.967 444.292 312.107C438.996 309.967 439.474 307.41 444.282 304.33Z",
  stroke: "#8496B9",
  strokeWidth: 1.82873,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_604"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M463.454 304.794C458.157 302.654 450.265 302.805 444.286 306.893C439.57 310.117 438.999 312.531 444.296 314.671C438.999 312.531 439.478 309.974 444.286 306.893C450.475 302.93 458.157 302.654 463.454 304.794Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444.286 306.893C450.265 302.805 458.157 302.654 463.454 304.794C458.157 302.654 450.475 302.93 444.286 306.893ZM444.286 306.893C439.57 310.117 438.999 312.531 444.296 314.671C438.999 312.531 439.478 309.974 444.286 306.893Z",
  stroke: "#8496B9",
  strokeWidth: 1.82873,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_605",
  d: "M452.27 320.78C455.778 322.197 458.621 320.847 458.621 317.766C458.621 314.684 455.778 311.037 452.27 309.62C448.763 308.203 445.919 309.552 445.919 312.634C445.919 315.716 448.763 319.363 452.27 320.78Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.83585,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_606",
  d: "M449.62 322.568C453.127 323.985 455.971 322.635 455.971 319.554C455.971 316.472 453.127 312.825 449.62 311.408C446.113 309.99 443.269 311.34 443.269 314.422C443.269 317.503 446.113 321.151 449.62 322.568Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.83585,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_607",
  d: "M444.063 311.89L447.742 309.403",
  stroke: "#8496B9",
  strokeWidth: 2.16057,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_608",
  d: "M453.912 322.892L457.59 320.405",
  stroke: "#8496B9",
  strokeWidth: 2.16057,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_609",
  d: "M468.559 312.726C472.066 314.143 474.909 312.794 474.909 309.712C474.909 306.63 472.066 302.983 468.559 301.566C465.051 300.149 462.208 301.498 462.208 304.58C462.208 307.662 465.051 311.309 468.559 312.726Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.83585,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_610",
  d: "M465.908 314.514C469.415 315.931 472.259 314.582 472.259 311.5C472.259 308.418 469.415 304.771 465.908 303.354C462.4 301.937 459.557 303.286 459.557 306.368C459.557 309.45 462.4 313.097 465.908 314.514Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.83585,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_611",
  d: "M466.408 311.38C468.271 312.133 469.781 311.416 469.781 309.78C469.781 308.143 468.271 306.206 466.408 305.453C464.546 304.701 463.035 305.417 463.035 307.054C463.035 308.691 464.546 310.628 466.408 311.38Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.91825,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_612",
  d: "M460.352 303.836L464.031 301.349",
  stroke: "#8496B9",
  strokeWidth: 2.16057,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_613",
  d: "M470.201 314.838L473.879 312.351",
  stroke: "#8496B9",
  strokeWidth: 2.16057,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__element-headphones-active",
  className: "element-headphones-active"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_614"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M463.45 302.231C458.154 300.091 450.261 300.241 444.282 304.33C439.566 307.553 438.996 309.967 444.292 312.107C438.996 309.967 439.474 307.41 444.282 304.33C450.471 300.367 458.154 300.091 463.45 302.231Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444.282 304.33C450.261 300.241 458.154 300.091 463.45 302.231C458.154 300.091 450.471 300.367 444.282 304.33ZM444.282 304.33C439.566 307.553 438.996 309.967 444.292 312.107C438.996 309.967 439.474 307.41 444.282 304.33Z",
  stroke: "#6E32F0",
  strokeWidth: 1.82873,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Vector_615"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M463.454 304.794C458.157 302.654 450.265 302.805 444.286 306.893C439.57 310.117 438.999 312.531 444.296 314.671C438.999 312.531 439.478 309.974 444.286 306.893C450.475 302.93 458.157 302.654 463.454 304.794Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444.286 306.893C450.265 302.805 458.157 302.654 463.454 304.794C458.157 302.654 450.475 302.93 444.286 306.893ZM444.286 306.893C439.57 310.117 438.999 312.531 444.296 314.671C438.999 312.531 439.478 309.974 444.286 306.893Z",
  stroke: "#6E32F0",
  strokeWidth: 1.82873,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_616",
  d: "M452.27 320.78C455.778 322.197 458.621 320.847 458.621 317.766C458.621 314.684 455.778 311.037 452.27 309.62C448.763 308.203 445.919 309.552 445.919 312.634C445.919 315.716 448.763 319.363 452.27 320.78Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.83585,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_617",
  d: "M449.62 322.568C453.127 323.985 455.971 322.635 455.971 319.554C455.971 316.472 453.127 312.825 449.62 311.408C446.113 309.99 443.269 311.34 443.269 314.422C443.269 317.503 446.113 321.151 449.62 322.568Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.83585,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_618",
  d: "M444.063 311.89L447.742 309.403",
  stroke: "#6E32F0",
  strokeWidth: 2.16057,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_619",
  d: "M453.912 322.892L457.59 320.405",
  stroke: "#6E32F0",
  strokeWidth: 2.16057,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_620",
  d: "M468.559 312.726C472.066 314.143 474.909 312.794 474.909 309.712C474.909 306.63 472.066 302.983 468.559 301.566C465.051 300.149 462.208 301.498 462.208 304.58C462.208 307.662 465.051 311.309 468.559 312.726Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.83585,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_621",
  d: "M465.908 314.514C469.415 315.931 472.259 314.582 472.259 311.5C472.259 308.418 469.415 304.771 465.908 303.354C462.4 301.937 459.557 303.286 459.557 306.368C459.557 309.45 462.4 313.097 465.908 314.514Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.83585,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_622",
  d: "M466.408 311.38C468.271 312.133 469.781 311.416 469.781 309.78C469.781 308.143 468.271 306.206 466.408 305.453C464.546 304.701 463.035 305.417 463.035 307.054C463.035 308.691 464.546 310.628 466.408 311.38Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 0.91825,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_623",
  d: "M460.352 303.836L464.031 301.349",
  stroke: "#6E32F0",
  strokeWidth: 2.16057,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Vector_624",
  d: "M470.201 314.838L473.879 312.351",
  stroke: "#6E32F0",
  strokeWidth: 2.16057,
  strokeMiterlimit: 1.5,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__label-interface",
  className: "label-interface",
  filter: "url(#control-room_svg__filter0_d_7074_1985)"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__text"
}, /*#__PURE__*/React.createElement("rect", {
  x: 201.141,
  y: 317.5,
  width: 105,
  height: 24,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Tooltip",
  d: "M209.555 334.5L213.383 326.04H214.679L218.555 334.5H216.983L215.951 332.124L216.575 332.544H211.499L212.147 332.124L211.115 334.5H209.555ZM214.019 327.696L212.327 331.704L212.015 331.332H216.047L215.795 331.704L214.067 327.696H214.019ZM221.555 334.62C220.811 334.62 220.255 334.416 219.887 334.008C219.519 333.6 219.335 332.976 219.335 332.136V328.44H220.835V332.124C220.835 332.572 220.927 332.904 221.111 333.12C221.295 333.328 221.575 333.432 221.951 333.432C222.375 333.432 222.719 333.288 222.983 333C223.255 332.712 223.391 332.332 223.391 331.86V328.44H224.891V334.5H223.427V333.264H223.595C223.419 333.696 223.151 334.032 222.791 334.272C222.439 334.504 222.027 334.62 221.555 334.62ZM228.871 334.62C228.343 334.62 227.875 334.496 227.467 334.248C227.067 333.992 226.755 333.628 226.531 333.156C226.307 332.684 226.195 332.12 226.195 331.464C226.195 330.808 226.307 330.248 226.531 329.784C226.755 329.312 227.067 328.952 227.467 328.704C227.875 328.448 228.343 328.32 228.871 328.32C229.375 328.32 229.819 328.444 230.203 328.692C230.595 328.932 230.855 329.26 230.983 329.676H230.827V325.668H232.327V334.5H230.851V333.216H230.995C230.867 333.648 230.607 333.992 230.215 334.248C229.831 334.496 229.383 334.62 228.871 334.62ZM229.291 333.468C229.763 333.468 230.143 333.304 230.431 332.976C230.719 332.64 230.863 332.136 230.863 331.464C230.863 330.792 230.719 330.292 230.431 329.964C230.143 329.636 229.763 329.472 229.291 329.472C228.819 329.472 228.435 329.636 228.139 329.964C227.851 330.292 227.707 330.792 227.707 331.464C227.707 332.136 227.851 332.64 228.139 332.976C228.435 333.304 228.819 333.468 229.291 333.468ZM233.961 334.5V328.44H235.461V334.5H233.961ZM233.877 327.3V325.836H235.545V327.3H233.877ZM239.825 334.62C239.201 334.62 238.661 334.492 238.205 334.236C237.749 333.98 237.393 333.616 237.137 333.144C236.889 332.672 236.765 332.112 236.765 331.464C236.765 330.816 236.889 330.26 237.137 329.796C237.393 329.324 237.749 328.96 238.205 328.704C238.661 328.448 239.201 328.32 239.825 328.32C240.449 328.32 240.989 328.448 241.445 328.704C241.909 328.96 242.265 329.324 242.513 329.796C242.769 330.26 242.897 330.816 242.897 331.464C242.897 332.112 242.769 332.672 242.513 333.144C242.265 333.616 241.909 333.98 241.445 334.236C240.989 334.492 240.449 334.62 239.825 334.62ZM239.825 333.468C240.297 333.468 240.673 333.304 240.953 332.976C241.233 332.64 241.373 332.136 241.373 331.464C241.373 330.792 241.233 330.292 240.953 329.964C240.673 329.636 240.297 329.472 239.825 329.472C239.353 329.472 238.977 329.636 238.697 329.964C238.417 330.292 238.277 330.792 238.277 331.464C238.277 332.136 238.417 332.64 238.697 332.976C238.977 333.304 239.353 333.468 239.825 333.468ZM247.604 334.5V326.04H249.152V334.5H247.604ZM250.894 334.5V329.952C250.894 329.704 250.886 329.452 250.87 329.196C250.854 328.94 250.83 328.688 250.798 328.44H252.25L252.37 329.64H252.226C252.418 329.216 252.702 328.892 253.078 328.668C253.454 328.436 253.89 328.32 254.386 328.32C255.098 328.32 255.634 328.52 255.994 328.92C256.354 329.32 256.534 329.944 256.534 330.792V334.5H255.034V330.864C255.034 330.376 254.938 330.028 254.746 329.82C254.562 329.604 254.282 329.496 253.906 329.496C253.442 329.496 253.074 329.64 252.802 329.928C252.53 330.216 252.394 330.6 252.394 331.08V334.5H250.894ZM260.717 334.62C259.997 334.62 259.453 334.432 259.085 334.056C258.717 333.68 258.533 333.116 258.533 332.364V329.568H257.369V328.44H258.533V326.892L260.033 326.508V328.44H261.653V329.568H260.033V332.268C260.033 332.684 260.113 332.976 260.273 333.144C260.433 333.312 260.653 333.396 260.933 333.396C261.085 333.396 261.213 333.384 261.317 333.36C261.429 333.336 261.537 333.304 261.641 333.264V334.452C261.505 334.508 261.353 334.548 261.185 334.572C261.025 334.604 260.869 334.62 260.717 334.62ZM265.541 334.62C264.525 334.62 263.729 334.34 263.153 333.78C262.577 333.22 262.289 332.452 262.289 331.476C262.289 330.844 262.413 330.292 262.661 329.82C262.909 329.348 263.253 328.98 263.693 328.716C264.141 328.452 264.661 328.32 265.253 328.32C265.837 328.32 266.325 328.444 266.717 328.692C267.109 328.94 267.405 329.288 267.605 329.736C267.813 330.184 267.917 330.708 267.917 331.308V331.704H263.501V330.912H266.849L266.645 331.08C266.645 330.52 266.525 330.092 266.285 329.796C266.053 329.5 265.713 329.352 265.265 329.352C264.769 329.352 264.385 329.528 264.113 329.88C263.849 330.232 263.717 330.724 263.717 331.356V331.512C263.717 332.168 263.877 332.66 264.197 332.988C264.525 333.308 264.985 333.468 265.577 333.468C265.921 333.468 266.241 333.424 266.537 333.336C266.841 333.24 267.129 333.088 267.401 332.88L267.845 333.888C267.557 334.12 267.213 334.3 266.813 334.428C266.413 334.556 265.989 334.62 265.541 334.62ZM269.175 334.5V329.988C269.175 329.732 269.167 329.472 269.151 329.208C269.143 328.944 269.123 328.688 269.091 328.44H270.543L270.711 330.096H270.471C270.551 329.696 270.683 329.364 270.867 329.1C271.059 328.836 271.291 328.64 271.563 328.512C271.835 328.384 272.131 328.32 272.451 328.32C272.595 328.32 272.711 328.328 272.799 328.344C272.887 328.352 272.975 328.372 273.063 328.404L273.051 329.724C272.899 329.66 272.767 329.62 272.655 329.604C272.551 329.588 272.419 329.58 272.259 329.58C271.915 329.58 271.623 329.652 271.383 329.796C271.151 329.94 270.975 330.14 270.855 330.396C270.743 330.652 270.687 330.944 270.687 331.272V334.5H269.175ZM274.646 334.5V329.568H273.482V328.44H275.066L274.646 328.824V327.9C274.646 327.148 274.838 326.58 275.222 326.196C275.614 325.812 276.186 325.62 276.938 325.62C277.114 325.62 277.298 325.632 277.49 325.656C277.69 325.68 277.862 325.724 278.006 325.788V326.964C277.902 326.924 277.778 326.892 277.634 326.868C277.49 326.844 277.35 326.832 277.214 326.832C277.006 326.832 276.818 326.872 276.65 326.952C276.49 327.032 276.362 327.156 276.266 327.324C276.178 327.484 276.134 327.7 276.134 327.972V328.704L275.918 328.44H277.73V329.568H276.146V334.5H274.646ZM280.937 334.62C280.409 334.62 279.945 334.496 279.545 334.248C279.145 333.992 278.833 333.628 278.609 333.156C278.385 332.684 278.273 332.12 278.273 331.464C278.273 330.808 278.385 330.248 278.609 329.784C278.833 329.312 279.145 328.952 279.545 328.704C279.945 328.448 280.409 328.32 280.937 328.32C281.449 328.32 281.897 328.448 282.281 328.704C282.673 328.952 282.933 329.288 283.061 329.712H282.929L283.061 328.44H284.501C284.477 328.688 284.453 328.94 284.429 329.196C284.413 329.452 284.405 329.704 284.405 329.952V334.5H282.917L282.905 333.252H283.049C282.921 333.668 282.661 334 282.269 334.248C281.877 334.496 281.433 334.62 280.937 334.62ZM281.357 333.468C281.829 333.468 282.209 333.304 282.497 332.976C282.785 332.64 282.929 332.136 282.929 331.464C282.929 330.792 282.785 330.292 282.497 329.964C282.209 329.636 281.829 329.472 281.357 329.472C280.885 329.472 280.505 329.636 280.217 329.964C279.929 330.292 279.785 330.792 279.785 331.464C279.785 332.136 279.925 332.64 280.205 332.976C280.493 333.304 280.877 333.468 281.357 333.468ZM288.823 334.62C288.199 334.62 287.651 334.492 287.179 334.236C286.715 333.98 286.355 333.616 286.099 333.144C285.843 332.664 285.715 332.096 285.715 331.44C285.715 330.784 285.843 330.224 286.099 329.76C286.363 329.296 286.727 328.94 287.191 328.692C287.655 328.444 288.199 328.32 288.823 328.32C289.223 328.32 289.611 328.384 289.987 328.512C290.371 328.632 290.683 328.808 290.923 329.04L290.467 330.084C290.251 329.884 290.007 329.736 289.735 329.64C289.471 329.536 289.211 329.484 288.955 329.484C288.419 329.484 287.999 329.652 287.695 329.988C287.399 330.324 287.251 330.812 287.251 331.452C287.251 332.092 287.399 332.584 287.695 332.928C287.999 333.272 288.419 333.444 288.955 333.444C289.203 333.444 289.459 333.396 289.723 333.3C289.995 333.204 290.243 333.056 290.467 332.856L290.923 333.888C290.675 334.12 290.359 334.3 289.975 334.428C289.599 334.556 289.215 334.62 288.823 334.62ZM294.896 334.62C293.88 334.62 293.084 334.34 292.508 333.78C291.932 333.22 291.644 332.452 291.644 331.476C291.644 330.844 291.768 330.292 292.016 329.82C292.264 329.348 292.608 328.98 293.048 328.716C293.496 328.452 294.016 328.32 294.608 328.32C295.192 328.32 295.68 328.444 296.072 328.692C296.464 328.94 296.76 329.288 296.96 329.736C297.168 330.184 297.272 330.708 297.272 331.308V331.704H292.856V330.912H296.204L296 331.08C296 330.52 295.88 330.092 295.64 329.796C295.408 329.5 295.068 329.352 294.62 329.352C294.124 329.352 293.74 329.528 293.468 329.88C293.204 330.232 293.072 330.724 293.072 331.356V331.512C293.072 332.168 293.232 332.66 293.552 332.988C293.88 333.308 294.34 333.468 294.932 333.468C295.276 333.468 295.596 333.424 295.892 333.336C296.196 333.24 296.484 333.088 296.756 332.88L297.2 333.888C296.912 334.12 296.568 334.3 296.168 334.428C295.768 334.556 295.344 334.62 294.896 334.62Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__tip"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Polygon 4",
  d: "M314.141 329.5L306.141 334.5L306.141 329.5L306.141 324.5L314.141 329.5Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__label-interface-active",
  className: "label-interface-active",
  filter: "url(#control-room_svg__filter1_d_7074_1985)"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__text_2"
}, /*#__PURE__*/React.createElement("rect", {
  x: 201.641,
  y: 318,
  width: 104,
  height: 23,
  rx: 1.5,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 201.641,
  y: 318,
  width: 104,
  height: 23,
  rx: 1.5,
  stroke: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Tooltip_2",
  d: "M209.555 334.5L213.383 326.04H214.679L218.555 334.5H216.983L215.951 332.124L216.575 332.544H211.499L212.147 332.124L211.115 334.5H209.555ZM214.019 327.696L212.327 331.704L212.015 331.332H216.047L215.795 331.704L214.067 327.696H214.019ZM221.555 334.62C220.811 334.62 220.255 334.416 219.887 334.008C219.519 333.6 219.335 332.976 219.335 332.136V328.44H220.835V332.124C220.835 332.572 220.927 332.904 221.111 333.12C221.295 333.328 221.575 333.432 221.951 333.432C222.375 333.432 222.719 333.288 222.983 333C223.255 332.712 223.391 332.332 223.391 331.86V328.44H224.891V334.5H223.427V333.264H223.595C223.419 333.696 223.151 334.032 222.791 334.272C222.439 334.504 222.027 334.62 221.555 334.62ZM228.871 334.62C228.343 334.62 227.875 334.496 227.467 334.248C227.067 333.992 226.755 333.628 226.531 333.156C226.307 332.684 226.195 332.12 226.195 331.464C226.195 330.808 226.307 330.248 226.531 329.784C226.755 329.312 227.067 328.952 227.467 328.704C227.875 328.448 228.343 328.32 228.871 328.32C229.375 328.32 229.819 328.444 230.203 328.692C230.595 328.932 230.855 329.26 230.983 329.676H230.827V325.668H232.327V334.5H230.851V333.216H230.995C230.867 333.648 230.607 333.992 230.215 334.248C229.831 334.496 229.383 334.62 228.871 334.62ZM229.291 333.468C229.763 333.468 230.143 333.304 230.431 332.976C230.719 332.64 230.863 332.136 230.863 331.464C230.863 330.792 230.719 330.292 230.431 329.964C230.143 329.636 229.763 329.472 229.291 329.472C228.819 329.472 228.435 329.636 228.139 329.964C227.851 330.292 227.707 330.792 227.707 331.464C227.707 332.136 227.851 332.64 228.139 332.976C228.435 333.304 228.819 333.468 229.291 333.468ZM233.961 334.5V328.44H235.461V334.5H233.961ZM233.877 327.3V325.836H235.545V327.3H233.877ZM239.825 334.62C239.201 334.62 238.661 334.492 238.205 334.236C237.749 333.98 237.393 333.616 237.137 333.144C236.889 332.672 236.765 332.112 236.765 331.464C236.765 330.816 236.889 330.26 237.137 329.796C237.393 329.324 237.749 328.96 238.205 328.704C238.661 328.448 239.201 328.32 239.825 328.32C240.449 328.32 240.989 328.448 241.445 328.704C241.909 328.96 242.265 329.324 242.513 329.796C242.769 330.26 242.897 330.816 242.897 331.464C242.897 332.112 242.769 332.672 242.513 333.144C242.265 333.616 241.909 333.98 241.445 334.236C240.989 334.492 240.449 334.62 239.825 334.62ZM239.825 333.468C240.297 333.468 240.673 333.304 240.953 332.976C241.233 332.64 241.373 332.136 241.373 331.464C241.373 330.792 241.233 330.292 240.953 329.964C240.673 329.636 240.297 329.472 239.825 329.472C239.353 329.472 238.977 329.636 238.697 329.964C238.417 330.292 238.277 330.792 238.277 331.464C238.277 332.136 238.417 332.64 238.697 332.976C238.977 333.304 239.353 333.468 239.825 333.468ZM247.604 334.5V326.04H249.152V334.5H247.604ZM250.894 334.5V329.952C250.894 329.704 250.886 329.452 250.87 329.196C250.854 328.94 250.83 328.688 250.798 328.44H252.25L252.37 329.64H252.226C252.418 329.216 252.702 328.892 253.078 328.668C253.454 328.436 253.89 328.32 254.386 328.32C255.098 328.32 255.634 328.52 255.994 328.92C256.354 329.32 256.534 329.944 256.534 330.792V334.5H255.034V330.864C255.034 330.376 254.938 330.028 254.746 329.82C254.562 329.604 254.282 329.496 253.906 329.496C253.442 329.496 253.074 329.64 252.802 329.928C252.53 330.216 252.394 330.6 252.394 331.08V334.5H250.894ZM260.717 334.62C259.997 334.62 259.453 334.432 259.085 334.056C258.717 333.68 258.533 333.116 258.533 332.364V329.568H257.369V328.44H258.533V326.892L260.033 326.508V328.44H261.653V329.568H260.033V332.268C260.033 332.684 260.113 332.976 260.273 333.144C260.433 333.312 260.653 333.396 260.933 333.396C261.085 333.396 261.213 333.384 261.317 333.36C261.429 333.336 261.537 333.304 261.641 333.264V334.452C261.505 334.508 261.353 334.548 261.185 334.572C261.025 334.604 260.869 334.62 260.717 334.62ZM265.541 334.62C264.525 334.62 263.729 334.34 263.153 333.78C262.577 333.22 262.289 332.452 262.289 331.476C262.289 330.844 262.413 330.292 262.661 329.82C262.909 329.348 263.253 328.98 263.693 328.716C264.141 328.452 264.661 328.32 265.253 328.32C265.837 328.32 266.325 328.444 266.717 328.692C267.109 328.94 267.405 329.288 267.605 329.736C267.813 330.184 267.917 330.708 267.917 331.308V331.704H263.501V330.912H266.849L266.645 331.08C266.645 330.52 266.525 330.092 266.285 329.796C266.053 329.5 265.713 329.352 265.265 329.352C264.769 329.352 264.385 329.528 264.113 329.88C263.849 330.232 263.717 330.724 263.717 331.356V331.512C263.717 332.168 263.877 332.66 264.197 332.988C264.525 333.308 264.985 333.468 265.577 333.468C265.921 333.468 266.241 333.424 266.537 333.336C266.841 333.24 267.129 333.088 267.401 332.88L267.845 333.888C267.557 334.12 267.213 334.3 266.813 334.428C266.413 334.556 265.989 334.62 265.541 334.62ZM269.175 334.5V329.988C269.175 329.732 269.167 329.472 269.151 329.208C269.143 328.944 269.123 328.688 269.091 328.44H270.543L270.711 330.096H270.471C270.551 329.696 270.683 329.364 270.867 329.1C271.059 328.836 271.291 328.64 271.563 328.512C271.835 328.384 272.131 328.32 272.451 328.32C272.595 328.32 272.711 328.328 272.799 328.344C272.887 328.352 272.975 328.372 273.063 328.404L273.051 329.724C272.899 329.66 272.767 329.62 272.655 329.604C272.551 329.588 272.419 329.58 272.259 329.58C271.915 329.58 271.623 329.652 271.383 329.796C271.151 329.94 270.975 330.14 270.855 330.396C270.743 330.652 270.687 330.944 270.687 331.272V334.5H269.175ZM274.646 334.5V329.568H273.482V328.44H275.066L274.646 328.824V327.9C274.646 327.148 274.838 326.58 275.222 326.196C275.614 325.812 276.186 325.62 276.938 325.62C277.114 325.62 277.298 325.632 277.49 325.656C277.69 325.68 277.862 325.724 278.006 325.788V326.964C277.902 326.924 277.778 326.892 277.634 326.868C277.49 326.844 277.35 326.832 277.214 326.832C277.006 326.832 276.818 326.872 276.65 326.952C276.49 327.032 276.362 327.156 276.266 327.324C276.178 327.484 276.134 327.7 276.134 327.972V328.704L275.918 328.44H277.73V329.568H276.146V334.5H274.646ZM280.937 334.62C280.409 334.62 279.945 334.496 279.545 334.248C279.145 333.992 278.833 333.628 278.609 333.156C278.385 332.684 278.273 332.12 278.273 331.464C278.273 330.808 278.385 330.248 278.609 329.784C278.833 329.312 279.145 328.952 279.545 328.704C279.945 328.448 280.409 328.32 280.937 328.32C281.449 328.32 281.897 328.448 282.281 328.704C282.673 328.952 282.933 329.288 283.061 329.712H282.929L283.061 328.44H284.501C284.477 328.688 284.453 328.94 284.429 329.196C284.413 329.452 284.405 329.704 284.405 329.952V334.5H282.917L282.905 333.252H283.049C282.921 333.668 282.661 334 282.269 334.248C281.877 334.496 281.433 334.62 280.937 334.62ZM281.357 333.468C281.829 333.468 282.209 333.304 282.497 332.976C282.785 332.64 282.929 332.136 282.929 331.464C282.929 330.792 282.785 330.292 282.497 329.964C282.209 329.636 281.829 329.472 281.357 329.472C280.885 329.472 280.505 329.636 280.217 329.964C279.929 330.292 279.785 330.792 279.785 331.464C279.785 332.136 279.925 332.64 280.205 332.976C280.493 333.304 280.877 333.468 281.357 333.468ZM288.823 334.62C288.199 334.62 287.651 334.492 287.179 334.236C286.715 333.98 286.355 333.616 286.099 333.144C285.843 332.664 285.715 332.096 285.715 331.44C285.715 330.784 285.843 330.224 286.099 329.76C286.363 329.296 286.727 328.94 287.191 328.692C287.655 328.444 288.199 328.32 288.823 328.32C289.223 328.32 289.611 328.384 289.987 328.512C290.371 328.632 290.683 328.808 290.923 329.04L290.467 330.084C290.251 329.884 290.007 329.736 289.735 329.64C289.471 329.536 289.211 329.484 288.955 329.484C288.419 329.484 287.999 329.652 287.695 329.988C287.399 330.324 287.251 330.812 287.251 331.452C287.251 332.092 287.399 332.584 287.695 332.928C287.999 333.272 288.419 333.444 288.955 333.444C289.203 333.444 289.459 333.396 289.723 333.3C289.995 333.204 290.243 333.056 290.467 332.856L290.923 333.888C290.675 334.12 290.359 334.3 289.975 334.428C289.599 334.556 289.215 334.62 288.823 334.62ZM294.896 334.62C293.88 334.62 293.084 334.34 292.508 333.78C291.932 333.22 291.644 332.452 291.644 331.476C291.644 330.844 291.768 330.292 292.016 329.82C292.264 329.348 292.608 328.98 293.048 328.716C293.496 328.452 294.016 328.32 294.608 328.32C295.192 328.32 295.68 328.444 296.072 328.692C296.464 328.94 296.76 329.288 296.96 329.736C297.168 330.184 297.272 330.708 297.272 331.308V331.704H292.856V330.912H296.204L296 331.08C296 330.52 295.88 330.092 295.64 329.796C295.408 329.5 295.068 329.352 294.62 329.352C294.124 329.352 293.74 329.528 293.468 329.88C293.204 330.232 293.072 330.724 293.072 331.356V331.512C293.072 332.168 293.232 332.66 293.552 332.988C293.88 333.308 294.34 333.468 294.932 333.468C295.276 333.468 295.596 333.424 295.892 333.336C296.196 333.24 296.484 333.088 296.756 332.88L297.2 333.888C296.912 334.12 296.568 334.3 296.168 334.428C295.768 334.556 295.344 334.62 294.896 334.62Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__tip_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Polygon 4_2",
  d: "M314.141 329.5L306.141 334.5L306.141 329.5L306.141 324.5L314.141 329.5Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__label-speakers",
  className: "label-speakers",
  filter: "url(#control-room_svg__filter2_d_7074_1985)"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__text_3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 338.57,
  y: 62.5,
  width: 96,
  height: 24,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Tooltip_3",
  d: "M347.727 79.5V71.04H349.275V78.192H353.259V79.5H347.727ZM356.999 79.62C356.375 79.62 355.835 79.492 355.379 79.236C354.923 78.98 354.567 78.616 354.311 78.144C354.063 77.672 353.939 77.112 353.939 76.464C353.939 75.816 354.063 75.26 354.311 74.796C354.567 74.324 354.923 73.96 355.379 73.704C355.835 73.448 356.375 73.32 356.999 73.32C357.623 73.32 358.163 73.448 358.619 73.704C359.083 73.96 359.439 74.324 359.687 74.796C359.943 75.26 360.071 75.816 360.071 76.464C360.071 77.112 359.943 77.672 359.687 78.144C359.439 78.616 359.083 78.98 358.619 79.236C358.163 79.492 357.623 79.62 356.999 79.62ZM356.999 78.468C357.471 78.468 357.847 78.304 358.127 77.976C358.407 77.64 358.547 77.136 358.547 76.464C358.547 75.792 358.407 75.292 358.127 74.964C357.847 74.636 357.471 74.472 356.999 74.472C356.527 74.472 356.151 74.636 355.871 74.964C355.591 75.292 355.451 75.792 355.451 76.464C355.451 77.136 355.591 77.64 355.871 77.976C356.151 78.304 356.527 78.468 356.999 78.468ZM363.549 79.62C362.805 79.62 362.249 79.416 361.881 79.008C361.513 78.6 361.329 77.976 361.329 77.136V73.44H362.829V77.124C362.829 77.572 362.921 77.904 363.105 78.12C363.289 78.328 363.569 78.432 363.945 78.432C364.369 78.432 364.713 78.288 364.977 78C365.249 77.712 365.385 77.332 365.385 76.86V73.44H366.885V79.5H365.421V78.264H365.589C365.413 78.696 365.145 79.032 364.785 79.272C364.433 79.504 364.021 79.62 363.549 79.62ZM370.865 79.62C370.337 79.62 369.869 79.496 369.461 79.248C369.061 78.992 368.749 78.628 368.525 78.156C368.301 77.684 368.189 77.12 368.189 76.464C368.189 75.808 368.301 75.248 368.525 74.784C368.749 74.312 369.061 73.952 369.461 73.704C369.869 73.448 370.337 73.32 370.865 73.32C371.369 73.32 371.813 73.444 372.197 73.692C372.589 73.932 372.849 74.26 372.977 74.676H372.821V70.668H374.321V79.5H372.845V78.216H372.989C372.861 78.648 372.601 78.992 372.209 79.248C371.825 79.496 371.377 79.62 370.865 79.62ZM371.285 78.468C371.757 78.468 372.137 78.304 372.425 77.976C372.713 77.64 372.857 77.136 372.857 76.464C372.857 75.792 372.713 75.292 372.425 74.964C372.137 74.636 371.757 74.472 371.285 74.472C370.813 74.472 370.429 74.636 370.133 74.964C369.845 75.292 369.701 75.792 369.701 76.464C369.701 77.136 369.845 77.64 370.133 77.976C370.429 78.304 370.813 78.468 371.285 78.468ZM378.115 79.62C377.595 79.62 377.115 79.56 376.675 79.44C376.243 79.312 375.879 79.136 375.583 78.912L376.003 77.904C376.307 78.112 376.643 78.272 377.011 78.384C377.379 78.496 377.751 78.552 378.127 78.552C378.527 78.552 378.823 78.484 379.015 78.348C379.215 78.212 379.315 78.028 379.315 77.796C379.315 77.612 379.251 77.468 379.123 77.364C379.003 77.252 378.807 77.168 378.535 77.112L377.335 76.884C376.823 76.772 376.431 76.58 376.159 76.308C375.895 76.036 375.763 75.68 375.763 75.24C375.763 74.864 375.863 74.532 376.063 74.244C376.271 73.956 376.563 73.732 376.939 73.572C377.323 73.404 377.771 73.32 378.283 73.32C378.731 73.32 379.151 73.38 379.543 73.5C379.943 73.62 380.279 73.8 380.551 74.04L380.119 75.012C379.871 74.812 379.587 74.656 379.267 74.544C378.947 74.432 378.635 74.376 378.331 74.376C377.915 74.376 377.611 74.452 377.419 74.604C377.227 74.748 377.131 74.936 377.131 75.168C377.131 75.344 377.187 75.492 377.299 75.612C377.419 75.724 377.603 75.808 377.851 75.864L379.051 76.092C379.587 76.196 379.991 76.38 380.263 76.644C380.543 76.9 380.683 77.252 380.683 77.7C380.683 78.1 380.575 78.444 380.359 78.732C380.143 79.02 379.843 79.24 379.459 79.392C379.075 79.544 378.627 79.62 378.115 79.62ZM381.966 82.092V74.952C381.966 74.704 381.958 74.452 381.942 74.196C381.926 73.94 381.902 73.688 381.87 73.44H383.322L383.454 74.712H383.322C383.442 74.288 383.694 73.952 384.078 73.704C384.47 73.448 384.922 73.32 385.434 73.32C385.97 73.32 386.438 73.448 386.838 73.704C387.238 73.952 387.55 74.312 387.774 74.784C387.998 75.248 388.11 75.808 388.11 76.464C388.11 77.12 387.998 77.684 387.774 78.156C387.55 78.628 387.238 78.992 386.838 79.248C386.438 79.496 385.97 79.62 385.434 79.62C384.93 79.62 384.486 79.496 384.102 79.248C383.718 79 383.462 78.668 383.334 78.252H383.466V82.092H381.966ZM385.014 78.468C385.494 78.468 385.878 78.304 386.166 77.976C386.454 77.64 386.598 77.136 386.598 76.464C386.598 75.792 386.454 75.292 386.166 74.964C385.878 74.636 385.494 74.472 385.014 74.472C384.542 74.472 384.162 74.636 383.874 74.964C383.586 75.292 383.442 75.792 383.442 76.464C383.442 77.136 383.586 77.64 383.874 77.976C384.162 78.304 384.542 78.468 385.014 78.468ZM392.336 79.62C391.32 79.62 390.524 79.34 389.948 78.78C389.372 78.22 389.084 77.452 389.084 76.476C389.084 75.844 389.208 75.292 389.456 74.82C389.704 74.348 390.048 73.98 390.488 73.716C390.936 73.452 391.456 73.32 392.048 73.32C392.632 73.32 393.12 73.444 393.512 73.692C393.904 73.94 394.2 74.288 394.4 74.736C394.608 75.184 394.712 75.708 394.712 76.308V76.704H390.296V75.912H393.644L393.44 76.08C393.44 75.52 393.32 75.092 393.08 74.796C392.848 74.5 392.508 74.352 392.06 74.352C391.564 74.352 391.18 74.528 390.908 74.88C390.644 75.232 390.512 75.724 390.512 76.356V76.512C390.512 77.168 390.672 77.66 390.992 77.988C391.32 78.308 391.78 78.468 392.372 78.468C392.716 78.468 393.036 78.424 393.332 78.336C393.636 78.24 393.924 78.088 394.196 77.88L394.64 78.888C394.352 79.12 394.008 79.3 393.608 79.428C393.208 79.556 392.784 79.62 392.336 79.62ZM398.322 79.62C397.794 79.62 397.33 79.496 396.93 79.248C396.53 78.992 396.218 78.628 395.994 78.156C395.77 77.684 395.658 77.12 395.658 76.464C395.658 75.808 395.77 75.248 395.994 74.784C396.218 74.312 396.53 73.952 396.93 73.704C397.33 73.448 397.794 73.32 398.322 73.32C398.834 73.32 399.282 73.448 399.666 73.704C400.058 73.952 400.318 74.288 400.446 74.712H400.314L400.446 73.44H401.886C401.862 73.688 401.838 73.94 401.814 74.196C401.798 74.452 401.79 74.704 401.79 74.952V79.5H400.302L400.29 78.252H400.434C400.306 78.668 400.046 79 399.654 79.248C399.262 79.496 398.818 79.62 398.322 79.62ZM398.742 78.468C399.214 78.468 399.594 78.304 399.882 77.976C400.17 77.64 400.314 77.136 400.314 76.464C400.314 75.792 400.17 75.292 399.882 74.964C399.594 74.636 399.214 74.472 398.742 74.472C398.27 74.472 397.89 74.636 397.602 74.964C397.314 75.292 397.17 75.792 397.17 76.464C397.17 77.136 397.31 77.64 397.59 77.976C397.878 78.304 398.262 78.468 398.742 78.468ZM403.423 79.5V70.668H404.923V76.02H404.947L407.407 73.44H409.219L406.159 76.644L406.171 76.044L409.435 79.5H407.575L404.947 76.788H404.923V79.5H403.423ZM412.855 79.62C411.839 79.62 411.043 79.34 410.467 78.78C409.891 78.22 409.603 77.452 409.603 76.476C409.603 75.844 409.727 75.292 409.975 74.82C410.223 74.348 410.567 73.98 411.007 73.716C411.455 73.452 411.975 73.32 412.567 73.32C413.151 73.32 413.639 73.444 414.031 73.692C414.423 73.94 414.719 74.288 414.919 74.736C415.127 75.184 415.231 75.708 415.231 76.308V76.704H410.815V75.912H414.163L413.959 76.08C413.959 75.52 413.839 75.092 413.599 74.796C413.367 74.5 413.027 74.352 412.579 74.352C412.083 74.352 411.699 74.528 411.427 74.88C411.163 75.232 411.031 75.724 411.031 76.356V76.512C411.031 77.168 411.191 77.66 411.511 77.988C411.839 78.308 412.299 78.468 412.891 78.468C413.235 78.468 413.555 78.424 413.851 78.336C414.155 78.24 414.443 78.088 414.715 77.88L415.159 78.888C414.871 79.12 414.527 79.3 414.127 79.428C413.727 79.556 413.303 79.62 412.855 79.62ZM416.49 79.5V74.988C416.49 74.732 416.482 74.472 416.466 74.208C416.458 73.944 416.438 73.688 416.406 73.44H417.858L418.026 75.096H417.786C417.866 74.696 417.998 74.364 418.182 74.1C418.374 73.836 418.606 73.64 418.878 73.512C419.15 73.384 419.446 73.32 419.766 73.32C419.91 73.32 420.026 73.328 420.114 73.344C420.202 73.352 420.29 73.372 420.378 73.404L420.366 74.724C420.214 74.66 420.082 74.62 419.97 74.604C419.866 74.588 419.734 74.58 419.574 74.58C419.23 74.58 418.938 74.652 418.698 74.796C418.466 74.94 418.29 75.14 418.17 75.396C418.058 75.652 418.002 75.944 418.002 76.272V79.5H416.49ZM423.314 79.62C422.794 79.62 422.314 79.56 421.874 79.44C421.442 79.312 421.078 79.136 420.782 78.912L421.202 77.904C421.506 78.112 421.842 78.272 422.21 78.384C422.578 78.496 422.95 78.552 423.326 78.552C423.726 78.552 424.022 78.484 424.214 78.348C424.414 78.212 424.514 78.028 424.514 77.796C424.514 77.612 424.45 77.468 424.322 77.364C424.202 77.252 424.006 77.168 423.734 77.112L422.534 76.884C422.022 76.772 421.63 76.58 421.358 76.308C421.094 76.036 420.962 75.68 420.962 75.24C420.962 74.864 421.062 74.532 421.262 74.244C421.47 73.956 421.762 73.732 422.138 73.572C422.522 73.404 422.97 73.32 423.482 73.32C423.93 73.32 424.35 73.38 424.742 73.5C425.142 73.62 425.478 73.8 425.75 74.04L425.318 75.012C425.07 74.812 424.786 74.656 424.466 74.544C424.146 74.432 423.834 74.376 423.53 74.376C423.114 74.376 422.81 74.452 422.618 74.604C422.426 74.748 422.33 74.936 422.33 75.168C422.33 75.344 422.386 75.492 422.498 75.612C422.618 75.724 422.802 75.808 423.05 75.864L424.25 76.092C424.786 76.196 425.19 76.38 425.462 76.644C425.742 76.9 425.882 77.252 425.882 77.7C425.882 78.1 425.774 78.444 425.558 78.732C425.342 79.02 425.042 79.24 424.658 79.392C424.274 79.544 423.826 79.62 423.314 79.62Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__tip_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Polygon 4_3",
  d: "M386.57 94.5L381.57 86.5L386.57 86.5L391.57 86.5L386.57 94.5Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__label-speakers-active",
  className: "label-speakers-active",
  filter: "url(#control-room_svg__filter3_d_7074_1985)"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__text_4"
}, /*#__PURE__*/React.createElement("rect", {
  x: 339.07,
  y: 63,
  width: 95,
  height: 23,
  rx: 1.5,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 339.07,
  y: 63,
  width: 95,
  height: 23,
  rx: 1.5,
  stroke: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Tooltip_4",
  d: "M347.727 79.5V71.04H349.275V78.192H353.259V79.5H347.727ZM356.999 79.62C356.375 79.62 355.835 79.492 355.379 79.236C354.923 78.98 354.567 78.616 354.311 78.144C354.063 77.672 353.939 77.112 353.939 76.464C353.939 75.816 354.063 75.26 354.311 74.796C354.567 74.324 354.923 73.96 355.379 73.704C355.835 73.448 356.375 73.32 356.999 73.32C357.623 73.32 358.163 73.448 358.619 73.704C359.083 73.96 359.439 74.324 359.687 74.796C359.943 75.26 360.071 75.816 360.071 76.464C360.071 77.112 359.943 77.672 359.687 78.144C359.439 78.616 359.083 78.98 358.619 79.236C358.163 79.492 357.623 79.62 356.999 79.62ZM356.999 78.468C357.471 78.468 357.847 78.304 358.127 77.976C358.407 77.64 358.547 77.136 358.547 76.464C358.547 75.792 358.407 75.292 358.127 74.964C357.847 74.636 357.471 74.472 356.999 74.472C356.527 74.472 356.151 74.636 355.871 74.964C355.591 75.292 355.451 75.792 355.451 76.464C355.451 77.136 355.591 77.64 355.871 77.976C356.151 78.304 356.527 78.468 356.999 78.468ZM363.549 79.62C362.805 79.62 362.249 79.416 361.881 79.008C361.513 78.6 361.329 77.976 361.329 77.136V73.44H362.829V77.124C362.829 77.572 362.921 77.904 363.105 78.12C363.289 78.328 363.569 78.432 363.945 78.432C364.369 78.432 364.713 78.288 364.977 78C365.249 77.712 365.385 77.332 365.385 76.86V73.44H366.885V79.5H365.421V78.264H365.589C365.413 78.696 365.145 79.032 364.785 79.272C364.433 79.504 364.021 79.62 363.549 79.62ZM370.865 79.62C370.337 79.62 369.869 79.496 369.461 79.248C369.061 78.992 368.749 78.628 368.525 78.156C368.301 77.684 368.189 77.12 368.189 76.464C368.189 75.808 368.301 75.248 368.525 74.784C368.749 74.312 369.061 73.952 369.461 73.704C369.869 73.448 370.337 73.32 370.865 73.32C371.369 73.32 371.813 73.444 372.197 73.692C372.589 73.932 372.849 74.26 372.977 74.676H372.821V70.668H374.321V79.5H372.845V78.216H372.989C372.861 78.648 372.601 78.992 372.209 79.248C371.825 79.496 371.377 79.62 370.865 79.62ZM371.285 78.468C371.757 78.468 372.137 78.304 372.425 77.976C372.713 77.64 372.857 77.136 372.857 76.464C372.857 75.792 372.713 75.292 372.425 74.964C372.137 74.636 371.757 74.472 371.285 74.472C370.813 74.472 370.429 74.636 370.133 74.964C369.845 75.292 369.701 75.792 369.701 76.464C369.701 77.136 369.845 77.64 370.133 77.976C370.429 78.304 370.813 78.468 371.285 78.468ZM378.115 79.62C377.595 79.62 377.115 79.56 376.675 79.44C376.243 79.312 375.879 79.136 375.583 78.912L376.003 77.904C376.307 78.112 376.643 78.272 377.011 78.384C377.379 78.496 377.751 78.552 378.127 78.552C378.527 78.552 378.823 78.484 379.015 78.348C379.215 78.212 379.315 78.028 379.315 77.796C379.315 77.612 379.251 77.468 379.123 77.364C379.003 77.252 378.807 77.168 378.535 77.112L377.335 76.884C376.823 76.772 376.431 76.58 376.159 76.308C375.895 76.036 375.763 75.68 375.763 75.24C375.763 74.864 375.863 74.532 376.063 74.244C376.271 73.956 376.563 73.732 376.939 73.572C377.323 73.404 377.771 73.32 378.283 73.32C378.731 73.32 379.151 73.38 379.543 73.5C379.943 73.62 380.279 73.8 380.551 74.04L380.119 75.012C379.871 74.812 379.587 74.656 379.267 74.544C378.947 74.432 378.635 74.376 378.331 74.376C377.915 74.376 377.611 74.452 377.419 74.604C377.227 74.748 377.131 74.936 377.131 75.168C377.131 75.344 377.187 75.492 377.299 75.612C377.419 75.724 377.603 75.808 377.851 75.864L379.051 76.092C379.587 76.196 379.991 76.38 380.263 76.644C380.543 76.9 380.683 77.252 380.683 77.7C380.683 78.1 380.575 78.444 380.359 78.732C380.143 79.02 379.843 79.24 379.459 79.392C379.075 79.544 378.627 79.62 378.115 79.62ZM381.966 82.092V74.952C381.966 74.704 381.958 74.452 381.942 74.196C381.926 73.94 381.902 73.688 381.87 73.44H383.322L383.454 74.712H383.322C383.442 74.288 383.694 73.952 384.078 73.704C384.47 73.448 384.922 73.32 385.434 73.32C385.97 73.32 386.438 73.448 386.838 73.704C387.238 73.952 387.55 74.312 387.774 74.784C387.998 75.248 388.11 75.808 388.11 76.464C388.11 77.12 387.998 77.684 387.774 78.156C387.55 78.628 387.238 78.992 386.838 79.248C386.438 79.496 385.97 79.62 385.434 79.62C384.93 79.62 384.486 79.496 384.102 79.248C383.718 79 383.462 78.668 383.334 78.252H383.466V82.092H381.966ZM385.014 78.468C385.494 78.468 385.878 78.304 386.166 77.976C386.454 77.64 386.598 77.136 386.598 76.464C386.598 75.792 386.454 75.292 386.166 74.964C385.878 74.636 385.494 74.472 385.014 74.472C384.542 74.472 384.162 74.636 383.874 74.964C383.586 75.292 383.442 75.792 383.442 76.464C383.442 77.136 383.586 77.64 383.874 77.976C384.162 78.304 384.542 78.468 385.014 78.468ZM392.336 79.62C391.32 79.62 390.524 79.34 389.948 78.78C389.372 78.22 389.084 77.452 389.084 76.476C389.084 75.844 389.208 75.292 389.456 74.82C389.704 74.348 390.048 73.98 390.488 73.716C390.936 73.452 391.456 73.32 392.048 73.32C392.632 73.32 393.12 73.444 393.512 73.692C393.904 73.94 394.2 74.288 394.4 74.736C394.608 75.184 394.712 75.708 394.712 76.308V76.704H390.296V75.912H393.644L393.44 76.08C393.44 75.52 393.32 75.092 393.08 74.796C392.848 74.5 392.508 74.352 392.06 74.352C391.564 74.352 391.18 74.528 390.908 74.88C390.644 75.232 390.512 75.724 390.512 76.356V76.512C390.512 77.168 390.672 77.66 390.992 77.988C391.32 78.308 391.78 78.468 392.372 78.468C392.716 78.468 393.036 78.424 393.332 78.336C393.636 78.24 393.924 78.088 394.196 77.88L394.64 78.888C394.352 79.12 394.008 79.3 393.608 79.428C393.208 79.556 392.784 79.62 392.336 79.62ZM398.322 79.62C397.794 79.62 397.33 79.496 396.93 79.248C396.53 78.992 396.218 78.628 395.994 78.156C395.77 77.684 395.658 77.12 395.658 76.464C395.658 75.808 395.77 75.248 395.994 74.784C396.218 74.312 396.53 73.952 396.93 73.704C397.33 73.448 397.794 73.32 398.322 73.32C398.834 73.32 399.282 73.448 399.666 73.704C400.058 73.952 400.318 74.288 400.446 74.712H400.314L400.446 73.44H401.886C401.862 73.688 401.838 73.94 401.814 74.196C401.798 74.452 401.79 74.704 401.79 74.952V79.5H400.302L400.29 78.252H400.434C400.306 78.668 400.046 79 399.654 79.248C399.262 79.496 398.818 79.62 398.322 79.62ZM398.742 78.468C399.214 78.468 399.594 78.304 399.882 77.976C400.17 77.64 400.314 77.136 400.314 76.464C400.314 75.792 400.17 75.292 399.882 74.964C399.594 74.636 399.214 74.472 398.742 74.472C398.27 74.472 397.89 74.636 397.602 74.964C397.314 75.292 397.17 75.792 397.17 76.464C397.17 77.136 397.31 77.64 397.59 77.976C397.878 78.304 398.262 78.468 398.742 78.468ZM403.423 79.5V70.668H404.923V76.02H404.947L407.407 73.44H409.219L406.159 76.644L406.171 76.044L409.435 79.5H407.575L404.947 76.788H404.923V79.5H403.423ZM412.855 79.62C411.839 79.62 411.043 79.34 410.467 78.78C409.891 78.22 409.603 77.452 409.603 76.476C409.603 75.844 409.727 75.292 409.975 74.82C410.223 74.348 410.567 73.98 411.007 73.716C411.455 73.452 411.975 73.32 412.567 73.32C413.151 73.32 413.639 73.444 414.031 73.692C414.423 73.94 414.719 74.288 414.919 74.736C415.127 75.184 415.231 75.708 415.231 76.308V76.704H410.815V75.912H414.163L413.959 76.08C413.959 75.52 413.839 75.092 413.599 74.796C413.367 74.5 413.027 74.352 412.579 74.352C412.083 74.352 411.699 74.528 411.427 74.88C411.163 75.232 411.031 75.724 411.031 76.356V76.512C411.031 77.168 411.191 77.66 411.511 77.988C411.839 78.308 412.299 78.468 412.891 78.468C413.235 78.468 413.555 78.424 413.851 78.336C414.155 78.24 414.443 78.088 414.715 77.88L415.159 78.888C414.871 79.12 414.527 79.3 414.127 79.428C413.727 79.556 413.303 79.62 412.855 79.62ZM416.49 79.5V74.988C416.49 74.732 416.482 74.472 416.466 74.208C416.458 73.944 416.438 73.688 416.406 73.44H417.858L418.026 75.096H417.786C417.866 74.696 417.998 74.364 418.182 74.1C418.374 73.836 418.606 73.64 418.878 73.512C419.15 73.384 419.446 73.32 419.766 73.32C419.91 73.32 420.026 73.328 420.114 73.344C420.202 73.352 420.29 73.372 420.378 73.404L420.366 74.724C420.214 74.66 420.082 74.62 419.97 74.604C419.866 74.588 419.734 74.58 419.574 74.58C419.23 74.58 418.938 74.652 418.698 74.796C418.466 74.94 418.29 75.14 418.17 75.396C418.058 75.652 418.002 75.944 418.002 76.272V79.5H416.49ZM423.314 79.62C422.794 79.62 422.314 79.56 421.874 79.44C421.442 79.312 421.078 79.136 420.782 78.912L421.202 77.904C421.506 78.112 421.842 78.272 422.21 78.384C422.578 78.496 422.95 78.552 423.326 78.552C423.726 78.552 424.022 78.484 424.214 78.348C424.414 78.212 424.514 78.028 424.514 77.796C424.514 77.612 424.45 77.468 424.322 77.364C424.202 77.252 424.006 77.168 423.734 77.112L422.534 76.884C422.022 76.772 421.63 76.58 421.358 76.308C421.094 76.036 420.962 75.68 420.962 75.24C420.962 74.864 421.062 74.532 421.262 74.244C421.47 73.956 421.762 73.732 422.138 73.572C422.522 73.404 422.97 73.32 423.482 73.32C423.93 73.32 424.35 73.38 424.742 73.5C425.142 73.62 425.478 73.8 425.75 74.04L425.318 75.012C425.07 74.812 424.786 74.656 424.466 74.544C424.146 74.432 423.834 74.376 423.53 74.376C423.114 74.376 422.81 74.452 422.618 74.604C422.426 74.748 422.33 74.936 422.33 75.168C422.33 75.344 422.386 75.492 422.498 75.612C422.618 75.724 422.802 75.808 423.05 75.864L424.25 76.092C424.786 76.196 425.19 76.38 425.462 76.644C425.742 76.9 425.882 77.252 425.882 77.7C425.882 78.1 425.774 78.444 425.558 78.732C425.342 79.02 425.042 79.24 424.658 79.392C424.274 79.544 423.826 79.62 423.314 79.62Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__tip_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Polygon 4_4",
  d: "M386.57 94.5L381.57 86.5L386.57 86.5L391.57 86.5L386.57 94.5Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__label-headphones",
  className: "label-headphones",
  filter: "url(#control-room_svg__filter4_d_7074_1985)"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__text_5"
}, /*#__PURE__*/React.createElement("rect", {
  x: 409.141,
  y: 264,
  width: 89,
  height: 24,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Tooltip_5",
  d: "M418.407 281V272.54H419.955V276.068H424.287V272.54H425.835V281H424.287V277.352H419.955V281H418.407ZM430.508 281.12C429.492 281.12 428.696 280.84 428.12 280.28C427.544 279.72 427.256 278.952 427.256 277.976C427.256 277.344 427.38 276.792 427.628 276.32C427.876 275.848 428.22 275.48 428.66 275.216C429.108 274.952 429.628 274.82 430.22 274.82C430.804 274.82 431.292 274.944 431.684 275.192C432.076 275.44 432.372 275.788 432.572 276.236C432.78 276.684 432.884 277.208 432.884 277.808V278.204H428.468V277.412H431.816L431.612 277.58C431.612 277.02 431.492 276.592 431.252 276.296C431.02 276 430.68 275.852 430.232 275.852C429.736 275.852 429.352 276.028 429.08 276.38C428.816 276.732 428.684 277.224 428.684 277.856V278.012C428.684 278.668 428.844 279.16 429.164 279.488C429.492 279.808 429.952 279.968 430.544 279.968C430.888 279.968 431.208 279.924 431.504 279.836C431.808 279.74 432.096 279.588 432.368 279.38L432.812 280.388C432.524 280.62 432.18 280.8 431.78 280.928C431.38 281.056 430.956 281.12 430.508 281.12ZM436.494 281.12C435.966 281.12 435.502 280.996 435.102 280.748C434.702 280.492 434.39 280.128 434.166 279.656C433.942 279.184 433.83 278.62 433.83 277.964C433.83 277.308 433.942 276.748 434.166 276.284C434.39 275.812 434.702 275.452 435.102 275.204C435.502 274.948 435.966 274.82 436.494 274.82C437.006 274.82 437.454 274.948 437.838 275.204C438.23 275.452 438.49 275.788 438.618 276.212H438.486L438.618 274.94H440.058C440.034 275.188 440.01 275.44 439.986 275.696C439.97 275.952 439.962 276.204 439.962 276.452V281H438.474L438.462 279.752H438.606C438.478 280.168 438.218 280.5 437.826 280.748C437.434 280.996 436.99 281.12 436.494 281.12ZM436.914 279.968C437.386 279.968 437.766 279.804 438.054 279.476C438.342 279.14 438.486 278.636 438.486 277.964C438.486 277.292 438.342 276.792 438.054 276.464C437.766 276.136 437.386 275.972 436.914 275.972C436.442 275.972 436.062 276.136 435.774 276.464C435.486 276.792 435.342 277.292 435.342 277.964C435.342 278.636 435.482 279.14 435.762 279.476C436.05 279.804 436.434 279.968 436.914 279.968ZM443.947 281.12C443.419 281.12 442.951 280.996 442.543 280.748C442.143 280.492 441.831 280.128 441.607 279.656C441.383 279.184 441.271 278.62 441.271 277.964C441.271 277.308 441.383 276.748 441.607 276.284C441.831 275.812 442.143 275.452 442.543 275.204C442.951 274.948 443.419 274.82 443.947 274.82C444.451 274.82 444.895 274.944 445.279 275.192C445.671 275.432 445.931 275.76 446.059 276.176H445.903V272.168H447.403V281H445.927V279.716H446.071C445.943 280.148 445.683 280.492 445.291 280.748C444.907 280.996 444.459 281.12 443.947 281.12ZM444.367 279.968C444.839 279.968 445.219 279.804 445.507 279.476C445.795 279.14 445.939 278.636 445.939 277.964C445.939 277.292 445.795 276.792 445.507 276.464C445.219 276.136 444.839 275.972 444.367 275.972C443.895 275.972 443.511 276.136 443.215 276.464C442.927 276.792 442.783 277.292 442.783 277.964C442.783 278.636 442.927 279.14 443.215 279.476C443.511 279.804 443.895 279.968 444.367 279.968ZM449.037 283.592V276.452C449.037 276.204 449.029 275.952 449.013 275.696C448.997 275.44 448.973 275.188 448.941 274.94H450.393L450.525 276.212H450.393C450.513 275.788 450.765 275.452 451.149 275.204C451.541 274.948 451.993 274.82 452.505 274.82C453.041 274.82 453.509 274.948 453.909 275.204C454.309 275.452 454.621 275.812 454.845 276.284C455.069 276.748 455.181 277.308 455.181 277.964C455.181 278.62 455.069 279.184 454.845 279.656C454.621 280.128 454.309 280.492 453.909 280.748C453.509 280.996 453.041 281.12 452.505 281.12C452.001 281.12 451.557 280.996 451.173 280.748C450.789 280.5 450.533 280.168 450.405 279.752H450.537V283.592H449.037ZM452.085 279.968C452.565 279.968 452.949 279.804 453.237 279.476C453.525 279.14 453.669 278.636 453.669 277.964C453.669 277.292 453.525 276.792 453.237 276.464C452.949 276.136 452.565 275.972 452.085 275.972C451.613 275.972 451.233 276.136 450.945 276.464C450.657 276.792 450.513 277.292 450.513 277.964C450.513 278.636 450.657 279.14 450.945 279.476C451.233 279.804 451.613 279.968 452.085 279.968ZM456.478 281V272.168H457.978V276.152H457.81C457.994 275.72 458.278 275.392 458.662 275.168C459.046 274.936 459.486 274.82 459.982 274.82C460.702 274.82 461.238 275.024 461.59 275.432C461.942 275.832 462.118 276.444 462.118 277.268V281H460.618V277.34C460.618 276.868 460.526 276.528 460.342 276.32C460.166 276.104 459.882 275.996 459.49 275.996C459.034 275.996 458.666 276.14 458.386 276.428C458.114 276.708 457.978 277.084 457.978 277.556V281H456.478ZM466.445 281.12C465.821 281.12 465.281 280.992 464.825 280.736C464.369 280.48 464.013 280.116 463.757 279.644C463.509 279.172 463.385 278.612 463.385 277.964C463.385 277.316 463.509 276.76 463.757 276.296C464.013 275.824 464.369 275.46 464.825 275.204C465.281 274.948 465.821 274.82 466.445 274.82C467.069 274.82 467.609 274.948 468.065 275.204C468.529 275.46 468.885 275.824 469.133 276.296C469.389 276.76 469.517 277.316 469.517 277.964C469.517 278.612 469.389 279.172 469.133 279.644C468.885 280.116 468.529 280.48 468.065 280.736C467.609 280.992 467.069 281.12 466.445 281.12ZM466.445 279.968C466.917 279.968 467.293 279.804 467.573 279.476C467.853 279.14 467.993 278.636 467.993 277.964C467.993 277.292 467.853 276.792 467.573 276.464C467.293 276.136 466.917 275.972 466.445 275.972C465.973 275.972 465.597 276.136 465.317 276.464C465.037 276.792 464.897 277.292 464.897 277.964C464.897 278.636 465.037 279.14 465.317 279.476C465.597 279.804 465.973 279.968 466.445 279.968ZM470.81 281V276.452C470.81 276.204 470.802 275.952 470.786 275.696C470.77 275.44 470.746 275.188 470.714 274.94H472.166L472.286 276.14H472.142C472.334 275.716 472.618 275.392 472.994 275.168C473.37 274.936 473.806 274.82 474.302 274.82C475.014 274.82 475.55 275.02 475.91 275.42C476.27 275.82 476.45 276.444 476.45 277.292V281H474.95V277.364C474.95 276.876 474.854 276.528 474.662 276.32C474.478 276.104 474.198 275.996 473.822 275.996C473.358 275.996 472.99 276.14 472.718 276.428C472.446 276.716 472.31 277.1 472.31 277.58V281H470.81ZM480.969 281.12C479.953 281.12 479.157 280.84 478.581 280.28C478.005 279.72 477.717 278.952 477.717 277.976C477.717 277.344 477.841 276.792 478.089 276.32C478.337 275.848 478.681 275.48 479.121 275.216C479.569 274.952 480.089 274.82 480.681 274.82C481.265 274.82 481.753 274.944 482.145 275.192C482.537 275.44 482.833 275.788 483.033 276.236C483.241 276.684 483.345 277.208 483.345 277.808V278.204H478.929V277.412H482.277L482.073 277.58C482.073 277.02 481.953 276.592 481.713 276.296C481.481 276 481.141 275.852 480.693 275.852C480.197 275.852 479.813 276.028 479.541 276.38C479.277 276.732 479.145 277.224 479.145 277.856V278.012C479.145 278.668 479.305 279.16 479.625 279.488C479.953 279.808 480.413 279.968 481.005 279.968C481.349 279.968 481.669 279.924 481.965 279.836C482.269 279.74 482.557 279.588 482.829 279.38L483.273 280.388C482.985 280.62 482.641 280.8 482.241 280.928C481.841 281.056 481.417 281.12 480.969 281.12ZM486.775 281.12C486.255 281.12 485.775 281.06 485.335 280.94C484.903 280.812 484.539 280.636 484.243 280.412L484.663 279.404C484.967 279.612 485.303 279.772 485.671 279.884C486.039 279.996 486.411 280.052 486.787 280.052C487.187 280.052 487.483 279.984 487.675 279.848C487.875 279.712 487.975 279.528 487.975 279.296C487.975 279.112 487.911 278.968 487.783 278.864C487.663 278.752 487.467 278.668 487.195 278.612L485.995 278.384C485.483 278.272 485.091 278.08 484.819 277.808C484.555 277.536 484.423 277.18 484.423 276.74C484.423 276.364 484.523 276.032 484.723 275.744C484.931 275.456 485.223 275.232 485.599 275.072C485.983 274.904 486.431 274.82 486.943 274.82C487.391 274.82 487.811 274.88 488.203 275C488.603 275.12 488.939 275.3 489.211 275.54L488.779 276.512C488.531 276.312 488.247 276.156 487.927 276.044C487.607 275.932 487.295 275.876 486.991 275.876C486.575 275.876 486.271 275.952 486.079 276.104C485.887 276.248 485.791 276.436 485.791 276.668C485.791 276.844 485.847 276.992 485.959 277.112C486.079 277.224 486.263 277.308 486.511 277.364L487.711 277.592C488.247 277.696 488.651 277.88 488.923 278.144C489.203 278.4 489.343 278.752 489.343 279.2C489.343 279.6 489.235 279.944 489.019 280.232C488.803 280.52 488.503 280.74 488.119 280.892C487.735 281.044 487.287 281.12 486.775 281.12Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__tip_5"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Polygon 4_5",
  d: "M453.641 296L448.641 288L453.641 288L458.641 288L453.641 296Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__label-headphones-active",
  className: "label-headphones-active",
  filter: "url(#control-room_svg__filter5_d_7074_1985)"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__text_6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 409.641,
  y: 264.5,
  width: 88,
  height: 23,
  rx: 1.5,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 409.641,
  y: 264.5,
  width: 88,
  height: 23,
  rx: 1.5,
  stroke: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Tooltip_6",
  d: "M418.407 281V272.54H419.955V276.068H424.287V272.54H425.835V281H424.287V277.352H419.955V281H418.407ZM430.508 281.12C429.492 281.12 428.696 280.84 428.12 280.28C427.544 279.72 427.256 278.952 427.256 277.976C427.256 277.344 427.38 276.792 427.628 276.32C427.876 275.848 428.22 275.48 428.66 275.216C429.108 274.952 429.628 274.82 430.22 274.82C430.804 274.82 431.292 274.944 431.684 275.192C432.076 275.44 432.372 275.788 432.572 276.236C432.78 276.684 432.884 277.208 432.884 277.808V278.204H428.468V277.412H431.816L431.612 277.58C431.612 277.02 431.492 276.592 431.252 276.296C431.02 276 430.68 275.852 430.232 275.852C429.736 275.852 429.352 276.028 429.08 276.38C428.816 276.732 428.684 277.224 428.684 277.856V278.012C428.684 278.668 428.844 279.16 429.164 279.488C429.492 279.808 429.952 279.968 430.544 279.968C430.888 279.968 431.208 279.924 431.504 279.836C431.808 279.74 432.096 279.588 432.368 279.38L432.812 280.388C432.524 280.62 432.18 280.8 431.78 280.928C431.38 281.056 430.956 281.12 430.508 281.12ZM436.494 281.12C435.966 281.12 435.502 280.996 435.102 280.748C434.702 280.492 434.39 280.128 434.166 279.656C433.942 279.184 433.83 278.62 433.83 277.964C433.83 277.308 433.942 276.748 434.166 276.284C434.39 275.812 434.702 275.452 435.102 275.204C435.502 274.948 435.966 274.82 436.494 274.82C437.006 274.82 437.454 274.948 437.838 275.204C438.23 275.452 438.49 275.788 438.618 276.212H438.486L438.618 274.94H440.058C440.034 275.188 440.01 275.44 439.986 275.696C439.97 275.952 439.962 276.204 439.962 276.452V281H438.474L438.462 279.752H438.606C438.478 280.168 438.218 280.5 437.826 280.748C437.434 280.996 436.99 281.12 436.494 281.12ZM436.914 279.968C437.386 279.968 437.766 279.804 438.054 279.476C438.342 279.14 438.486 278.636 438.486 277.964C438.486 277.292 438.342 276.792 438.054 276.464C437.766 276.136 437.386 275.972 436.914 275.972C436.442 275.972 436.062 276.136 435.774 276.464C435.486 276.792 435.342 277.292 435.342 277.964C435.342 278.636 435.482 279.14 435.762 279.476C436.05 279.804 436.434 279.968 436.914 279.968ZM443.947 281.12C443.419 281.12 442.951 280.996 442.543 280.748C442.143 280.492 441.831 280.128 441.607 279.656C441.383 279.184 441.271 278.62 441.271 277.964C441.271 277.308 441.383 276.748 441.607 276.284C441.831 275.812 442.143 275.452 442.543 275.204C442.951 274.948 443.419 274.82 443.947 274.82C444.451 274.82 444.895 274.944 445.279 275.192C445.671 275.432 445.931 275.76 446.059 276.176H445.903V272.168H447.403V281H445.927V279.716H446.071C445.943 280.148 445.683 280.492 445.291 280.748C444.907 280.996 444.459 281.12 443.947 281.12ZM444.367 279.968C444.839 279.968 445.219 279.804 445.507 279.476C445.795 279.14 445.939 278.636 445.939 277.964C445.939 277.292 445.795 276.792 445.507 276.464C445.219 276.136 444.839 275.972 444.367 275.972C443.895 275.972 443.511 276.136 443.215 276.464C442.927 276.792 442.783 277.292 442.783 277.964C442.783 278.636 442.927 279.14 443.215 279.476C443.511 279.804 443.895 279.968 444.367 279.968ZM449.037 283.592V276.452C449.037 276.204 449.029 275.952 449.013 275.696C448.997 275.44 448.973 275.188 448.941 274.94H450.393L450.525 276.212H450.393C450.513 275.788 450.765 275.452 451.149 275.204C451.541 274.948 451.993 274.82 452.505 274.82C453.041 274.82 453.509 274.948 453.909 275.204C454.309 275.452 454.621 275.812 454.845 276.284C455.069 276.748 455.181 277.308 455.181 277.964C455.181 278.62 455.069 279.184 454.845 279.656C454.621 280.128 454.309 280.492 453.909 280.748C453.509 280.996 453.041 281.12 452.505 281.12C452.001 281.12 451.557 280.996 451.173 280.748C450.789 280.5 450.533 280.168 450.405 279.752H450.537V283.592H449.037ZM452.085 279.968C452.565 279.968 452.949 279.804 453.237 279.476C453.525 279.14 453.669 278.636 453.669 277.964C453.669 277.292 453.525 276.792 453.237 276.464C452.949 276.136 452.565 275.972 452.085 275.972C451.613 275.972 451.233 276.136 450.945 276.464C450.657 276.792 450.513 277.292 450.513 277.964C450.513 278.636 450.657 279.14 450.945 279.476C451.233 279.804 451.613 279.968 452.085 279.968ZM456.478 281V272.168H457.978V276.152H457.81C457.994 275.72 458.278 275.392 458.662 275.168C459.046 274.936 459.486 274.82 459.982 274.82C460.702 274.82 461.238 275.024 461.59 275.432C461.942 275.832 462.118 276.444 462.118 277.268V281H460.618V277.34C460.618 276.868 460.526 276.528 460.342 276.32C460.166 276.104 459.882 275.996 459.49 275.996C459.034 275.996 458.666 276.14 458.386 276.428C458.114 276.708 457.978 277.084 457.978 277.556V281H456.478ZM466.445 281.12C465.821 281.12 465.281 280.992 464.825 280.736C464.369 280.48 464.013 280.116 463.757 279.644C463.509 279.172 463.385 278.612 463.385 277.964C463.385 277.316 463.509 276.76 463.757 276.296C464.013 275.824 464.369 275.46 464.825 275.204C465.281 274.948 465.821 274.82 466.445 274.82C467.069 274.82 467.609 274.948 468.065 275.204C468.529 275.46 468.885 275.824 469.133 276.296C469.389 276.76 469.517 277.316 469.517 277.964C469.517 278.612 469.389 279.172 469.133 279.644C468.885 280.116 468.529 280.48 468.065 280.736C467.609 280.992 467.069 281.12 466.445 281.12ZM466.445 279.968C466.917 279.968 467.293 279.804 467.573 279.476C467.853 279.14 467.993 278.636 467.993 277.964C467.993 277.292 467.853 276.792 467.573 276.464C467.293 276.136 466.917 275.972 466.445 275.972C465.973 275.972 465.597 276.136 465.317 276.464C465.037 276.792 464.897 277.292 464.897 277.964C464.897 278.636 465.037 279.14 465.317 279.476C465.597 279.804 465.973 279.968 466.445 279.968ZM470.81 281V276.452C470.81 276.204 470.802 275.952 470.786 275.696C470.77 275.44 470.746 275.188 470.714 274.94H472.166L472.286 276.14H472.142C472.334 275.716 472.618 275.392 472.994 275.168C473.37 274.936 473.806 274.82 474.302 274.82C475.014 274.82 475.55 275.02 475.91 275.42C476.27 275.82 476.45 276.444 476.45 277.292V281H474.95V277.364C474.95 276.876 474.854 276.528 474.662 276.32C474.478 276.104 474.198 275.996 473.822 275.996C473.358 275.996 472.99 276.14 472.718 276.428C472.446 276.716 472.31 277.1 472.31 277.58V281H470.81ZM480.969 281.12C479.953 281.12 479.157 280.84 478.581 280.28C478.005 279.72 477.717 278.952 477.717 277.976C477.717 277.344 477.841 276.792 478.089 276.32C478.337 275.848 478.681 275.48 479.121 275.216C479.569 274.952 480.089 274.82 480.681 274.82C481.265 274.82 481.753 274.944 482.145 275.192C482.537 275.44 482.833 275.788 483.033 276.236C483.241 276.684 483.345 277.208 483.345 277.808V278.204H478.929V277.412H482.277L482.073 277.58C482.073 277.02 481.953 276.592 481.713 276.296C481.481 276 481.141 275.852 480.693 275.852C480.197 275.852 479.813 276.028 479.541 276.38C479.277 276.732 479.145 277.224 479.145 277.856V278.012C479.145 278.668 479.305 279.16 479.625 279.488C479.953 279.808 480.413 279.968 481.005 279.968C481.349 279.968 481.669 279.924 481.965 279.836C482.269 279.74 482.557 279.588 482.829 279.38L483.273 280.388C482.985 280.62 482.641 280.8 482.241 280.928C481.841 281.056 481.417 281.12 480.969 281.12ZM486.775 281.12C486.255 281.12 485.775 281.06 485.335 280.94C484.903 280.812 484.539 280.636 484.243 280.412L484.663 279.404C484.967 279.612 485.303 279.772 485.671 279.884C486.039 279.996 486.411 280.052 486.787 280.052C487.187 280.052 487.483 279.984 487.675 279.848C487.875 279.712 487.975 279.528 487.975 279.296C487.975 279.112 487.911 278.968 487.783 278.864C487.663 278.752 487.467 278.668 487.195 278.612L485.995 278.384C485.483 278.272 485.091 278.08 484.819 277.808C484.555 277.536 484.423 277.18 484.423 276.74C484.423 276.364 484.523 276.032 484.723 275.744C484.931 275.456 485.223 275.232 485.599 275.072C485.983 274.904 486.431 274.82 486.943 274.82C487.391 274.82 487.811 274.88 488.203 275C488.603 275.12 488.939 275.3 489.211 275.54L488.779 276.512C488.531 276.312 488.247 276.156 487.927 276.044C487.607 275.932 487.295 275.876 486.991 275.876C486.575 275.876 486.271 275.952 486.079 276.104C485.887 276.248 485.791 276.436 485.791 276.668C485.791 276.844 485.847 276.992 485.959 277.112C486.079 277.224 486.263 277.308 486.511 277.364L487.711 277.592C488.247 277.696 488.651 277.88 488.923 278.144C489.203 278.4 489.343 278.752 489.343 279.2C489.343 279.6 489.235 279.944 489.019 280.232C488.803 280.52 488.503 280.74 488.119 280.892C487.735 281.044 487.287 281.12 486.775 281.12Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__tip_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Polygon 4_6",
  d: "M453.641 296L448.641 288L453.641 288L458.641 288L453.641 296Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__label-monitoring-controller",
  className: "label-monitoring-controller",
  filter: "url(#control-room_svg__filter6_d_7074_1985)"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__text_7"
}, /*#__PURE__*/React.createElement("rect", {
  x: 209.57,
  y: 415,
  width: 138,
  height: 24,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Tooltip_7",
  d: "M218.891 432V423.54H220.247L223.355 430.536H222.983L226.091 423.54H227.435V432H226.031V425.724H226.463L223.619 432H222.695L219.851 425.724H220.295V432H218.891ZM231.937 432.12C231.313 432.12 230.773 431.992 230.317 431.736C229.861 431.48 229.505 431.116 229.249 430.644C229.001 430.172 228.877 429.612 228.877 428.964C228.877 428.316 229.001 427.76 229.249 427.296C229.505 426.824 229.861 426.46 230.317 426.204C230.773 425.948 231.313 425.82 231.937 425.82C232.561 425.82 233.101 425.948 233.557 426.204C234.021 426.46 234.377 426.824 234.625 427.296C234.881 427.76 235.009 428.316 235.009 428.964C235.009 429.612 234.881 430.172 234.625 430.644C234.377 431.116 234.021 431.48 233.557 431.736C233.101 431.992 232.561 432.12 231.937 432.12ZM231.937 430.968C232.409 430.968 232.785 430.804 233.065 430.476C233.345 430.14 233.485 429.636 233.485 428.964C233.485 428.292 233.345 427.792 233.065 427.464C232.785 427.136 232.409 426.972 231.937 426.972C231.465 426.972 231.089 427.136 230.809 427.464C230.529 427.792 230.389 428.292 230.389 428.964C230.389 429.636 230.529 430.14 230.809 430.476C231.089 430.804 231.465 430.968 231.937 430.968ZM236.302 432V427.452C236.302 427.204 236.294 426.952 236.278 426.696C236.262 426.44 236.238 426.188 236.206 425.94H237.658L237.778 427.14H237.634C237.826 426.716 238.11 426.392 238.486 426.168C238.862 425.936 239.298 425.82 239.794 425.82C240.506 425.82 241.042 426.02 241.402 426.42C241.762 426.82 241.942 427.444 241.942 428.292V432H240.442V428.364C240.442 427.876 240.346 427.528 240.154 427.32C239.97 427.104 239.69 426.996 239.314 426.996C238.85 426.996 238.482 427.14 238.21 427.428C237.938 427.716 237.802 428.1 237.802 428.58V432H236.302ZM243.533 432V425.94H245.033V432H243.533ZM243.449 424.8V423.336H245.117V424.8H243.449ZM249.254 432.12C248.534 432.12 247.99 431.932 247.622 431.556C247.254 431.18 247.07 430.616 247.07 429.864V427.068H245.906V425.94H247.07V424.392L248.57 424.008V425.94H250.19V427.068H248.57V429.768C248.57 430.184 248.65 430.476 248.81 430.644C248.97 430.812 249.19 430.896 249.47 430.896C249.622 430.896 249.75 430.884 249.854 430.86C249.966 430.836 250.074 430.804 250.178 430.764V431.952C250.042 432.008 249.89 432.048 249.722 432.072C249.562 432.104 249.406 432.12 249.254 432.12ZM253.886 432.12C253.262 432.12 252.722 431.992 252.266 431.736C251.81 431.48 251.454 431.116 251.198 430.644C250.95 430.172 250.826 429.612 250.826 428.964C250.826 428.316 250.95 427.76 251.198 427.296C251.454 426.824 251.81 426.46 252.266 426.204C252.722 425.948 253.262 425.82 253.886 425.82C254.51 425.82 255.05 425.948 255.506 426.204C255.97 426.46 256.326 426.824 256.574 427.296C256.83 427.76 256.958 428.316 256.958 428.964C256.958 429.612 256.83 430.172 256.574 430.644C256.326 431.116 255.97 431.48 255.506 431.736C255.05 431.992 254.51 432.12 253.886 432.12ZM253.886 430.968C254.358 430.968 254.734 430.804 255.014 430.476C255.294 430.14 255.434 429.636 255.434 428.964C255.434 428.292 255.294 427.792 255.014 427.464C254.734 427.136 254.358 426.972 253.886 426.972C253.414 426.972 253.038 427.136 252.758 427.464C252.478 427.792 252.338 428.292 252.338 428.964C252.338 429.636 252.478 430.14 252.758 430.476C253.038 430.804 253.414 430.968 253.886 430.968ZM258.24 432V427.488C258.24 427.232 258.232 426.972 258.216 426.708C258.208 426.444 258.188 426.188 258.156 425.94H259.608L259.776 427.596H259.536C259.616 427.196 259.748 426.864 259.932 426.6C260.124 426.336 260.356 426.14 260.628 426.012C260.9 425.884 261.196 425.82 261.516 425.82C261.66 425.82 261.776 425.828 261.864 425.844C261.952 425.852 262.04 425.872 262.128 425.904L262.116 427.224C261.964 427.16 261.832 427.12 261.72 427.104C261.616 427.088 261.484 427.08 261.324 427.08C260.98 427.08 260.688 427.152 260.448 427.296C260.216 427.44 260.04 427.64 259.92 427.896C259.808 428.152 259.752 428.444 259.752 428.772V432H258.24ZM262.962 432V425.94H264.462V432H262.962ZM262.878 424.8V423.336H264.546V424.8H262.878ZM266.091 432V427.452C266.091 427.204 266.083 426.952 266.067 426.696C266.051 426.44 266.027 426.188 265.995 425.94H267.447L267.567 427.14H267.423C267.615 426.716 267.899 426.392 268.275 426.168C268.651 425.936 269.087 425.82 269.583 425.82C270.295 425.82 270.831 426.02 271.191 426.42C271.551 426.82 271.731 427.444 271.731 428.292V432H270.231V428.364C270.231 427.876 270.135 427.528 269.943 427.32C269.759 427.104 269.479 426.996 269.103 426.996C268.639 426.996 268.271 427.14 267.999 427.428C267.727 427.716 267.591 428.1 267.591 428.58V432H266.091ZM276.13 434.688C275.57 434.688 275.062 434.628 274.606 434.508C274.158 434.388 273.758 434.204 273.406 433.956L273.73 432.876C273.962 433.028 274.202 433.152 274.45 433.248C274.698 433.344 274.954 433.416 275.218 433.464C275.482 433.512 275.75 433.536 276.022 433.536C276.582 433.536 276.998 433.396 277.27 433.116C277.55 432.844 277.69 432.452 277.69 431.94V430.488H277.81C277.682 430.904 277.422 431.236 277.03 431.484C276.646 431.732 276.202 431.856 275.698 431.856C275.154 431.856 274.678 431.736 274.27 431.496C273.87 431.248 273.558 430.896 273.334 430.44C273.11 429.984 272.998 429.448 272.998 428.832C272.998 428.216 273.11 427.684 273.334 427.236C273.558 426.78 273.87 426.432 274.27 426.192C274.678 425.944 275.154 425.82 275.698 425.82C276.21 425.82 276.654 425.944 277.03 426.192C277.414 426.432 277.67 426.76 277.798 427.176L277.69 427.104L277.81 425.94H279.262C279.23 426.188 279.206 426.44 279.19 426.696C279.174 426.952 279.166 427.204 279.166 427.452V431.76C279.166 432.712 278.906 433.436 278.386 433.932C277.874 434.436 277.122 434.688 276.13 434.688ZM276.106 430.704C276.586 430.704 276.966 430.544 277.246 430.224C277.534 429.896 277.678 429.432 277.678 428.832C277.678 428.232 277.534 427.772 277.246 427.452C276.966 427.132 276.586 426.972 276.106 426.972C275.618 426.972 275.23 427.132 274.942 427.452C274.654 427.772 274.51 428.232 274.51 428.832C274.51 429.432 274.654 429.896 274.942 430.224C275.23 430.544 275.618 430.704 276.106 430.704ZM288.136 432.12C287.256 432.12 286.5 431.944 285.868 431.592C285.244 431.232 284.764 430.728 284.428 430.08C284.092 429.424 283.924 428.652 283.924 427.764C283.924 426.876 284.092 426.108 284.428 425.46C284.764 424.812 285.244 424.312 285.868 423.96C286.5 423.6 287.256 423.42 288.136 423.42C288.728 423.42 289.26 423.504 289.732 423.672C290.212 423.84 290.624 424.088 290.968 424.416L290.464 425.64C290.088 425.336 289.724 425.12 289.372 424.992C289.028 424.856 288.632 424.788 288.184 424.788C287.328 424.788 286.672 425.048 286.216 425.568C285.768 426.08 285.544 426.812 285.544 427.764C285.544 428.716 285.768 429.452 286.216 429.972C286.672 430.492 287.328 430.752 288.184 430.752C288.632 430.752 289.028 430.688 289.372 430.56C289.724 430.424 290.088 430.2 290.464 429.888L290.968 431.112C290.624 431.432 290.212 431.68 289.732 431.856C289.26 432.032 288.728 432.12 288.136 432.12ZM294.609 432.12C293.985 432.12 293.445 431.992 292.989 431.736C292.533 431.48 292.177 431.116 291.921 430.644C291.673 430.172 291.549 429.612 291.549 428.964C291.549 428.316 291.673 427.76 291.921 427.296C292.177 426.824 292.533 426.46 292.989 426.204C293.445 425.948 293.985 425.82 294.609 425.82C295.233 425.82 295.773 425.948 296.229 426.204C296.693 426.46 297.049 426.824 297.297 427.296C297.553 427.76 297.681 428.316 297.681 428.964C297.681 429.612 297.553 430.172 297.297 430.644C297.049 431.116 296.693 431.48 296.229 431.736C295.773 431.992 295.233 432.12 294.609 432.12ZM294.609 430.968C295.081 430.968 295.457 430.804 295.737 430.476C296.017 430.14 296.157 429.636 296.157 428.964C296.157 428.292 296.017 427.792 295.737 427.464C295.457 427.136 295.081 426.972 294.609 426.972C294.137 426.972 293.761 427.136 293.481 427.464C293.201 427.792 293.061 428.292 293.061 428.964C293.061 429.636 293.201 430.14 293.481 430.476C293.761 430.804 294.137 430.968 294.609 430.968ZM298.974 432V427.452C298.974 427.204 298.966 426.952 298.95 426.696C298.934 426.44 298.91 426.188 298.878 425.94H300.33L300.45 427.14H300.306C300.498 426.716 300.782 426.392 301.158 426.168C301.534 425.936 301.97 425.82 302.466 425.82C303.178 425.82 303.714 426.02 304.074 426.42C304.434 426.82 304.614 427.444 304.614 428.292V432H303.114V428.364C303.114 427.876 303.018 427.528 302.826 427.32C302.642 427.104 302.362 426.996 301.986 426.996C301.522 426.996 301.154 427.14 300.882 427.428C300.61 427.716 300.474 428.1 300.474 428.58V432H298.974ZM308.797 432.12C308.077 432.12 307.533 431.932 307.165 431.556C306.797 431.18 306.613 430.616 306.613 429.864V427.068H305.449V425.94H306.613V424.392L308.113 424.008V425.94H309.733V427.068H308.113V429.768C308.113 430.184 308.193 430.476 308.353 430.644C308.513 430.812 308.733 430.896 309.013 430.896C309.165 430.896 309.293 430.884 309.397 430.86C309.509 430.836 309.617 430.804 309.721 430.764V431.952C309.585 432.008 309.433 432.048 309.265 432.072C309.105 432.104 308.949 432.12 308.797 432.12ZM310.74 432V427.488C310.74 427.232 310.732 426.972 310.716 426.708C310.708 426.444 310.688 426.188 310.656 425.94H312.108L312.276 427.596H312.036C312.116 427.196 312.248 426.864 312.432 426.6C312.624 426.336 312.856 426.14 313.128 426.012C313.4 425.884 313.696 425.82 314.016 425.82C314.16 425.82 314.276 425.828 314.364 425.844C314.452 425.852 314.54 425.872 314.628 425.904L314.616 427.224C314.464 427.16 314.332 427.12 314.22 427.104C314.116 427.088 313.984 427.08 313.824 427.08C313.48 427.08 313.188 427.152 312.948 427.296C312.716 427.44 312.54 427.64 312.42 427.896C312.308 428.152 312.252 428.444 312.252 428.772V432H310.74ZM318.105 432.12C317.481 432.12 316.941 431.992 316.485 431.736C316.029 431.48 315.673 431.116 315.417 430.644C315.169 430.172 315.045 429.612 315.045 428.964C315.045 428.316 315.169 427.76 315.417 427.296C315.673 426.824 316.029 426.46 316.485 426.204C316.941 425.948 317.481 425.82 318.105 425.82C318.729 425.82 319.269 425.948 319.725 426.204C320.189 426.46 320.545 426.824 320.793 427.296C321.049 427.76 321.177 428.316 321.177 428.964C321.177 429.612 321.049 430.172 320.793 430.644C320.545 431.116 320.189 431.48 319.725 431.736C319.269 431.992 318.729 432.12 318.105 432.12ZM318.105 430.968C318.577 430.968 318.953 430.804 319.233 430.476C319.513 430.14 319.653 429.636 319.653 428.964C319.653 428.292 319.513 427.792 319.233 427.464C318.953 427.136 318.577 426.972 318.105 426.972C317.633 426.972 317.257 427.136 316.977 427.464C316.697 427.792 316.557 428.292 316.557 428.964C316.557 429.636 316.697 430.14 316.977 430.476C317.257 430.804 317.633 430.968 318.105 430.968ZM322.47 432V423.168H323.97V432H322.47ZM325.599 432V423.168H327.099V432H325.599ZM331.656 432.12C330.64 432.12 329.844 431.84 329.268 431.28C328.692 430.72 328.404 429.952 328.404 428.976C328.404 428.344 328.528 427.792 328.776 427.32C329.024 426.848 329.368 426.48 329.808 426.216C330.256 425.952 330.776 425.82 331.368 425.82C331.952 425.82 332.44 425.944 332.832 426.192C333.224 426.44 333.52 426.788 333.72 427.236C333.928 427.684 334.032 428.208 334.032 428.808V429.204H329.616V428.412H332.964L332.76 428.58C332.76 428.02 332.64 427.592 332.4 427.296C332.168 427 331.828 426.852 331.38 426.852C330.884 426.852 330.5 427.028 330.228 427.38C329.964 427.732 329.832 428.224 329.832 428.856V429.012C329.832 429.668 329.992 430.16 330.312 430.488C330.64 430.808 331.1 430.968 331.692 430.968C332.036 430.968 332.356 430.924 332.652 430.836C332.956 430.74 333.244 430.588 333.516 430.38L333.96 431.388C333.672 431.62 333.328 431.8 332.928 431.928C332.528 432.056 332.104 432.12 331.656 432.12ZM335.29 432V427.488C335.29 427.232 335.282 426.972 335.266 426.708C335.258 426.444 335.238 426.188 335.206 425.94H336.658L336.826 427.596H336.586C336.666 427.196 336.798 426.864 336.982 426.6C337.174 426.336 337.406 426.14 337.678 426.012C337.95 425.884 338.246 425.82 338.566 425.82C338.71 425.82 338.826 425.828 338.914 425.844C339.002 425.852 339.09 425.872 339.178 425.904L339.166 427.224C339.014 427.16 338.882 427.12 338.77 427.104C338.666 427.088 338.534 427.08 338.374 427.08C338.03 427.08 337.738 427.152 337.498 427.296C337.266 427.44 337.09 427.64 336.97 427.896C336.858 428.152 336.802 428.444 336.802 428.772V432H335.29Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__tip_7"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Polygon 4_7",
  d: "M355.57 427L347.57 432L347.57 427L347.57 422L355.57 427Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__label-monitoring-controller-active",
  className: "label-monitoring-controller-active",
  filter: "url(#control-room_svg__filter7_d_7074_1985)"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__text_8"
}, /*#__PURE__*/React.createElement("rect", {
  x: 210.07,
  y: 415.5,
  width: 137,
  height: 23,
  rx: 1.5,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 210.07,
  y: 415.5,
  width: 137,
  height: 23,
  rx: 1.5,
  stroke: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Tooltip_8",
  d: "M218.891 432V423.54H220.247L223.355 430.536H222.983L226.091 423.54H227.435V432H226.031V425.724H226.463L223.619 432H222.695L219.851 425.724H220.295V432H218.891ZM231.937 432.12C231.313 432.12 230.773 431.992 230.317 431.736C229.861 431.48 229.505 431.116 229.249 430.644C229.001 430.172 228.877 429.612 228.877 428.964C228.877 428.316 229.001 427.76 229.249 427.296C229.505 426.824 229.861 426.46 230.317 426.204C230.773 425.948 231.313 425.82 231.937 425.82C232.561 425.82 233.101 425.948 233.557 426.204C234.021 426.46 234.377 426.824 234.625 427.296C234.881 427.76 235.009 428.316 235.009 428.964C235.009 429.612 234.881 430.172 234.625 430.644C234.377 431.116 234.021 431.48 233.557 431.736C233.101 431.992 232.561 432.12 231.937 432.12ZM231.937 430.968C232.409 430.968 232.785 430.804 233.065 430.476C233.345 430.14 233.485 429.636 233.485 428.964C233.485 428.292 233.345 427.792 233.065 427.464C232.785 427.136 232.409 426.972 231.937 426.972C231.465 426.972 231.089 427.136 230.809 427.464C230.529 427.792 230.389 428.292 230.389 428.964C230.389 429.636 230.529 430.14 230.809 430.476C231.089 430.804 231.465 430.968 231.937 430.968ZM236.302 432V427.452C236.302 427.204 236.294 426.952 236.278 426.696C236.262 426.44 236.238 426.188 236.206 425.94H237.658L237.778 427.14H237.634C237.826 426.716 238.11 426.392 238.486 426.168C238.862 425.936 239.298 425.82 239.794 425.82C240.506 425.82 241.042 426.02 241.402 426.42C241.762 426.82 241.942 427.444 241.942 428.292V432H240.442V428.364C240.442 427.876 240.346 427.528 240.154 427.32C239.97 427.104 239.69 426.996 239.314 426.996C238.85 426.996 238.482 427.14 238.21 427.428C237.938 427.716 237.802 428.1 237.802 428.58V432H236.302ZM243.533 432V425.94H245.033V432H243.533ZM243.449 424.8V423.336H245.117V424.8H243.449ZM249.254 432.12C248.534 432.12 247.99 431.932 247.622 431.556C247.254 431.18 247.07 430.616 247.07 429.864V427.068H245.906V425.94H247.07V424.392L248.57 424.008V425.94H250.19V427.068H248.57V429.768C248.57 430.184 248.65 430.476 248.81 430.644C248.97 430.812 249.19 430.896 249.47 430.896C249.622 430.896 249.75 430.884 249.854 430.86C249.966 430.836 250.074 430.804 250.178 430.764V431.952C250.042 432.008 249.89 432.048 249.722 432.072C249.562 432.104 249.406 432.12 249.254 432.12ZM253.886 432.12C253.262 432.12 252.722 431.992 252.266 431.736C251.81 431.48 251.454 431.116 251.198 430.644C250.95 430.172 250.826 429.612 250.826 428.964C250.826 428.316 250.95 427.76 251.198 427.296C251.454 426.824 251.81 426.46 252.266 426.204C252.722 425.948 253.262 425.82 253.886 425.82C254.51 425.82 255.05 425.948 255.506 426.204C255.97 426.46 256.326 426.824 256.574 427.296C256.83 427.76 256.958 428.316 256.958 428.964C256.958 429.612 256.83 430.172 256.574 430.644C256.326 431.116 255.97 431.48 255.506 431.736C255.05 431.992 254.51 432.12 253.886 432.12ZM253.886 430.968C254.358 430.968 254.734 430.804 255.014 430.476C255.294 430.14 255.434 429.636 255.434 428.964C255.434 428.292 255.294 427.792 255.014 427.464C254.734 427.136 254.358 426.972 253.886 426.972C253.414 426.972 253.038 427.136 252.758 427.464C252.478 427.792 252.338 428.292 252.338 428.964C252.338 429.636 252.478 430.14 252.758 430.476C253.038 430.804 253.414 430.968 253.886 430.968ZM258.24 432V427.488C258.24 427.232 258.232 426.972 258.216 426.708C258.208 426.444 258.188 426.188 258.156 425.94H259.608L259.776 427.596H259.536C259.616 427.196 259.748 426.864 259.932 426.6C260.124 426.336 260.356 426.14 260.628 426.012C260.9 425.884 261.196 425.82 261.516 425.82C261.66 425.82 261.776 425.828 261.864 425.844C261.952 425.852 262.04 425.872 262.128 425.904L262.116 427.224C261.964 427.16 261.832 427.12 261.72 427.104C261.616 427.088 261.484 427.08 261.324 427.08C260.98 427.08 260.688 427.152 260.448 427.296C260.216 427.44 260.04 427.64 259.92 427.896C259.808 428.152 259.752 428.444 259.752 428.772V432H258.24ZM262.962 432V425.94H264.462V432H262.962ZM262.878 424.8V423.336H264.546V424.8H262.878ZM266.091 432V427.452C266.091 427.204 266.083 426.952 266.067 426.696C266.051 426.44 266.027 426.188 265.995 425.94H267.447L267.567 427.14H267.423C267.615 426.716 267.899 426.392 268.275 426.168C268.651 425.936 269.087 425.82 269.583 425.82C270.295 425.82 270.831 426.02 271.191 426.42C271.551 426.82 271.731 427.444 271.731 428.292V432H270.231V428.364C270.231 427.876 270.135 427.528 269.943 427.32C269.759 427.104 269.479 426.996 269.103 426.996C268.639 426.996 268.271 427.14 267.999 427.428C267.727 427.716 267.591 428.1 267.591 428.58V432H266.091ZM276.13 434.688C275.57 434.688 275.062 434.628 274.606 434.508C274.158 434.388 273.758 434.204 273.406 433.956L273.73 432.876C273.962 433.028 274.202 433.152 274.45 433.248C274.698 433.344 274.954 433.416 275.218 433.464C275.482 433.512 275.75 433.536 276.022 433.536C276.582 433.536 276.998 433.396 277.27 433.116C277.55 432.844 277.69 432.452 277.69 431.94V430.488H277.81C277.682 430.904 277.422 431.236 277.03 431.484C276.646 431.732 276.202 431.856 275.698 431.856C275.154 431.856 274.678 431.736 274.27 431.496C273.87 431.248 273.558 430.896 273.334 430.44C273.11 429.984 272.998 429.448 272.998 428.832C272.998 428.216 273.11 427.684 273.334 427.236C273.558 426.78 273.87 426.432 274.27 426.192C274.678 425.944 275.154 425.82 275.698 425.82C276.21 425.82 276.654 425.944 277.03 426.192C277.414 426.432 277.67 426.76 277.798 427.176L277.69 427.104L277.81 425.94H279.262C279.23 426.188 279.206 426.44 279.19 426.696C279.174 426.952 279.166 427.204 279.166 427.452V431.76C279.166 432.712 278.906 433.436 278.386 433.932C277.874 434.436 277.122 434.688 276.13 434.688ZM276.106 430.704C276.586 430.704 276.966 430.544 277.246 430.224C277.534 429.896 277.678 429.432 277.678 428.832C277.678 428.232 277.534 427.772 277.246 427.452C276.966 427.132 276.586 426.972 276.106 426.972C275.618 426.972 275.23 427.132 274.942 427.452C274.654 427.772 274.51 428.232 274.51 428.832C274.51 429.432 274.654 429.896 274.942 430.224C275.23 430.544 275.618 430.704 276.106 430.704ZM288.136 432.12C287.256 432.12 286.5 431.944 285.868 431.592C285.244 431.232 284.764 430.728 284.428 430.08C284.092 429.424 283.924 428.652 283.924 427.764C283.924 426.876 284.092 426.108 284.428 425.46C284.764 424.812 285.244 424.312 285.868 423.96C286.5 423.6 287.256 423.42 288.136 423.42C288.728 423.42 289.26 423.504 289.732 423.672C290.212 423.84 290.624 424.088 290.968 424.416L290.464 425.64C290.088 425.336 289.724 425.12 289.372 424.992C289.028 424.856 288.632 424.788 288.184 424.788C287.328 424.788 286.672 425.048 286.216 425.568C285.768 426.08 285.544 426.812 285.544 427.764C285.544 428.716 285.768 429.452 286.216 429.972C286.672 430.492 287.328 430.752 288.184 430.752C288.632 430.752 289.028 430.688 289.372 430.56C289.724 430.424 290.088 430.2 290.464 429.888L290.968 431.112C290.624 431.432 290.212 431.68 289.732 431.856C289.26 432.032 288.728 432.12 288.136 432.12ZM294.609 432.12C293.985 432.12 293.445 431.992 292.989 431.736C292.533 431.48 292.177 431.116 291.921 430.644C291.673 430.172 291.549 429.612 291.549 428.964C291.549 428.316 291.673 427.76 291.921 427.296C292.177 426.824 292.533 426.46 292.989 426.204C293.445 425.948 293.985 425.82 294.609 425.82C295.233 425.82 295.773 425.948 296.229 426.204C296.693 426.46 297.049 426.824 297.297 427.296C297.553 427.76 297.681 428.316 297.681 428.964C297.681 429.612 297.553 430.172 297.297 430.644C297.049 431.116 296.693 431.48 296.229 431.736C295.773 431.992 295.233 432.12 294.609 432.12ZM294.609 430.968C295.081 430.968 295.457 430.804 295.737 430.476C296.017 430.14 296.157 429.636 296.157 428.964C296.157 428.292 296.017 427.792 295.737 427.464C295.457 427.136 295.081 426.972 294.609 426.972C294.137 426.972 293.761 427.136 293.481 427.464C293.201 427.792 293.061 428.292 293.061 428.964C293.061 429.636 293.201 430.14 293.481 430.476C293.761 430.804 294.137 430.968 294.609 430.968ZM298.974 432V427.452C298.974 427.204 298.966 426.952 298.95 426.696C298.934 426.44 298.91 426.188 298.878 425.94H300.33L300.45 427.14H300.306C300.498 426.716 300.782 426.392 301.158 426.168C301.534 425.936 301.97 425.82 302.466 425.82C303.178 425.82 303.714 426.02 304.074 426.42C304.434 426.82 304.614 427.444 304.614 428.292V432H303.114V428.364C303.114 427.876 303.018 427.528 302.826 427.32C302.642 427.104 302.362 426.996 301.986 426.996C301.522 426.996 301.154 427.14 300.882 427.428C300.61 427.716 300.474 428.1 300.474 428.58V432H298.974ZM308.797 432.12C308.077 432.12 307.533 431.932 307.165 431.556C306.797 431.18 306.613 430.616 306.613 429.864V427.068H305.449V425.94H306.613V424.392L308.113 424.008V425.94H309.733V427.068H308.113V429.768C308.113 430.184 308.193 430.476 308.353 430.644C308.513 430.812 308.733 430.896 309.013 430.896C309.165 430.896 309.293 430.884 309.397 430.86C309.509 430.836 309.617 430.804 309.721 430.764V431.952C309.585 432.008 309.433 432.048 309.265 432.072C309.105 432.104 308.949 432.12 308.797 432.12ZM310.74 432V427.488C310.74 427.232 310.732 426.972 310.716 426.708C310.708 426.444 310.688 426.188 310.656 425.94H312.108L312.276 427.596H312.036C312.116 427.196 312.248 426.864 312.432 426.6C312.624 426.336 312.856 426.14 313.128 426.012C313.4 425.884 313.696 425.82 314.016 425.82C314.16 425.82 314.276 425.828 314.364 425.844C314.452 425.852 314.54 425.872 314.628 425.904L314.616 427.224C314.464 427.16 314.332 427.12 314.22 427.104C314.116 427.088 313.984 427.08 313.824 427.08C313.48 427.08 313.188 427.152 312.948 427.296C312.716 427.44 312.54 427.64 312.42 427.896C312.308 428.152 312.252 428.444 312.252 428.772V432H310.74ZM318.105 432.12C317.481 432.12 316.941 431.992 316.485 431.736C316.029 431.48 315.673 431.116 315.417 430.644C315.169 430.172 315.045 429.612 315.045 428.964C315.045 428.316 315.169 427.76 315.417 427.296C315.673 426.824 316.029 426.46 316.485 426.204C316.941 425.948 317.481 425.82 318.105 425.82C318.729 425.82 319.269 425.948 319.725 426.204C320.189 426.46 320.545 426.824 320.793 427.296C321.049 427.76 321.177 428.316 321.177 428.964C321.177 429.612 321.049 430.172 320.793 430.644C320.545 431.116 320.189 431.48 319.725 431.736C319.269 431.992 318.729 432.12 318.105 432.12ZM318.105 430.968C318.577 430.968 318.953 430.804 319.233 430.476C319.513 430.14 319.653 429.636 319.653 428.964C319.653 428.292 319.513 427.792 319.233 427.464C318.953 427.136 318.577 426.972 318.105 426.972C317.633 426.972 317.257 427.136 316.977 427.464C316.697 427.792 316.557 428.292 316.557 428.964C316.557 429.636 316.697 430.14 316.977 430.476C317.257 430.804 317.633 430.968 318.105 430.968ZM322.47 432V423.168H323.97V432H322.47ZM325.599 432V423.168H327.099V432H325.599ZM331.656 432.12C330.64 432.12 329.844 431.84 329.268 431.28C328.692 430.72 328.404 429.952 328.404 428.976C328.404 428.344 328.528 427.792 328.776 427.32C329.024 426.848 329.368 426.48 329.808 426.216C330.256 425.952 330.776 425.82 331.368 425.82C331.952 425.82 332.44 425.944 332.832 426.192C333.224 426.44 333.52 426.788 333.72 427.236C333.928 427.684 334.032 428.208 334.032 428.808V429.204H329.616V428.412H332.964L332.76 428.58C332.76 428.02 332.64 427.592 332.4 427.296C332.168 427 331.828 426.852 331.38 426.852C330.884 426.852 330.5 427.028 330.228 427.38C329.964 427.732 329.832 428.224 329.832 428.856V429.012C329.832 429.668 329.992 430.16 330.312 430.488C330.64 430.808 331.1 430.968 331.692 430.968C332.036 430.968 332.356 430.924 332.652 430.836C332.956 430.74 333.244 430.588 333.516 430.38L333.96 431.388C333.672 431.62 333.328 431.8 332.928 431.928C332.528 432.056 332.104 432.12 331.656 432.12ZM335.29 432V427.488C335.29 427.232 335.282 426.972 335.266 426.708C335.258 426.444 335.238 426.188 335.206 425.94H336.658L336.826 427.596H336.586C336.666 427.196 336.798 426.864 336.982 426.6C337.174 426.336 337.406 426.14 337.678 426.012C337.95 425.884 338.246 425.82 338.566 425.82C338.71 425.82 338.826 425.828 338.914 425.844C339.002 425.852 339.09 425.872 339.178 425.904L339.166 427.224C339.014 427.16 338.882 427.12 338.77 427.104C338.666 427.088 338.534 427.08 338.374 427.08C338.03 427.08 337.738 427.152 337.498 427.296C337.266 427.44 337.09 427.64 336.97 427.896C336.858 428.152 336.802 428.444 336.802 428.772V432H335.29Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__tip_8"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Polygon 4_8",
  d: "M355.57 427L347.57 432L347.57 427L347.57 422L355.57 427Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__label-studio-room",
  className: "label-studio-room",
  filter: "url(#control-room_svg__filter8_d_7074_1985)"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Frame 4"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Polygon 4_9",
  d: "M476.57 495L481.57 503H476.57H471.57L476.57 495Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__text_9"
}, /*#__PURE__*/React.createElement("rect", {
  x: 433.57,
  y: 503,
  width: 86,
  height: 24,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Tooltip_9",
  d: "M445.484 520.12C444.804 520.12 444.176 520.036 443.6 519.868C443.032 519.692 442.544 519.452 442.136 519.148L442.616 517.936C442.888 518.128 443.172 518.292 443.468 518.428C443.764 518.556 444.08 518.656 444.416 518.728C444.752 518.792 445.108 518.824 445.484 518.824C446.116 518.824 446.572 518.72 446.852 518.512C447.132 518.304 447.272 518.032 447.272 517.696C447.272 517.4 447.176 517.176 446.984 517.024C446.792 516.864 446.448 516.732 445.952 516.628L444.596 516.352C443.82 516.192 443.24 515.924 442.856 515.548C442.472 515.172 442.28 514.668 442.28 514.036C442.28 513.508 442.42 513.048 442.7 512.656C442.98 512.264 443.372 511.96 443.876 511.744C444.38 511.528 444.968 511.42 445.64 511.42C446.24 511.42 446.796 511.508 447.308 511.684C447.82 511.852 448.248 512.096 448.592 512.416L448.112 513.568C447.768 513.28 447.392 513.068 446.984 512.932C446.576 512.788 446.12 512.716 445.616 512.716C445.048 512.716 444.604 512.828 444.284 513.052C443.972 513.268 443.816 513.568 443.816 513.952C443.816 514.248 443.912 514.484 444.104 514.66C444.304 514.836 444.64 514.972 445.112 515.068L446.456 515.332C447.256 515.492 447.848 515.756 448.232 516.124C448.616 516.484 448.808 516.972 448.808 517.588C448.808 518.092 448.672 518.536 448.4 518.92C448.128 519.296 447.744 519.592 447.248 519.808C446.752 520.016 446.164 520.12 445.484 520.12ZM452.679 520.12C451.959 520.12 451.415 519.932 451.047 519.556C450.679 519.18 450.495 518.616 450.495 517.864V515.068H449.331V513.94H450.495V512.392L451.995 512.008V513.94H453.615V515.068H451.995V517.768C451.995 518.184 452.075 518.476 452.235 518.644C452.395 518.812 452.615 518.896 452.895 518.896C453.047 518.896 453.175 518.884 453.279 518.86C453.391 518.836 453.499 518.804 453.603 518.764V519.952C453.467 520.008 453.315 520.048 453.147 520.072C452.987 520.104 452.831 520.12 452.679 520.12ZM456.818 520.12C456.074 520.12 455.518 519.916 455.15 519.508C454.782 519.1 454.598 518.476 454.598 517.636V513.94H456.098V517.624C456.098 518.072 456.19 518.404 456.374 518.62C456.558 518.828 456.838 518.932 457.214 518.932C457.638 518.932 457.982 518.788 458.246 518.5C458.518 518.212 458.654 517.832 458.654 517.36V513.94H460.154V520H458.69V518.764H458.858C458.682 519.196 458.414 519.532 458.054 519.772C457.702 520.004 457.29 520.12 456.818 520.12ZM464.135 520.12C463.607 520.12 463.139 519.996 462.731 519.748C462.331 519.492 462.019 519.128 461.795 518.656C461.571 518.184 461.459 517.62 461.459 516.964C461.459 516.308 461.571 515.748 461.795 515.284C462.019 514.812 462.331 514.452 462.731 514.204C463.139 513.948 463.607 513.82 464.135 513.82C464.639 513.82 465.083 513.944 465.467 514.192C465.859 514.432 466.119 514.76 466.247 515.176H466.091V511.168H467.591V520H466.115V518.716H466.259C466.131 519.148 465.871 519.492 465.479 519.748C465.095 519.996 464.647 520.12 464.135 520.12ZM464.555 518.968C465.027 518.968 465.407 518.804 465.695 518.476C465.983 518.14 466.127 517.636 466.127 516.964C466.127 516.292 465.983 515.792 465.695 515.464C465.407 515.136 465.027 514.972 464.555 514.972C464.083 514.972 463.699 515.136 463.403 515.464C463.115 515.792 462.971 516.292 462.971 516.964C462.971 517.636 463.115 518.14 463.403 518.476C463.699 518.804 464.083 518.968 464.555 518.968ZM469.224 520V513.94H470.724V520H469.224ZM469.14 512.8V511.336H470.808V512.8H469.14ZM475.089 520.12C474.465 520.12 473.925 519.992 473.469 519.736C473.013 519.48 472.657 519.116 472.401 518.644C472.153 518.172 472.029 517.612 472.029 516.964C472.029 516.316 472.153 515.76 472.401 515.296C472.657 514.824 473.013 514.46 473.469 514.204C473.925 513.948 474.465 513.82 475.089 513.82C475.713 513.82 476.253 513.948 476.709 514.204C477.173 514.46 477.529 514.824 477.777 515.296C478.033 515.76 478.161 516.316 478.161 516.964C478.161 517.612 478.033 518.172 477.777 518.644C477.529 519.116 477.173 519.48 476.709 519.736C476.253 519.992 475.713 520.12 475.089 520.12ZM475.089 518.968C475.561 518.968 475.937 518.804 476.217 518.476C476.497 518.14 476.637 517.636 476.637 516.964C476.637 516.292 476.497 515.792 476.217 515.464C475.937 515.136 475.561 514.972 475.089 514.972C474.617 514.972 474.241 515.136 473.961 515.464C473.681 515.792 473.541 516.292 473.541 516.964C473.541 517.636 473.681 518.14 473.961 518.476C474.241 518.804 474.617 518.968 475.089 518.968ZM482.736 520V515.488C482.736 515.232 482.728 514.972 482.712 514.708C482.704 514.444 482.684 514.188 482.652 513.94H484.104L484.272 515.596H484.032C484.112 515.196 484.244 514.864 484.428 514.6C484.62 514.336 484.852 514.14 485.124 514.012C485.396 513.884 485.692 513.82 486.012 513.82C486.156 513.82 486.272 513.828 486.36 513.844C486.448 513.852 486.536 513.872 486.624 513.904L486.612 515.224C486.46 515.16 486.328 515.12 486.216 515.104C486.112 515.088 485.98 515.08 485.82 515.08C485.476 515.08 485.184 515.152 484.944 515.296C484.712 515.44 484.536 515.64 484.416 515.896C484.304 516.152 484.248 516.444 484.248 516.772V520H482.736ZM490.101 520.12C489.477 520.12 488.937 519.992 488.481 519.736C488.025 519.48 487.669 519.116 487.413 518.644C487.165 518.172 487.041 517.612 487.041 516.964C487.041 516.316 487.165 515.76 487.413 515.296C487.669 514.824 488.025 514.46 488.481 514.204C488.937 513.948 489.477 513.82 490.101 513.82C490.725 513.82 491.265 513.948 491.721 514.204C492.185 514.46 492.541 514.824 492.789 515.296C493.045 515.76 493.173 516.316 493.173 516.964C493.173 517.612 493.045 518.172 492.789 518.644C492.541 519.116 492.185 519.48 491.721 519.736C491.265 519.992 490.725 520.12 490.101 520.12ZM490.101 518.968C490.573 518.968 490.949 518.804 491.229 518.476C491.509 518.14 491.649 517.636 491.649 516.964C491.649 516.292 491.509 515.792 491.229 515.464C490.949 515.136 490.573 514.972 490.101 514.972C489.629 514.972 489.253 515.136 488.973 515.464C488.693 515.792 488.553 516.292 488.553 516.964C488.553 517.636 488.693 518.14 488.973 518.476C489.253 518.804 489.629 518.968 490.101 518.968ZM497.202 520.12C496.578 520.12 496.038 519.992 495.582 519.736C495.126 519.48 494.77 519.116 494.514 518.644C494.266 518.172 494.142 517.612 494.142 516.964C494.142 516.316 494.266 515.76 494.514 515.296C494.77 514.824 495.126 514.46 495.582 514.204C496.038 513.948 496.578 513.82 497.202 513.82C497.826 513.82 498.366 513.948 498.822 514.204C499.286 514.46 499.642 514.824 499.89 515.296C500.146 515.76 500.274 516.316 500.274 516.964C500.274 517.612 500.146 518.172 499.89 518.644C499.642 519.116 499.286 519.48 498.822 519.736C498.366 519.992 497.826 520.12 497.202 520.12ZM497.202 518.968C497.674 518.968 498.05 518.804 498.33 518.476C498.61 518.14 498.75 517.636 498.75 516.964C498.75 516.292 498.61 515.792 498.33 515.464C498.05 515.136 497.674 514.972 497.202 514.972C496.73 514.972 496.354 515.136 496.074 515.464C495.794 515.792 495.654 516.292 495.654 516.964C495.654 517.636 495.794 518.14 496.074 518.476C496.354 518.804 496.73 518.968 497.202 518.968ZM501.568 520V515.452C501.568 515.204 501.56 514.952 501.544 514.696C501.528 514.44 501.504 514.188 501.472 513.94H502.924L503.044 515.14H502.9C503.068 514.724 503.324 514.4 503.668 514.168C504.02 513.936 504.436 513.82 504.916 513.82C505.396 513.82 505.792 513.936 506.104 514.168C506.424 514.392 506.648 514.744 506.776 515.224H506.584C506.752 514.792 507.028 514.452 507.412 514.204C507.796 513.948 508.236 513.82 508.732 513.82C509.412 513.82 509.92 514.02 510.256 514.42C510.592 514.82 510.76 515.444 510.76 516.292V520H509.26V516.352C509.26 515.872 509.18 515.528 509.02 515.32C508.86 515.104 508.604 514.996 508.252 514.996C507.836 514.996 507.508 515.144 507.268 515.44C507.028 515.728 506.908 516.12 506.908 516.616V520H505.408V516.352C505.408 515.872 505.328 515.528 505.168 515.32C505.008 515.104 504.752 514.996 504.4 514.996C503.984 514.996 503.656 515.144 503.416 515.44C503.184 515.728 503.068 516.12 503.068 516.616V520H501.568Z",
  fill: "#141941"
}))), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__label-studio-room-active",
  className: "label-studio-room-active",
  filter: "url(#control-room_svg__filter9_d_7074_1985)"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__Frame 4_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Polygon 4_10",
  d: "M476.57 495L481.57 503H476.57H471.57L476.57 495Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "control-room_svg__text_10"
}, /*#__PURE__*/React.createElement("rect", {
  x: 434.07,
  y: 503.5,
  width: 85,
  height: 23,
  rx: 1.5,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 434.07,
  y: 503.5,
  width: 85,
  height: 23,
  rx: 1.5,
  stroke: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  id: "control-room_svg__Tooltip_10",
  d: "M445.484 520.12C444.804 520.12 444.176 520.036 443.6 519.868C443.032 519.692 442.544 519.452 442.136 519.148L442.616 517.936C442.888 518.128 443.172 518.292 443.468 518.428C443.764 518.556 444.08 518.656 444.416 518.728C444.752 518.792 445.108 518.824 445.484 518.824C446.116 518.824 446.572 518.72 446.852 518.512C447.132 518.304 447.272 518.032 447.272 517.696C447.272 517.4 447.176 517.176 446.984 517.024C446.792 516.864 446.448 516.732 445.952 516.628L444.596 516.352C443.82 516.192 443.24 515.924 442.856 515.548C442.472 515.172 442.28 514.668 442.28 514.036C442.28 513.508 442.42 513.048 442.7 512.656C442.98 512.264 443.372 511.96 443.876 511.744C444.38 511.528 444.968 511.42 445.64 511.42C446.24 511.42 446.796 511.508 447.308 511.684C447.82 511.852 448.248 512.096 448.592 512.416L448.112 513.568C447.768 513.28 447.392 513.068 446.984 512.932C446.576 512.788 446.12 512.716 445.616 512.716C445.048 512.716 444.604 512.828 444.284 513.052C443.972 513.268 443.816 513.568 443.816 513.952C443.816 514.248 443.912 514.484 444.104 514.66C444.304 514.836 444.64 514.972 445.112 515.068L446.456 515.332C447.256 515.492 447.848 515.756 448.232 516.124C448.616 516.484 448.808 516.972 448.808 517.588C448.808 518.092 448.672 518.536 448.4 518.92C448.128 519.296 447.744 519.592 447.248 519.808C446.752 520.016 446.164 520.12 445.484 520.12ZM452.679 520.12C451.959 520.12 451.415 519.932 451.047 519.556C450.679 519.18 450.495 518.616 450.495 517.864V515.068H449.331V513.94H450.495V512.392L451.995 512.008V513.94H453.615V515.068H451.995V517.768C451.995 518.184 452.075 518.476 452.235 518.644C452.395 518.812 452.615 518.896 452.895 518.896C453.047 518.896 453.175 518.884 453.279 518.86C453.391 518.836 453.499 518.804 453.603 518.764V519.952C453.467 520.008 453.315 520.048 453.147 520.072C452.987 520.104 452.831 520.12 452.679 520.12ZM456.818 520.12C456.074 520.12 455.518 519.916 455.15 519.508C454.782 519.1 454.598 518.476 454.598 517.636V513.94H456.098V517.624C456.098 518.072 456.19 518.404 456.374 518.62C456.558 518.828 456.838 518.932 457.214 518.932C457.638 518.932 457.982 518.788 458.246 518.5C458.518 518.212 458.654 517.832 458.654 517.36V513.94H460.154V520H458.69V518.764H458.858C458.682 519.196 458.414 519.532 458.054 519.772C457.702 520.004 457.29 520.12 456.818 520.12ZM464.135 520.12C463.607 520.12 463.139 519.996 462.731 519.748C462.331 519.492 462.019 519.128 461.795 518.656C461.571 518.184 461.459 517.62 461.459 516.964C461.459 516.308 461.571 515.748 461.795 515.284C462.019 514.812 462.331 514.452 462.731 514.204C463.139 513.948 463.607 513.82 464.135 513.82C464.639 513.82 465.083 513.944 465.467 514.192C465.859 514.432 466.119 514.76 466.247 515.176H466.091V511.168H467.591V520H466.115V518.716H466.259C466.131 519.148 465.871 519.492 465.479 519.748C465.095 519.996 464.647 520.12 464.135 520.12ZM464.555 518.968C465.027 518.968 465.407 518.804 465.695 518.476C465.983 518.14 466.127 517.636 466.127 516.964C466.127 516.292 465.983 515.792 465.695 515.464C465.407 515.136 465.027 514.972 464.555 514.972C464.083 514.972 463.699 515.136 463.403 515.464C463.115 515.792 462.971 516.292 462.971 516.964C462.971 517.636 463.115 518.14 463.403 518.476C463.699 518.804 464.083 518.968 464.555 518.968ZM469.224 520V513.94H470.724V520H469.224ZM469.14 512.8V511.336H470.808V512.8H469.14ZM475.089 520.12C474.465 520.12 473.925 519.992 473.469 519.736C473.013 519.48 472.657 519.116 472.401 518.644C472.153 518.172 472.029 517.612 472.029 516.964C472.029 516.316 472.153 515.76 472.401 515.296C472.657 514.824 473.013 514.46 473.469 514.204C473.925 513.948 474.465 513.82 475.089 513.82C475.713 513.82 476.253 513.948 476.709 514.204C477.173 514.46 477.529 514.824 477.777 515.296C478.033 515.76 478.161 516.316 478.161 516.964C478.161 517.612 478.033 518.172 477.777 518.644C477.529 519.116 477.173 519.48 476.709 519.736C476.253 519.992 475.713 520.12 475.089 520.12ZM475.089 518.968C475.561 518.968 475.937 518.804 476.217 518.476C476.497 518.14 476.637 517.636 476.637 516.964C476.637 516.292 476.497 515.792 476.217 515.464C475.937 515.136 475.561 514.972 475.089 514.972C474.617 514.972 474.241 515.136 473.961 515.464C473.681 515.792 473.541 516.292 473.541 516.964C473.541 517.636 473.681 518.14 473.961 518.476C474.241 518.804 474.617 518.968 475.089 518.968ZM482.736 520V515.488C482.736 515.232 482.728 514.972 482.712 514.708C482.704 514.444 482.684 514.188 482.652 513.94H484.104L484.272 515.596H484.032C484.112 515.196 484.244 514.864 484.428 514.6C484.62 514.336 484.852 514.14 485.124 514.012C485.396 513.884 485.692 513.82 486.012 513.82C486.156 513.82 486.272 513.828 486.36 513.844C486.448 513.852 486.536 513.872 486.624 513.904L486.612 515.224C486.46 515.16 486.328 515.12 486.216 515.104C486.112 515.088 485.98 515.08 485.82 515.08C485.476 515.08 485.184 515.152 484.944 515.296C484.712 515.44 484.536 515.64 484.416 515.896C484.304 516.152 484.248 516.444 484.248 516.772V520H482.736ZM490.101 520.12C489.477 520.12 488.937 519.992 488.481 519.736C488.025 519.48 487.669 519.116 487.413 518.644C487.165 518.172 487.041 517.612 487.041 516.964C487.041 516.316 487.165 515.76 487.413 515.296C487.669 514.824 488.025 514.46 488.481 514.204C488.937 513.948 489.477 513.82 490.101 513.82C490.725 513.82 491.265 513.948 491.721 514.204C492.185 514.46 492.541 514.824 492.789 515.296C493.045 515.76 493.173 516.316 493.173 516.964C493.173 517.612 493.045 518.172 492.789 518.644C492.541 519.116 492.185 519.48 491.721 519.736C491.265 519.992 490.725 520.12 490.101 520.12ZM490.101 518.968C490.573 518.968 490.949 518.804 491.229 518.476C491.509 518.14 491.649 517.636 491.649 516.964C491.649 516.292 491.509 515.792 491.229 515.464C490.949 515.136 490.573 514.972 490.101 514.972C489.629 514.972 489.253 515.136 488.973 515.464C488.693 515.792 488.553 516.292 488.553 516.964C488.553 517.636 488.693 518.14 488.973 518.476C489.253 518.804 489.629 518.968 490.101 518.968ZM497.202 520.12C496.578 520.12 496.038 519.992 495.582 519.736C495.126 519.48 494.77 519.116 494.514 518.644C494.266 518.172 494.142 517.612 494.142 516.964C494.142 516.316 494.266 515.76 494.514 515.296C494.77 514.824 495.126 514.46 495.582 514.204C496.038 513.948 496.578 513.82 497.202 513.82C497.826 513.82 498.366 513.948 498.822 514.204C499.286 514.46 499.642 514.824 499.89 515.296C500.146 515.76 500.274 516.316 500.274 516.964C500.274 517.612 500.146 518.172 499.89 518.644C499.642 519.116 499.286 519.48 498.822 519.736C498.366 519.992 497.826 520.12 497.202 520.12ZM497.202 518.968C497.674 518.968 498.05 518.804 498.33 518.476C498.61 518.14 498.75 517.636 498.75 516.964C498.75 516.292 498.61 515.792 498.33 515.464C498.05 515.136 497.674 514.972 497.202 514.972C496.73 514.972 496.354 515.136 496.074 515.464C495.794 515.792 495.654 516.292 495.654 516.964C495.654 517.636 495.794 518.14 496.074 518.476C496.354 518.804 496.73 518.968 497.202 518.968ZM501.568 520V515.452C501.568 515.204 501.56 514.952 501.544 514.696C501.528 514.44 501.504 514.188 501.472 513.94H502.924L503.044 515.14H502.9C503.068 514.724 503.324 514.4 503.668 514.168C504.02 513.936 504.436 513.82 504.916 513.82C505.396 513.82 505.792 513.936 506.104 514.168C506.424 514.392 506.648 514.744 506.776 515.224H506.584C506.752 514.792 507.028 514.452 507.412 514.204C507.796 513.948 508.236 513.82 508.732 513.82C509.412 513.82 509.92 514.02 510.256 514.42C510.592 514.82 510.76 515.444 510.76 516.292V520H509.26V516.352C509.26 515.872 509.18 515.528 509.02 515.32C508.86 515.104 508.604 514.996 508.252 514.996C507.836 514.996 507.508 515.144 507.268 515.44C507.028 515.728 506.908 516.12 506.908 516.616V520H505.408V516.352C505.408 515.872 505.328 515.528 505.168 515.32C505.008 515.104 504.752 514.996 504.4 514.996C503.984 514.996 503.656 515.144 503.416 515.44C503.184 515.728 503.068 516.12 503.068 516.616V520H501.568Z",
  fill: "#141941"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "control-room_svg__pattern0_7074_1985",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#control-room_svg__image0_7074_1985",
  transform: "scale(0.00326797 0.00332226)"
})), /*#__PURE__*/React.createElement("filter", {
  id: "control-room_svg__filter0_d_7074_1985",
  x: 191.141,
  y: 312.5,
  width: 133,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7074_1985"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7074_1985",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "control-room_svg__filter1_d_7074_1985",
  x: 191.141,
  y: 312.5,
  width: 133,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7074_1985"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7074_1985",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "control-room_svg__filter2_d_7074_1985",
  x: 328.57,
  y: 57.5,
  width: 116,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7074_1985"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7074_1985",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "control-room_svg__filter3_d_7074_1985",
  x: 328.57,
  y: 57.5,
  width: 116,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7074_1985"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7074_1985",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "control-room_svg__filter4_d_7074_1985",
  x: 399.141,
  y: 259,
  width: 109,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7074_1985"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7074_1985",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "control-room_svg__filter5_d_7074_1985",
  x: 399.141,
  y: 259,
  width: 109,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7074_1985"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7074_1985",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "control-room_svg__filter6_d_7074_1985",
  x: 199.57,
  y: 410,
  width: 166,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7074_1985"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7074_1985",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "control-room_svg__filter7_d_7074_1985",
  x: 199.57,
  y: 410,
  width: 166,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7074_1985"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7074_1985",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "control-room_svg__filter8_d_7074_1985",
  x: 423.57,
  y: 490,
  width: 106,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7074_1985"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7074_1985",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "control-room_svg__filter9_d_7074_1985",
  x: 423.57,
  y: 490,
  width: 106,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7074_1985"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7074_1985",
  result: "shape"
})), /*#__PURE__*/React.createElement("image", {
  id: "control-room_svg__image0_7074_1985",
  "data-name": "_Image1.png",
  width: 306,
  height: 301,
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,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"
}))));
export default SvgControlRoom;